(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1737,2426],{

/***/ 55120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27812);
/* harmony import */ var _BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89744);
/* harmony import */ var _BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _Redux_actionTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var BreadCrumb = function BreadCrumb(_ref) {
  var list = _ref.list,
      title = _ref.title,
      replacePageTitle = _ref.replacePageTitle;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .componentResize */ .Y4)();
  var itemsBefore = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.items_display_before_collapser_mbl */ .Z.BreadCrumbLabels.items_display_before_collapser_mbl;
  var itemsAfter = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.items_display_after_collapser_mbl */ .Z.BreadCrumbLabels.items_display_after_collapser_mbl;
  var breadcrumbList = [];
  var currentPage = {};
  var lastItem;
  var router = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var dispatch = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useDispatch)();
  var isMiniApp = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getCookieValue */ .Do)("miniApp") === "true";

  var handleClick = function handleClick(url) {
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
    dispatch({
      type: _Redux_actionTypes__WEBPACK_IMPORTED_MODULE_4__/* .BREADCRUMB_SELECT */ .T1,
      payload: true
    });

    if ((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .internalUrl */ .az)(url).url === "/") {
      if (true) {
        var origin = window.location.origin; // .then(()=>{

        window.location.assign(origin);
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)(); // window.lo
        // })
      }
    } else {
      router.push((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .internalUrl */ .az)(url).url).then(function () {
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
      });
    }
  };

  function handleBreadCrumbMobile(breadcrumbList) {
    if (isMobile && breadcrumbList.length > _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.max_display_items_mbl */ .Z.BreadCrumbLabels.max_display_items_mbl) {
      breadcrumbList.splice.apply(breadcrumbList, [0, breadcrumbList.length].concat((0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breadcrumbList.slice(0, itemsBefore)), [{
        title: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile */ .Z.BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile
      }], (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breadcrumbList.slice(breadcrumbList.length - itemsAfter, breadcrumbList.length))));
    }

    lastItem = breadcrumbList.length - 1;
    return breadcrumbList;
  }

  if (list) {
    var totalKeys = Object.keys(list).length; // Mapping current page object into currentPage

    if (totalKeys > 0) {
      currentPage = Object.values(list)[totalKeys - 1];
    }

    Object.entries(list).forEach(function (value) {
      var replacedTitle = title && value[1].url === currentPage.url ? title : null;
      var replacePageTitleBool = replacePageTitle && value[1].url === currentPage.url ? true : false;
      var matchedRoute = {
        url: value[1].url,
        title: value[0],
        replacedTitle: replacedTitle,
        replacePageTitle: replacePageTitleBool
      };
      breadcrumbList.push(matchedRoute);
    });
    lastItem = breadcrumbList.length - 1;
  }

  return isMiniApp || breadcrumbList.length === 0 || breadcrumbList.length === 1 && breadcrumbList[0].url == "/" ? "" : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Nav, {
    className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-wrapper"])),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ol", {
      className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-list"])),
      children: handleBreadCrumbMobile(breadcrumbList).map(function (bcrumb, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
          className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-item"])),
          id: "".concat(index, "_").concat(bcrumb.title),
          children: lastItem !== index && bcrumb.url ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            id: "".concat(index, "_").concat(bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title),
            onClick: function onClick() {
              return handleClick(bcrumb.url);
            },
            children: ["                    ", bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title]
          }) : bcrumb.replacePageTitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            id: "".concat(index, "_").concat(bcrumb.replacedTitle),
            children: bcrumb.replacedTitle
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            id: "".concat(index, "_").concat(bcrumb.title),
            children: bcrumb.title
          })
        }, index);
      })
    })
  });
};

BreadCrumb.defaultProps = {
  list: null,
  title: "",
  replacePageTitle: false
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 33757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_ButtonComponent; }
});

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./config/colors.js
var colors = __webpack_require__(93957);
// EXTERNAL MODULE: ./config/fonts.js
var fonts = __webpack_require__(78198);
;// CONCATENATED MODULE: ./components/atoms/button/ButtonComponentStyle.js


var ButtonComponentStyle = [".buttonText.jsx-1048313388{font-family:".concat(fonts/* default.medium */.Z.medium, ";font-weight:500;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;text-align:center;color:").concat(colors/* default.Black23 */.Z.Black23, ";cursor:pointer;}"), ".transparant-btn.jsx-1048313388{background:none;border:none;outline:none;}", ".image-box.jsx-1048313388{padding-right:8px;}", ".button-hide.jsx-1048313388{display:none;}", ".btnTextSizingMobile.jsx-1048313388{font-size:14px;}", ".out-of-stock-disabled-btn.jsx-1048313388{color:".concat(colors/* default.Grey20 */.Z.Grey20, ";!important;}")];
ButtonComponentStyle.__hash = "1048313388";
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/button/ButtonComponent.js







var ButtonComponent = function ButtonComponent(props) {
  /*
   The following function "buttonClicked" handles the event Button click.
   Implementation yet to be added
    */
  var buttonClicked = function buttonClicked(e) {
    if (props.onBtnClick) {
      e.preventDefault();
      props.onBtnClick(e);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      id: props.id,
      uniquebuttonid: props === null || props === void 0 ? void 0 : props.uniqueButtonId,
      onClick: function onClick(e) {
        buttonClicked(e);
      },
      disabled: props === null || props === void 0 ? void 0 : props.disabledFlag,
      className: "jsx-".concat(ButtonComponentStyle.__hash) + " " + ((props !== null && props !== void 0 && props.isHidden ? "button-hide" : "".concat(props === null || props === void 0 ? void 0 : props.className)) || ""),
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        id: props === null || props === void 0 ? void 0 : props.uniqueButtonId,
        className: "jsx-".concat(ButtonComponentStyle.__hash) + " " + "".concat(props.textClassName, " ").concat(props.background, " ").concat(props === null || props === void 0 ? void 0 : props.disabledBtnClassName, " buttonText"),
        children: props.selected ? props.selectedText : props.text
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: ButtonComponentStyle.__hash,
      children: ButtonComponentStyle
    })]
  });
};

ButtonComponent.defaultProps = {
  pageRequired: "/",
  className: "transparant-btn"
};
/* harmony default export */ var button_ButtonComponent = (ButtonComponent);

/***/ }),

/***/ 87419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ imageWithText_ImageWithText; }
});

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./config/colors.js
var colors = __webpack_require__(93957);
;// CONCATENATED MODULE: ./components/atoms/imageWithText/imageWithTextStyle.js

var imageWithTextStyle = [".card.jsx-3853968429{padding:1rem;margin:0.7rem 1rem;}", ".text-center.jsx-3853968429{text-align:center;}", ".image-title.jsx-3853968429{height:2.75rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".title.jsx-3853968429{font-size:1rem;line-height:1.375rem;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:#08081B;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", ".image.jsx-3853968429{display:block;width:11.25rem;height:11.25rem;margin:auto;object-fit:contain;}", ".custom-image.jsx-3853968429{display:block margin:0 auto;object-fit:contain;background-size:cover;}", ".custom-image-section.jsx-3853968429{background-size:contain;background-repeat:no-repeat;background-position:center;margin:0 auto;}", ".color-label.jsx-3853968429{color:".concat(colors/* default.Grey60 */.Z.Grey60, ";font-family:Roboto Regular;font-size:0.875rem;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;text-align:center;}")];
imageWithTextStyle.__hash = "3853968429";
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/imageWithText/ImageWithText.js







var ImageWithText = function ImageWithText(props) {
  var labelText = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var _labelText$current;

    if ((labelText === null || labelText === void 0 ? void 0 : (_labelText$current = labelText.current) === null || _labelText$current === void 0 ? void 0 : _labelText$current.scrollHeight) !== null) {
      while ((labelText === null || labelText === void 0 ? void 0 : (_labelText$current2 = labelText.current) === null || _labelText$current2 === void 0 ? void 0 : _labelText$current2.scrollHeight) > (labelText === null || labelText === void 0 ? void 0 : (_labelText$current3 = labelText.current) === null || _labelText$current3 === void 0 ? void 0 : _labelText$current3.offsetHeight)) {
        var _labelText$current2, _labelText$current3;

        labelText.current.innerText = labelText.current.innerText.replace(/\W*\s(\S)*$/, '...');
      }
    }
  }, [labelText]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "text-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        width: props.width,
        height: props.height,
        backgroundImage: "url(".concat(props.img_path, ")")
      },
      className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "mw-100 custom-image-section"
    }), props.children ? props.children : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "image-title mt-s",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        ref: labelText,
        dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(props.text),
        uniqueName: props.uniqueName,
        className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "title mt-auto ".concat(props.imageLabelStyle)
      })
    }), props !== null && props !== void 0 && props.color ? /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "color-label",
      children: props === null || props === void 0 ? void 0 : props.color
    }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: imageWithTextStyle.__hash,
      children: imageWithTextStyle
    })]
  });
};

/* harmony default export */ var imageWithText_ImageWithText = (ImageWithText);

/***/ }),

/***/ 96105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var Timer = function Timer(_ref) {
  var onTimerComplete = _ref.onTimerComplete,
      dateTime = _ref.dateTime,
      preText = _ref.preText,
      className = _ref.className;

  var handleChange = function handleChange(event) {
    onTimerComplete(event);
  };

  var renderer = function renderer(props) {
    if (props.completed) {
      handleChange(false);
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    } else {
      handleChange(true);
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: className,
        children: [!!preText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: preText
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: props.formatted.days
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "d "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: props.formatted.hours
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "h "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: props.formatted.minutes
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "m "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: props.formatted.seconds
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "s"
        })]
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Countdown, {
    date: dateTime,
    renderer: renderer,
    zeroPadTime: 1
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Timer);

/***/ }),

/***/ 73742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
// EXTERNAL MODULE: ./Redux/actions/dealDetailsAction.js
var dealDetailsAction = __webpack_require__(84296);
// EXTERNAL MODULE: ./Redux/actions/getHelpAction.js
var getHelpAction = __webpack_require__(87524);
// EXTERNAL MODULE: ./Redux/actions/commonAction.js
var commonAction = __webpack_require__(88093);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/atoms/pageHeading/PageHeading.jsx
var PageHeading = __webpack_require__(19456);
// EXTERNAL MODULE: ./components/atoms/breadCrumb/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(55120);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./services/breadcrumbService.js
var breadcrumbService = __webpack_require__(74425);
// EXTERNAL MODULE: ./components/molecules/dealDetailsHeader/DealDetailsHeader.module.scss
var DealDetailsHeader_module = __webpack_require__(83984);
var DealDetailsHeader_module_default = /*#__PURE__*/__webpack_require__.n(DealDetailsHeader_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/dealDetailsHeader/DealDetailsHeader.jsx









var DealDetailsHeader = function DealDetailsHeader(_ref) {
  var productName = _ref.productName;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (DealDetailsHeader_module_default())["product-details-header-container"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb["default"], {
      list: (0,helperServices/* formatBreadCrumb */.x9)((0,breadcrumbService/* breadcrumbGenerator */.G)().dealdetails),
      title: productName,
      replacePageTitle: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
          text: productName,
          variant: "product-details-heading",
          className: "my-l"
        })
      })
    })]
  });
};

DealDetailsHeader.defaultProps = {
  productName: ""
};
/* harmony default export */ var dealDetailsHeader_DealDetailsHeader = (DealDetailsHeader);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./context/VasContext.js
var VasContext = __webpack_require__(69633);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBar.jsx
var SnackBar = __webpack_require__(52932);
// EXTERNAL MODULE: ./components/molecules/affordabilityContainer/AffordabilityContainer.jsx
var AffordabilityContainer = __webpack_require__(97984);
// EXTERNAL MODULE: ./components/molecules/unaffordableAlertModal/UnaffordableAlertModal.module.scss
var UnaffordableAlertModal_module = __webpack_require__(8247);
var UnaffordableAlertModal_module_default = /*#__PURE__*/__webpack_require__.n(UnaffordableAlertModal_module);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/atoms/iconsComponent/IconsComponent.jsx
var IconsComponent = __webpack_require__(85436);
;// CONCATENATED MODULE: ./components/molecules/unaffordableAlertModal/UnaffordableAlertModal.jsx








var UnaffordableAlertModal = function UnaffordableAlertModal(_ref) {
  var displayData = _ref.displayData,
      showModal = _ref.showModal,
      creditFilters = _ref.creditFilters,
      toggleModal = _ref.toggleModal,
      onClickHandlerPrimary = _ref.onClickHandlerPrimary;

  var scrollToTop = function scrollToTop() {
    // scrolling the window up when closing the modal
    if (showModal) window.scrollTo(0, 0);
  };

  var toggleUpgradeModal = function toggleUpgradeModal() {
    scrollToTop();
    toggleModal();
  };

  var primaryButtonClick = function primaryButtonClick(url) {
    scrollToTop();
    onClickHandlerPrimary(url);
  };

  return showModal && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal, {
    show: showModal,
    dialogClassName: "".concat((UnaffordableAlertModal_module_default())["upgrade-modal1"]),
    onHide: toggleUpgradeModal,
    centered: true,
    backdrop: "static",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal.Header, {
      className: (UnaffordableAlertModal_module_default())["modal-header"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        onClick: toggleUpgradeModal,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconsComponent/* default */.Z, {
          type: "closeBlack"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal.Body, {
      className: (UnaffordableAlertModal_module_default())["modal-body"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (UnaffordableAlertModal_module_default()).upgradeComponent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (UnaffordableAlertModal_module_default())["otp-tick-img"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-sucess.svg"),
            width: 40,
            height: 40
          })
        }), (displayData === null || displayData === void 0 ? void 0 : displayData.resultTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (UnaffordableAlertModal_module_default()).title,
          children: displayData === null || displayData === void 0 ? void 0 : displayData.resultTitle
        }), (displayData === null || displayData === void 0 ? void 0 : displayData.resultHTML) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((UnaffordableAlertModal_module_default()).description),
          dangerouslySetInnerHTML: {
            __html: displayData === null || displayData === void 0 ? void 0 : displayData.resultHTML
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
          variant: displayData === null || displayData === void 0 ? void 0 : displayData.primaryButtonStyle,
          className: "".concat((UnaffordableAlertModal_module_default())[displayData === null || displayData === void 0 ? void 0 : displayData.primaryButtonClass]),
          handleClick: function handleClick() {
            return primaryButtonClick(displayData === null || displayData === void 0 ? void 0 : displayData.primaryCTAURL);
          },
          children: displayData === null || displayData === void 0 ? void 0 : displayData.primaryCTAText
        })]
      })
    })]
  });
};

/* harmony default export */ var unaffordableAlertModal_UnaffordableAlertModal = (UnaffordableAlertModal);
// EXTERNAL MODULE: ./components/molecules/upgradeModal/UpgradeModal.jsx
var UpgradeModal = __webpack_require__(27575);
// EXTERNAL MODULE: ./components/organisms/dealSpecifications/ApplicationTypeSelector.module.scss
var ApplicationTypeSelector_module = __webpack_require__(37293);
var ApplicationTypeSelector_module_default = /*#__PURE__*/__webpack_require__.n(ApplicationTypeSelector_module);
;// CONCATENATED MODULE: ./components/organisms/dealSpecifications/ApplicationTypeSelector.jsx







var ApplicationTypeSelector = function ApplicationTypeSelector(props) {
  var _props$buyOptions;

  var selected = props.buyOptionSelected.title;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "d-lg-block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((ApplicationTypeSelector_module_default())["pill-btn-all"]),
        children: (_props$buyOptions = props.buyOptions) === null || _props$buyOptions === void 0 ? void 0 : _props$buyOptions.filter(function (option) {
          return option.title !== 'add_contract';
        }).map(function (option, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return props.handleSelectedBuyOption(option);
            },
            className: "d-flex align-items-center \n                ".concat(selected === option.title ? "".concat((ApplicationTypeSelector_module_default())["btn-gradient"]) : "".concat((ApplicationTypeSelector_module_default())["default-gradient"]), "\n              "),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat((ApplicationTypeSelector_module_default())["pill-btn"]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                type: "radio",
                name: "contract-type",
                checked: selected === option.title,
                id: "contract-type-".concat(index),
                className: "mr-s",
                readOnly: true
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                htmlFor: "contract-type-".concat(index),
                children: [(option === null || option === void 0 ? void 0 : option.title) === "Get this deal on a new contract" ? "New Contract" : option === null || option === void 0 ? void 0 : option.title, selected === option.title && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  className: (ApplicationTypeSelector_module_default()).PillVectorPrice_icon,
                  src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/pillvector.svg")
                })]
              })]
            })
          }, index);
        })
      })
    })
  });
};

/* harmony default export */ var dealSpecifications_ApplicationTypeSelector = (ApplicationTypeSelector);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./components/organisms/dealSpecifications/DealDurationAndPrice.module.scss
var DealDurationAndPrice_module = __webpack_require__(52506);
var DealDurationAndPrice_module_default = /*#__PURE__*/__webpack_require__.n(DealDurationAndPrice_module);
;// CONCATENATED MODULE: ./components/organisms/dealSpecifications/DealDurationAndPrice.jsx



 // import { propTypes } from 'react-bootstrap/esm/Image';





var DealDurationAndPrice = function DealDurationAndPrice(props) {
  var renderPriceDurationCard = function renderPriceDurationCard(contract, index) {
    var _props$dealData, _props$dealData2, _props$dealData3;

    var hasSaving = !!(Number(contract.old_monthly_recurring) > 0 && Number(contract.old_monthly_recurring) > Number(contract.price));
    var price = (0,helperServices/* numberFormat */.i8)(Math.round(contract.price));
    var oldPrice = (0,helperServices/* numberFormat */.i8)(Math.round(contract.old_monthly_recurring));
    var savings = (0,helperServices/* numberFormat */.i8)(Math.round((_props$dealData = props.dealData) === null || _props$dealData === void 0 ? void 0 : _props$dealData.save_monthly_recurring));
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: "".concat((DealDurationAndPrice_module_default())["contract-box"], "\n            ").concat(contract.id === ((_props$dealData2 = props.dealData) === null || _props$dealData2 === void 0 ? void 0 : _props$dealData2.sku) ? (DealDurationAndPrice_module_default())["contract-box--active"] : "", " \n            col-xs-6 col-md-3"),
        onClick: function onClick() {
          return props.handleContract(contract.id);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (DealDurationAndPrice_module_default())["contract-box--duration"],
            children: ["x ", contract.duration, " ", labels/* default.lbl_months.toLowerCase */.Z.lbl_months.toLowerCase()]
          }), hasSaving ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (DealDurationAndPrice_module_default())["contract-box--discount"],
              children: "R".concat(price, " ").concat(labels/* default.lbl_pm */.Z.lbl_pm)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (DealDurationAndPrice_module_default())["contract-box--old-price"],
              children: "R".concat(oldPrice, " ").concat(labels/* default.lbl_pm */.Z.lbl_pm)
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (DealDurationAndPrice_module_default())["contract-box--price"],
            children: "R".concat(price, " ").concat(labels/* default.lbl_pm */.Z.lbl_pm)
          })]
        }), ((_props$dealData3 = props.dealData) === null || _props$dealData3 === void 0 ? void 0 : _props$dealData3.sku) === contract.id ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (DealDurationAndPrice_module_default())["radio-selector"],
          src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/pillvector.svg")
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "".concat((DealDurationAndPrice_module_default())["radio-selector"], " ").concat((DealDurationAndPrice_module_default())["selection-placeholder"])
        })]
      }), hasSaving && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (DealDurationAndPrice_module_default())["contract-box--savings"],
        children: "SAVE R".concat(savings, " PM!")
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((DealDurationAndPrice_module_default())["container-group"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((DealDurationAndPrice_module_default())["contracts-container"], " row"),
      children: props.contractsDurations.map(renderPriceDurationCard)
    })
  });
};

DealDurationAndPrice.defaultProps = {
  dealData: null,
  handleContract: function handleContract() {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    dealData: state.dealDetails.selectedDealDetails,
    contractsDurations: state.dealDetails.contractsDurations
  };
};

/* harmony default export */ var dealSpecifications_DealDurationAndPrice = ((0,DependencyHelper.connect)(mapStateToProps, {})(DealDurationAndPrice));
// EXTERNAL MODULE: ./utils/hooks/dealDetails.js
var hooks_dealDetails = __webpack_require__(46224);
// EXTERNAL MODULE: ./config/types.js
var types = __webpack_require__(69842);
// EXTERNAL MODULE: ./components/organisms/dealSpecifications/DealSpecificationControl.module.scss
var DealSpecificationControl_module = __webpack_require__(46589);
var DealSpecificationControl_module_default = /*#__PURE__*/__webpack_require__.n(DealSpecificationControl_module);
;// CONCATENATED MODULE: ./components/organisms/dealSpecifications/DealSpecificationControl.jsx










var DealSpecificationControl = function DealSpecificationControl(props) {
  var _props$buyOptions$, _props$buyOptions$2;

  var isMobile = (0,helperServices/* componentResize */.Y4)();

  var _useDeviceStockStatus = (0,hooks_dealDetails/* useDeviceStockStatus */.c6)(),
      isDeviceInStock = _useDeviceStockStatus.isInStock;

  var _useInclusionStockSta = (0,hooks_dealDetails/* useInclusionStockStatus */.dL)(),
      isInclusionInStock = _useInclusionStockSta.isInStock;

  var isDealInCart = (0,hooks_dealDetails/* useDealInCartStatus */.og)();
  var isAddToCart = props.buyOption && props.buyOptions && props.buyOption === ((_props$buyOptions$ = props.buyOptions[0]) === null || _props$buyOptions$ === void 0 ? void 0 : _props$buyOptions$.title);
  var isUpgrade = props.buyOption && props.buyOptions && props.buyOption === ((_props$buyOptions$2 = props.buyOptions[1]) === null || _props$buyOptions$2 === void 0 ? void 0 : _props$buyOptions$2.title);
  var isViewCart = isDealInCart && !isMobile;
  var disableAddToCart = !isDeviceInStock || !isInclusionInStock || isDealInCart || props.isBackOrderDealUnavailable;
  var disableUpgrade = props.ctaText === labels/* default.deal_details.lbl_add_deal_cart */.Z.deal_details.lbl_add_deal_cart && (!isDeviceInStock || isDealInCart) || !isDeviceInStock || !isInclusionInStock || props.userLoggedIn && props.eligibleUpgradeList.length == 0;
  var variant_addToCart = props.promoTag !== types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER && props.addDealToCartEnabled ? "success" : "danger";
  var variant_upgrade = props.promoTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? "danger" : props.ctaText === labels/* default.deal_details.lbl_add_deal_cart */.Z.deal_details.lbl_add_deal_cart ? "success" : "danger";
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (DealSpecificationControl_module_default())["button-container"],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((DealSpecificationControl_module_default()).sticky_on_mobile),
      children: [isAddToCart && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Button, {
        variant: variant_addToCart,
        className: "mb-xs ".concat((DealSpecificationControl_module_default()).addToCartBtn, " \n              ").concat(disableAddToCart ? (DealSpecificationControl_module_default()).disabled : ""),
        block: true,
        onClick: function onClick() {
          return props.handleAddToCart(props.addDealToCartEnabled ? labels/* default.deal_details.lbl_deal_to_cart */.Z.deal_details.lbl_deal_to_cart : labels/* default.deal_details.lbl_get_this_deal */.Z.deal_details.lbl_get_this_deal);
        },
        disabled: disableAddToCart,
        children: [props.addDealToCartEnabled && props.promoTag != types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER && /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
          className: "v-icon-cart-s",
          children: " "
        }), props.promoTag == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : props.addDealToCartEnabled ? labels/* default.deal_details.lbl_deal_to_cart */.Z.deal_details.lbl_deal_to_cart : labels/* default.deal_details.lbl_get_this_deal */.Z.deal_details.lbl_get_this_deal]
      }), isUpgrade && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Button, {
        onClick: function onClick() {
          return props.handleUpgrade(props.ctaText);
        },
        variant: variant_upgrade,
        className: "mb-xs  ".concat((DealSpecificationControl_module_default()).addToCartBtn, " \n                ").concat(disableUpgrade ? (DealSpecificationControl_module_default()).disabled : ""),
        block: true,
        disabled: disableUpgrade,
        children: [props.ctaText === labels/* default.deal_details.lbl_add_deal_cart */.Z.deal_details.lbl_add_deal_cart && props.promoTag !== types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER && /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
          className: "v-icon-cart-s",
          children: " "
        }), props.ctaText]
      }), isViewCart && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Button, {
        variant: "dark",
        className: "mb-xs  ".concat((DealSpecificationControl_module_default())["viewcart-btn"]),
        onClick: props.viewCart,
        block: true,
        id: "".concat(props.dealSKU, "-ViewCart"),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          className: "mr-2",
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/arrow-right-small-copy-2.svg"),
          img_width: "1.125rem",
          img_height: "1.125rem"
        }), labels/* default.lbl_view_cart */.Z.lbl_view_cart]
      })]
    })
  });
};

var DealSpecificationControl_mapStateToProps = function mapStateToProps(state) {
  var _state$dealDetails$se, _state$dealDetails$se2, _state$dealDetails$se3;

  return {
    eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
    buyOption: ((_state$dealDetails$se = state.dealDetails.selectedApplicationType) === null || _state$dealDetails$se === void 0 ? void 0 : _state$dealDetails$se.title) || "",
    dealSKU: ((_state$dealDetails$se2 = state.dealDetails.selectedDealDetails) === null || _state$dealDetails$se2 === void 0 ? void 0 : _state$dealDetails$se2.sku) || "",
    promoTag: ((_state$dealDetails$se3 = state.dealDetails.selectedDealDetails) === null || _state$dealDetails$se3 === void 0 ? void 0 : _state$dealDetails$se3.promotion_tag_label) || "",
    userLoggedIn: state.navDetails.isUserLoggedIn
  };
};

/* harmony default export */ var dealSpecifications_DealSpecificationControl = ((0,DependencyHelper.connect)(DealSpecificationControl_mapStateToProps, {})(DealSpecificationControl));
// EXTERNAL MODULE: ./components/organisms/summeryWizard/SummeryWizard.module.scss
var SummeryWizard_module = __webpack_require__(932);
var SummeryWizard_module_default = /*#__PURE__*/__webpack_require__.n(SummeryWizard_module);
// EXTERNAL MODULE: ./components/organisms/summeryWizard/WizardSection.module.scss
var WizardSection_module = __webpack_require__(5289);
var WizardSection_module_default = /*#__PURE__*/__webpack_require__.n(WizardSection_module);
;// CONCATENATED MODULE: ./components/organisms/summeryWizard/WizardSection.jsx





var WizardSection = function WizardSection(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (WizardSection_module_default())["wizard-section-container"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (WizardSection_module_default())["section-indicators"],
      children: [!props.isLast && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (WizardSection_module_default())["indicator-line"]
      }), !props.showAsSubsection ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (WizardSection_module_default())["section-step"],
        children: props.stepNumber
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (WizardSection_module_default())["section-sub-step"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (WizardSection_module_default())["section-content"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (WizardSection_module_default())["section-header"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h5", {
          className: props.showAsSubsection ? (WizardSection_module_default())["subsection-header"] : (WizardSection_module_default())["section-header"],
          children: [props.sectionTitle, props.isOptional && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "".concat((WizardSection_module_default())["addOns-grey"]),
            children: "(Optional)"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (WizardSection_module_default())["section-body"],
        children: props.children
      })]
    })]
  });
};

WizardSection.defaultProps = {
  showAsSubsection: false,
  isLast: false,
  isSectionHidden: false
};
/* harmony default export */ var summeryWizard_WizardSection = (WizardSection);
;// CONCATENATED MODULE: ./components/organisms/summeryWizard/SummeryWizard.jsx






var SummeryWizard = function SummeryWizard(props) {
  var newStepNumber = 0;
  var childCount = react.Children.count(props.children);
  var upgradedChildren = react.Children.map(props.children, function (child, index) {
    if (! /*#__PURE__*/react.isValidElement(child) || child.type.name !== summeryWizard_WizardSection.name || child.props.isSectionHidden) return;
    var _child$props = child.props,
        showAsSubsection = _child$props.showAsSubsection,
        stepNumber = _child$props.stepNumber;
    var isLast = index + 1 === childCount;
    if (!showAsSubsection) newStepNumber++;
    return /*#__PURE__*/react.cloneElement(child, {
      stepNumber: stepNumber || newStepNumber,
      isLast: isLast
    });
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: (SummeryWizard_module_default())["summary-wizard-container"],
    children: upgradedChildren
  });
};

SummeryWizard.defaultProps = {
  isSectionHidden: false
};
/* harmony default export */ var summeryWizard_SummeryWizard = (SummeryWizard);
;// CONCATENATED MODULE: ./components/organisms/summeryWizard/index.js


// EXTERNAL MODULE: ./components/atoms/indication/Indication.jsx
var Indication = __webpack_require__(28093);
// EXTERNAL MODULE: ./components/organisms/dealSpecifications/CTADescription.module.scss
var CTADescription_module = __webpack_require__(86175);
var CTADescription_module_default = /*#__PURE__*/__webpack_require__.n(CTADescription_module);
;// CONCATENATED MODULE: ./components/organisms/dealSpecifications/CTADescription.jsx






var CTADescription = function CTADescription(props) {
  var imgUrl = '';
  var ctaText = null;

  if (props.isUpgradeQualificationPrompt) {
    imgUrl = "".concat(props.imagePrefix, "/assets/images/upgradenew.svg");
    ctaText = /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (CTADescription_module_default()).upgrade,
        children: " Upgrade check required "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (CTADescription_module_default())["cta-txt-info"],
        children: props.isUpgradeEnabled ? labels/* default.upgrade.lbl_upgrade_add_to_cart_info */.Z.upgrade.lbl_upgrade_add_to_cart_info : labels/* default.upgrade.lbl_upgrade_qualify_info */.Z.upgrade.lbl_upgrade_qualify_info
      })]
    });
  } else if (props.userLoggedIn && props.eligibleUpgradeList.length == 0) {
    imgUrl = "".concat(props.imagePrefix, "/assets/images/icon-cross.svg");
    ctaText = /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: (CTADescription_module_default())["cta-txt-warning"],
      children: [labels/* default.upgrade.lbl_cant_upgrade */.Z.upgrade.lbl_cant_upgrade, " ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        onClick: props.handleFindOut,
        className: (CTADescription_module_default())["info-link"],
        children: labels/* default.upgrade.lbl_find_out_why */.Z.upgrade.lbl_find_out_why
      })]
    });
  } else {
    imgUrl = "".concat(props.imagePrefix, "/assets/images/upgradenew.svg");
    ctaText = /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (CTADescription_module_default()).upgrade,
        children: " Upgrade check required "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (CTADescription_module_default())["cta-txt-info"],
        children: labels/* default.upgrade.lbl_upgrade_due_info */.Z.upgrade.lbl_upgrade_due_info
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (CTADescription_module_default())["cta-txt"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: imgUrl,
      className: (CTADescription_module_default())["cta-txt-icon"]
    }), ctaText]
  });
};

var CTADescription_mapStateToProps = function mapStateToProps(state) {
  var _state$upgrade$upgrad, _state$upgrade$upgrad2;

  return {
    eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
    isUpgradeQualificationPrompt: state.upgrade.upgradeCheckDone && (((_state$upgrade$upgrad = state.upgrade.upgradeResponse) === null || _state$upgrade$upgrad === void 0 ? void 0 : _state$upgrade$upgrad.eligibilityStatus) || ((_state$upgrade$upgrad2 = state.upgrade.upgradeResponse) === null || _state$upgrade$upgrad2 === void 0 ? void 0 : _state$upgrade$upgrad2.upgradeEligible)),
    upgradeCheckDone: state.upgrade.upgradeCheckDone,
    userLoggedIn: state.navDetails.isUserLoggedIn
  };
};

/* harmony default export */ var dealSpecifications_CTADescription = ((0,DependencyHelper.connect)(CTADescription_mapStateToProps, {})(CTADescription));
// EXTERNAL MODULE: ./components/molecules/StockModal/StockModal.jsx
var StockModal = __webpack_require__(75217);
;// CONCATENATED MODULE: ./Redux/actions/AlertAction.js



var handleSelect = function handleSelect(value) {
  return /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dispatch) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: actionTypes/* ALERT_SELECT */.XI,
                payload: value
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./components/organisms/dealDetailsIndicators/dealDetailsIndicators.module.scss
var dealDetailsIndicators_module = __webpack_require__(79462);
var dealDetailsIndicators_module_default = /*#__PURE__*/__webpack_require__.n(dealDetailsIndicators_module);
;// CONCATENATED MODULE: ./components/organisms/dealDetailsIndicators/dealDetailsIndicators.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var IndicatorTypes = {
  ProductStock: "product-stock",
  DeliveryInfo: "delivery-info",
  TermsAndConditions: "Terms-and-conditions",
  UpgradeNotice: "upgrade-notice"
};

var addProductStatus = function addProductStatus(_ref) {
  var isDeviceInStock = _ref.isDeviceInStock,
      isDeviceBackOrder = _ref.isDeviceBackOrder,
      isInclusionInStock = _ref.isInclusionInStock,
      isInclusionBackOrder = _ref.isInclusionBackOrder,
      stockMessages = _ref.stockMessages,
      selectedOption = _ref.selectedOption;
  var productStatus = {
    id: "product-status",
    description: labels/* default.lbl_In_the_stock_description */.Z.lbl_In_the_stock_description,
    status: Indication/* IndicationState.Good */.q.Good,
    type: IndicatorTypes.ProductStock,
    title: labels/* default.deal_details.device_data.lbl_available_online */.Z.deal_details.device_data.lbl_available_online
  };

  if (isDeviceInStock && isInclusionInStock && !isDeviceBackOrder && !isInclusionBackOrder) {
    return productStatus;
  } else if (!isDeviceInStock || !isInclusionInStock) {
    productStatus.description = labels/* default.lbl_out_of_stock_description */.Z.lbl_out_of_stock_description;
    productStatus.status = Indication/* IndicationState.Bad */.q.Bad;
    productStatus.title = labels/* default.lbl_out_of_stock_title */.Z.lbl_out_of_stock_title;
    productStatus.action = {
      showAction: (selectedOption != labels/* default.lbl_custom_dropdown_upgrade_option */.Z.lbl_custom_dropdown_upgrade_option || labels/* default.lbl_custom_dropdown_upgrade_option_new_contract */.Z.lbl_custom_dropdown_upgrade_option_new_contract) && selectedOption != labels/* default.lbl_custom_dropdown_deal_option */.Z.lbl_custom_dropdown_deal_option,
      actionLabel: "Notify me when it's available online"
    };
    return productStatus;
  } else if (isDeviceBackOrder) {
    // Back-order, primary product
    productStatus.description = typeof (stockMessages === null || stockMessages === void 0 ? void 0 : stockMessages.out_of_stock_description) === "string" ? stockMessages === null || stockMessages === void 0 ? void 0 : stockMessages.out_of_stock_description.replace("%product%", "product colour") : stockMessages === null || stockMessages === void 0 ? void 0 : stockMessages.out_of_stock_description;
    productStatus.status = Indication/* IndicationState.Warning */.q.Warning;
    productStatus.title = stockMessages === null || stockMessages === void 0 ? void 0 : stockMessages.out_of_stock_title;
    return productStatus;
  } else if (isInclusionBackOrder) {
    // Back-order, inclusion
    productStatus.description = typeof (stockMessages === null || stockMessages === void 0 ? void 0 : stockMessages.out_of_stock_description) === "string" ? stockMessages === null || stockMessages === void 0 ? void 0 : stockMessages.out_of_stock_description.replace("%product%", "accessory colour") : stockMessages === null || stockMessages === void 0 ? void 0 : stockMessages.out_of_stock_description;
    productStatus.status = Indication/* IndicationState.Warning */.q.Warning;
    productStatus.title = stockMessages === null || stockMessages === void 0 ? void 0 : stockMessages.out_of_stock_title;
    return productStatus;
  }

  return null;
};

var addUpgradeCheck = function addUpgradeCheck(isUpgradeSelection) {
  if (!isUpgradeSelection) {
    return null;
  }

  return {
    id: "upgrade-notice",
    type: IndicatorTypes.UpgradeNotice
  };
};

var addDeliveryInfo = function addDeliveryInfo(delivery_and_return, isSimonly, isUpgradeSelection) {
  if (!delivery_and_return || isSimonly && isUpgradeSelection) {
    return null;
  }

  var termsRegex = /terms *and *conditions/g;
  var isTsAndCs = typeof delivery_and_return === 'string' ? delivery_and_return.match(termsRegex) : false;
  return {
    id: "delivery-info",
    content: delivery_and_return,
    type: IndicatorTypes.DeliveryInfo,
    isTsAndCs: isTsAndCs
  };
};

var DealDetailsIndicators = function DealDetailsIndicators(props) {
  var _useDeviceStockStatus = (0,hooks_dealDetails/* useDeviceStockStatus */.c6)(),
      isDeviceInStock = _useDeviceStockStatus.isInStock,
      isDeviceBackOrder = _useDeviceStockStatus.isBackOrder;

  var _useInclusionStockSta = (0,hooks_dealDetails/* useInclusionStockStatus */.dL)(),
      isInclusionInStock = _useInclusionStockSta.isInStock,
      isInclusionBackOrder = _useInclusionStockSta.isBackOrder;

  var _useState = (0,react.useState)(false),
      showStockModal = _useState[0],
      setShowStockModal = _useState[1];

  var env = (config_default()).env;
  var loginUrl = (config_default()).envConfigs[env].DIDLoginUrl;
  var dealIndicators = [];
  dealIndicators.push(addProductStatus({
    isDeviceInStock: isDeviceInStock,
    isDeviceBackOrder: isDeviceBackOrder,
    isInclusionInStock: isInclusionInStock,
    isInclusionBackOrder: isInclusionBackOrder,
    stockMessages: props.stockMessages
  }));
  dealIndicators.push(addUpgradeCheck(props.isUpgradeSelection));
  dealIndicators.push(addDeliveryInfo(props.deliveryAndReturn, props.isSimonly, props.isUpgradeSelection));
  var colCount = dealIndicators.reduce(function (sum, cur) {
    return cur === null ? sum : sum + 1;
  }, 0);
  var isGridView = colCount > 2 && typeof props.deliveryAndReturn === "string" && props.deliveryAndReturn.length > 0;

  function getAlertData() {
    return _getAlertData.apply(this, arguments);
  }

  function _getAlertData() {
    _getAlertData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var alertResult;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* AlertDetails */.kr, {
                productId: props.dealDetailID
              });

            case 2:
              alertResult = _context2.sent;

              if (alertResult.productAlert == null) {
                setShowStockModal(false);
              } else {
                setShowStockModal(true);
              }

              props.handleAlertSelect(false);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _getAlertData.apply(this, arguments);
  }

  var handleModalClose = function handleModalClose() {
    setShowStockModal(false);
    (0,analyticsUtag/* link */.p4)(_objectSpread(_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
      page_form_event: "success",
      page_form_name: "shopping: devices: out of stock: email notification signup"
    }));
  };

  var handleModalShow = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var analyticsData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              props.handleAlertSelect(true);
              analyticsData = _objectSpread(_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "sales_product_category", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
                link_type: "o",
                link_name: "shopping: devices: deal details: out of stock: notify me when its available online"
              });
              (0,analyticsUtag/* link */.p4)(analyticsData);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleModalShow() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var JWTtoken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");

    if (props.checkSelect === true) {
      if (props.userLoggedIn && JWTtoken && props.dealDetailID) {
        getAlertData();
      } else if (!JWTtoken && !props.profileLoading && !props.userLoggedIn) {
        var redirectURL = loginUrl + "?redirectUrl=" + window.location.href + (props.isMiniApp ? "&app=true" : "");
        window.location.replace(redirectURL);
      }
    }
  }, [props.checkSelect, props.userLoggedIn, props.profileLoading]);

  var renderIndicator = function renderIndicator(indicatorItem) {
    var _indicatorItem$action, _indicatorItem$action2;

    if (!indicatorItem) {
      return null;
    }

    switch (indicatorItem.type) {
      case IndicatorTypes.DeliveryInfo:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          dangerouslySetInnerHTML: {
            __html: indicatorItem.content
          },
          className: "".concat((dealDetailsIndicators_module_default()).deliveryReturn_section, " \n                ").concat(isGridView ? (dealDetailsIndicators_module_default())["deliveryReturn_section--enhanced"] : "", " \n                ").concat(indicatorItem.isTsAndCs ? (dealDetailsIndicators_module_default())["deliveryReturn_section--terms"] : "", "\n              ")
        }, indicatorItem.id);

      case IndicatorTypes.ProductStock:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Indication/* default */.Z, {
          className: (dealDetailsIndicators_module_default())["indicator-item"],
          type: indicatorItem.status,
          state: indicatorItem.title,
          description: indicatorItem.description,
          uniqueIndication: indicatorItem.id,
          actionLabel: indicatorItem === null || indicatorItem === void 0 ? void 0 : (_indicatorItem$action = indicatorItem.action) === null || _indicatorItem$action === void 0 ? void 0 : _indicatorItem$action.actionLabel,
          showAction: indicatorItem === null || indicatorItem === void 0 ? void 0 : (_indicatorItem$action2 = indicatorItem.action) === null || _indicatorItem$action2 === void 0 ? void 0 : _indicatorItem$action2.showAction,
          onActionClick: handleModalShow
        }, indicatorItem.id);

      case IndicatorTypes.UpgradeNotice:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (dealDetailsIndicators_module_default())["upgrade-indicator"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dealSpecifications_CTADescription, {
            imagePrefix: helperServices/* imagePrefix */.Sj,
            isUpgradeEnabled: props.isUpgradeEnabled,
            handleFindOut: props.onUpgradeAction
          })
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((dealDetailsIndicators_module_default())["indicators-container"], " ").concat(props.className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StockModal/* default */.Z, {
      show: showStockModal,
      handleClose: handleModalClose
    }), dealIndicators.map(renderIndicator)]
  });
};

DealDetailsIndicators.defaultProps = {
  className: "",
  stockMessages: {}
};

var dealDetailsIndicators_mapStateToProps = function mapStateToProps(state) {
  return {
    userLoggedIn: state.navDetails.isUserLoggedIn,
    checkSelect: state.alertSelect.alert,
    dealDetailID: state.dealDetails.id,
    profileLoading: state.navDetails.isProfileLoading,
    isSimonly: state.dealDetails.selectedDealDetails.sim_only_flg,
    isMiniApp: state.navDetails.isMiniApp
  };
};

var mapDispatchToProps = {
  handleAlertSelect: handleSelect
};
/* harmony default export */ var dealDetailsIndicators = ((0,DependencyHelper.connect)(dealDetailsIndicators_mapStateToProps, mapDispatchToProps)(DealDetailsIndicators));
;// CONCATENATED MODULE: ./components/organisms/dealSpecifications/DealSpecificationsHelper.js


var getCTAText = function getCTAText(_ref) {
  var features = _ref.features,
      dealData = _ref.dealData,
      userLoggedIn = _ref.userLoggedIn,
      upgradeCheckDone = _ref.upgradeCheckDone,
      eligibleUpgradeList = _ref.eligibleUpgradeList;

  if (!(features !== null && features !== void 0 && features.upgradeChecksEnabled)) {
    return labels/* default.lbl_do_an_upgrade_check */.Z.lbl_do_an_upgrade_check;
  } else if (!upgradeCheckDone) {
    if (userLoggedIn && (eligibleUpgradeList === null || eligibleUpgradeList === void 0 ? void 0 : eligibleUpgradeList.length) == 0) {
      if (!features.upgradeEnabled) {
        return labels/* default.deal_details.lbl_upgrade_this_deal */.Z.deal_details.lbl_upgrade_this_deal;
      }

      return (dealData === null || dealData === void 0 ? void 0 : dealData.promotion_tag_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : labels/* default.deal_details.lbl_add_deal_cart */.Z.deal_details.lbl_add_deal_cart;
    } else {
      return labels/* default.lbl_do_an_upgrade_check */.Z.lbl_do_an_upgrade_check;
    }
  } else {
    if (!features.upgradeEnabled) {
      return labels/* default.deal_details.lbl_upgrade_this_deal */.Z.deal_details.lbl_upgrade_this_deal;
    }

    return (dealData === null || dealData === void 0 ? void 0 : dealData.promotion_tag_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? labels/* default.lbl_preorder_now */.Z.lbl_preorder_now : labels/* default.deal_details.lbl_add_deal_cart */.Z.deal_details.lbl_add_deal_cart;
  }
};
// EXTERNAL MODULE: ./components/organisms/dealSpecifications/AddedToCartPopup.jsx
var AddedToCartPopup = __webpack_require__(61297);
// EXTERNAL MODULE: ./components/organisms/dealSpecifications/DealSpecificationsTaggingHelper.js
var DealSpecificationsTaggingHelper = __webpack_require__(65688);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Collapse.js
var Collapse = __webpack_require__(9966);
// EXTERNAL MODULE: ./components/organisms/dealHighlights/DealHighLights.module.scss
var DealHighLights_module = __webpack_require__(33240);
var DealHighLights_module_default = /*#__PURE__*/__webpack_require__.n(DealHighLights_module);
// EXTERNAL MODULE: ./components/organisms/dealDetailsBody/DealDetailsBody.module.scss
var DealDetailsBody_module = __webpack_require__(52857);
var DealDetailsBody_module_default = /*#__PURE__*/__webpack_require__.n(DealDetailsBody_module);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js + 3 modules
var OverlayTrigger = __webpack_require__(95944);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
var Tooltip = __webpack_require__(43489);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
;// CONCATENATED MODULE: ./utils/hooks/common.js


/**
 * Method that returns the device screen type, Mobile, Tablet, Desktop
 * @returns {string}
 */

var useScreenType = function useScreenType() {
  var _useState = (0,react.useState)(),
      screenType = _useState[0],
      setScreenType = _useState[1];

  var isSizeChecked = false;

  var updateScreenType = function updateScreenType() {
    if (window.outerWidth <= constants/* MOBILE_WIDTH */.P_) {
      setScreenType(constants/* ScreenSizeTypes.Mobile */.yZ.Mobile);
    } else if (window.outerWidth > constants/* MOBILE_WIDTH */.P_ && window.outerWidth <= constants/* TABLET_WIDTH */.uU) {
      setScreenType(constants/* ScreenSizeTypes.Tablet */.yZ.Tablet);
    } else {
      setScreenType(constants/* ScreenSizeTypes.Desktop */.yZ.Desktop);
    }
  };

  (0,react.useEffect)(function () {
    if (false) {}

    if (!isSizeChecked) {
      updateScreenType();
      isSizeChecked = true;
    }

    window.addEventListener("resize", updateScreenType);
    return function () {
      return window.removeEventListener("resize", updateScreenType);
    };
  }, []);
  return screenType;
};
// EXTERNAL MODULE: ./components/molecules/colorSwatch/ColorSwatch.module.scss
var ColorSwatch_module = __webpack_require__(11410);
var ColorSwatch_module_default = /*#__PURE__*/__webpack_require__.n(ColorSwatch_module);
;// CONCATENATED MODULE: ./components/molecules/colorSwatch/ColorSwatch.jsx


function ColorSwatch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ColorSwatch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ColorSwatch_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ColorSwatch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CrossIcon = function CrossIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", ColorSwatch_objectSpread(ColorSwatch_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#a)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "m4 12.333 8.667-8.666M12.667 12.333 4 3.667",
        stroke: "#A8ACB8",
        strokeWidth: "2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "m4 12.333 8.667-8.666M12.667 12.333 4 3.667",
        stroke: "#fff"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          transform: "translate(.332)",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
};

CrossIcon.defaultProps = {
  width: "17",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};





var getNoticeConfigs = function getNoticeConfigs(noticeType) {
  var configs = {
    iconUrl: "",
    labelClass: "",
    indicatorClass: ""
  };

  switch (noticeType) {
    case constants/* NotificationTypes.Error */.j_.Error:
      configs.iconUrl = "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg");
      configs.indicatorClass = (ColorSwatch_module_default())["swatch-color-indicator--notice--error"];
      configs.labelClass = (ColorSwatch_module_default())["swatch-notification-error"];
      break;

    case constants/* NotificationTypes.Warning */.j_.Warning:
      configs.iconUrl = "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-orange.svg");
      configs.indicatorClass = (ColorSwatch_module_default())["swatch-color-indicator--notice--warning"];
      configs.labelClass = (ColorSwatch_module_default())["swatch-notification-warning"];
      break;

    case constants/* NotificationTypes.Success */.j_.Success:
    default:
      configs.iconUrl = "";
      configs.labelClass = "";
      configs.indicatorClass = "";
      break;
  }

  return configs;
};

var ColorSwatchModes = {
  Pill: "pill",
  Rounded: "rounded"
};
var NotificationPositions = {
  Bottom: "bottom",
  Right: "right"
};
var SwatchColor = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ColorSwatch__SwatchColor",
  componentId: "sc-2a5b52-0"
})(["background-color:", ";"], function (props) {
  return props.color;
});

var ColorSwatch = function ColorSwatch(props) {
  var _props$selectedOption, _props$selectedOption2, _props$selectedOption3, _props$selectedOption4, _props$selectedOption6, _props$selectedOption8, _props$selectedOption9, _props$selectedOption10, _props$selectedOption11, _props$selectedOption12;

  var notice = ((_props$selectedOption = props.selectedOption) === null || _props$selectedOption === void 0 ? void 0 : (_props$selectedOption2 = _props$selectedOption.notification) === null || _props$selectedOption2 === void 0 ? void 0 : _props$selectedOption2.text) || "";
  var noticeType = (_props$selectedOption3 = props.selectedOption) === null || _props$selectedOption3 === void 0 ? void 0 : (_props$selectedOption4 = _props$selectedOption3.notification) === null || _props$selectedOption4 === void 0 ? void 0 : _props$selectedOption4.type;

  var _useState = (0,react.useState)(false),
      showToolTip = _useState[0],
      setShowTooltip = _useState[1];

  var isDesktop = useScreenType() === constants/* ScreenSizeTypes.Desktop */.yZ.Desktop;

  var _getNoticeConfigs = getNoticeConfigs(noticeType),
      iconUrl = _getNoticeConfigs.iconUrl,
      indicatorClass = _getNoticeConfigs.indicatorClass,
      labelClass = _getNoticeConfigs.labelClass;

  var handleColorSelect = function handleColorSelect(item) {
    var _props$selectedOption5;

    if (props.disabled || item.id === ((_props$selectedOption5 = props.selectedOption) === null || _props$selectedOption5 === void 0 ? void 0 : _props$selectedOption5.id)) return;
    typeof props.onColorSelect === "function" && props.onColorSelect(item);
  };

  if (Array.isArray(props.options) && props.options.length === 1 && props.options[0].id !== ((_props$selectedOption6 = props.selectedOption) === null || _props$selectedOption6 === void 0 ? void 0 : _props$selectedOption6.id)) {
    handleColorSelect(props.options[0]);
  }

  var modeClassName;

  switch (props.swatchMode) {
    case ColorSwatchModes.Pill:
      modeClassName = "swatch-color-indicator-pill";
      break;

    case ColorSwatchModes.Rounded:
    default:
      modeClassName = "swatch-color-indicator-rounded";
      break;
  }

  var renderSwatchColor = function renderSwatchColor(swatchItem) {
    var _props$selectedOption7;

    var isSelected = swatchItem.id === ((_props$selectedOption7 = props.selectedOption) === null || _props$selectedOption7 === void 0 ? void 0 : _props$selectedOption7.id);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SwatchColor, {
      className: "\n          ".concat((ColorSwatch_module_default())["swatch-color-indicator"], " \n          ").concat((ColorSwatch_module_default())[modeClassName], " \n          ").concat(isSelected ? (ColorSwatch_module_default())["swatch-color-indicator--selected"] : "", "\n          ").concat(notice ? indicatorClass : "", "\n        "),
      color: swatchItem.value,
      onClick: function onClick() {
        return handleColorSelect(swatchItem);
      },
      children: !swatchItem.isAvailable && /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIcon, {
        className: (ColorSwatch_module_default())["swatch-color-icon"]
      })
    }, swatchItem.id);
  };

  var renderSwatchNotice = function renderSwatchNotice() {
    if (!notice) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(OverlayTrigger/* default */.Z, {
      placement: "bottom-start",
      overlay: notificationOverlay,
      delay: {
        hide: 1000,
        show: 500
      },
      defaultShow: false,
      onToggle: setShowTooltip,
      show: showToolTip,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (ColorSwatch_module_default())["swatch-notification"],
        onClick: props.toggleNotice,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (ColorSwatch_module_default())["swatch-notification-icon"],
          src: iconUrl
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "".concat((ColorSwatch_module_default())["swatch-notification-label"], " ").concat(labelClass),
          children: notice
        })]
      })
    });
  };

  if (!Array.isArray(props.options) || props.options.length === 0) return null;
  var notificationOverlay = isDesktop && (_props$selectedOption8 = props.selectedOption) !== null && _props$selectedOption8 !== void 0 && (_props$selectedOption9 = _props$selectedOption8.notification) !== null && _props$selectedOption9 !== void 0 && _props$selectedOption9.description ? /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
    id: "tooltip-notification",
    children: (_props$selectedOption10 = props.selectedOption) === null || _props$selectedOption10 === void 0 ? void 0 : (_props$selectedOption11 = _props$selectedOption10.notification) === null || _props$selectedOption11 === void 0 ? void 0 : _props$selectedOption11.description
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {});
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((ColorSwatch_module_default())["color-swatch-container"], " ").concat(props.className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
      className: (ColorSwatch_module_default())["swatch-color-title"],
      children: [props.title, ":", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (ColorSwatch_module_default())["swatch-color-label"],
        children: [" ", ((_props$selectedOption12 = props.selectedOption) === null || _props$selectedOption12 === void 0 ? void 0 : _props$selectedOption12.label) || ""]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((ColorSwatch_module_default())["color-swatch-content"], " \n          ").concat(props.alignNotification === NotificationPositions.Bottom ? (ColorSwatch_module_default())["color-swatch-content--bottom"] : (ColorSwatch_module_default())["color-swatch-content--right"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (ColorSwatch_module_default())["color-swatch-group"],
        children: Array.isArray(props.options) && props.options.map(renderSwatchColor)
      }), renderSwatchNotice()]
    })]
  });
};

ColorSwatch.defaultProps = {
  alignNotification: NotificationPositions.Bottom,
  className: "",
  disabled: false,
  options: [],
  selectedOption: null,
  swatchMode: ColorSwatchModes.Rounded,
  title: "Choose a colour",
  toggleNotice: function toggleNotice() {
    return null;
  }
};
/* harmony default export */ var colorSwatch_ColorSwatch = (ColorSwatch);
// EXTERNAL MODULE: ./components/atoms/label/Label.jsx
var Label = __webpack_require__(63703);
// EXTERNAL MODULE: ./components/molecules/dealDetailsPromotions/dealDetailsPromotions.module.scss
var dealDetailsPromotions_module = __webpack_require__(35347);
var dealDetailsPromotions_module_default = /*#__PURE__*/__webpack_require__.n(dealDetailsPromotions_module);
// EXTERNAL MODULE: ./components/atoms/linkRoute/LinkRoute.jsx
var LinkRoute = __webpack_require__(80286);
;// CONCATENATED MODULE: ./components/molecules/dealDetailsPromotions/dealDetailsPromotions.jsx









var DealDetailsPromotions = function DealDetailsPromotions(_ref) {
  var variant = _ref.variant,
      tagText = _ref.tagText,
      description = _ref.description,
      isPromotionTagLink = _ref.isPromotionTagLink,
      promotionTag = _ref.promotionTag,
      descriptionTime = _ref.descriptionTime,
      promotionLink = _ref.promotionLink,
      flag = _ref.flag,
      labelColor = _ref.labelColor;
  if (!(tagText || description || promotionLink)) return "";

  var generateVariantStyle = function generateVariantStyle() {
    return variant ? (dealDetailsPromotions_module_default())["promotion--" + variant] : "";
  }; // For Filter with on the appropriate promotion on product list page


  var createPromotionFilter = function createPromotionFilter(value, label) {
    return value + ":" + label;
  };

  var env = (config_default()).env;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((dealDetailsPromotions_module_default()).promotion, " ").concat(generateVariantStyle()),
    children: [tagText && /*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      className: "".concat((dealDetailsPromotions_module_default()).promotion__tag),
      text: tagText,
      labelColor: labelColor
    }), isPromotionTagLink || promotionLink ? promotionLink !== null && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkRoute/* default */.Z, {
        href: promotionLink ? (0,helperServices/* isExternalUrl */.xf)(promotionLink) ? "".concat(promotionLink) : "".concat(urlPrefix, "/").concat(promotionLink) : "".concat(urlPrefix, "/deals"),
        as: promotionLink ? null : "".concat(urlPrefix, "/deals?promotions=").concat(createPromotionFilter(promotionTag, variant)),
        text: labels/* default.lbl_promotion_tag_link */.Z.lbl_promotion_tag_link,
        className: "".concat((dealDetailsPromotions_module_default()).promotion__description__link)
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        children: [" \xA0", labels/* default.lbl_promotion_tag_text */.Z.lbl_promotion_tag_text]
      })]
    }) : !flag ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: (dealDetailsPromotions_module_default()).promotion__description,
      children: [description, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (dealDetailsPromotions_module_default()).description_font,
        children: descriptionTime
      })]
    }) : ""]
  });
};

DealDetailsPromotions.defaultProps = {
  className: "",
  variant: "",
  promotionTag: ""
};
/* harmony default export */ var dealDetailsPromotions = (DealDetailsPromotions);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./components/organisms/dealHighlights/DeviceSubsection.module.scss
var DeviceSubsection_module = __webpack_require__(81993);
var DeviceSubsection_module_default = /*#__PURE__*/__webpack_require__.n(DeviceSubsection_module);
;// CONCATENATED MODULE: ./components/organisms/dealHighlights/DeviceSubsection.jsx











var DeviceSubsection = function DeviceSubsection(props) {
  var isDesktop = useScreenType() === constants/* ScreenSizeTypes.Desktop */.yZ.Desktop;
  var isTablet = useScreenType() === constants/* ScreenSizeTypes.Tablet */.yZ.Tablet;

  var renderFooterNotice = function renderFooterNotice() {
    if (isDesktop || !props.footerText) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (DeviceSubsection_module_default())["device-subsection-footer"],
      children: [isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: "".concat((DeviceSubsection_module_default())["footer--icon"], " ").concat(open ? (DeviceSubsection_module_default()).open : ""),
        src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/info_white.svg")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: (DeviceSubsection_module_default())["footer--label"],
        children: props.footerText
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: props.onDismissFooter,
        variant: "link",
        children: "Dismiss"
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "col-sm-12 ".concat(props.className, " ").concat((DeviceSubsection_module_default())["device-subsection"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (DeviceSubsection_module_default())["device-content"],
      children: [props.children, renderFooterNotice()]
    })
  });
};

DeviceSubsection.defaultProps = {
  className: "",
  footerText: "",
  onDismissFooter: function onDismissFooter() {
    return null;
  }
};
/* harmony default export */ var dealHighlights_DeviceSubsection = (DeviceSubsection);
// EXTERNAL MODULE: ./components/molecules/iconWithText/svgWithText.module.scss
var svgWithText_module = __webpack_require__(10932);
var svgWithText_module_default = /*#__PURE__*/__webpack_require__.n(svgWithText_module);
;// CONCATENATED MODULE: ./components/molecules/iconWithText/svgWithText.jsx






var TextIconTypes = {
  Data: "data",
  SMS: "sms",
  Phone: "phone",
  Combo: "combo"
};

var SvgWithText = function SvgWithText(_ref) {
  var className = _ref.className,
      description = _ref.description,
      iconType = _ref.iconType,
      owlDescription = _ref.owlDescription,
      owlValue = _ref.owlValue,
      value = _ref.value;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var iconUrl = '';

  switch (iconType) {
    case TextIconTypes.Data:
      iconUrl = "".concat(imagePrefix, "/assets/images/plan-data.svg");
      break;

    case TextIconTypes.SMS:
      iconUrl = "".concat(imagePrefix, "/assets/images/plan-sms.svg");
      break;

    case TextIconTypes.Phone:
      iconUrl = "".concat(imagePrefix, "/assets/images/plan-phone.svg");
      break;

    case TextIconTypes.Combo:
      iconUrl = "".concat(imagePrefix, "/assets/images/plan-combo.svg");
      break;

    default:
      iconUrl = '';
      break;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((svgWithText_module_default())["detail-container"], " ").concat(className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (svgWithText_module_default())["svg-icon"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: iconUrl
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (svgWithText_module_default()).description,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Text, {
        className: (svgWithText_module_default()).value,
        children: value
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Text, {
        className: (svgWithText_module_default()).type,
        children: description
      }), owlValue && owlDescription && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Text, {
          className: (svgWithText_module_default()).value,
          children: "+"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Text, {
          className: (svgWithText_module_default()).value,
          children: owlValue
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Text, {
          className: (svgWithText_module_default()).type,
          children: owlDescription
        })]
      })]
    })]
  });
};

/* harmony default export */ var svgWithText = (SvgWithText);
;// CONCATENATED MODULE: ./components/organisms/dealHighlights/DealHighlights.jsx


function DealHighlights_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DealHighlights_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DealHighlights_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DealHighlights_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var MaxInclusionCount = 3;
var DefaultHighLights = [{
  id: "1",
  value: "",
  displayUnit: "Anytime data",
  unit: "promo_data",
  iconLabel: "data"
}, {
  id: "2",
  value: "",
  displayUnit: "Night Owl data",
  unit: "nightowl_units",
  iconLabel: "data"
}, {
  id: "3",
  value: "",
  displayUnit: "minutes",
  unit: "minutes_label",
  iconLabel: "phone"
}, {
  id: "4",
  value: "",
  displayUnit: "airtime",
  unit: "airtime",
  iconLabel: "combo"
}, {
  id: "5",
  value: "",
  displayUnit: "SMS",
  unit: "sms",
  iconLabel: "sms"
}];
var DefaultNotice = {
  text: "",
  description: "",
  visible: false
};

var DealHighlights = function DealHighlights(_ref) {
  var dealData = _ref.dealData,
      primaryProduct = _ref.primaryProduct,
      primaryProductColors = _ref.primaryProductColors,
      secondaryProductColors = _ref.secondaryProductColors,
      dealInclusionColors = _ref.dealInclusionColors,
      inclusions = _ref.moreDeals,
      planData = _ref.planData,
      secondaryProduct = _ref.secondaryProduct,
      primarySwatchColor = _ref.selectedPrimaryDeviceColor,
      secondarySwatchColor = _ref.selectedSecondaryDeviceColor,
      updateSelectedDeviceColor = _ref.updateSelectedDeviceColor,
      updateSelectedInclusionColor = _ref.updateSelectedInclusionColor;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0,react.useState)(DefaultNotice),
      inclusionNotice = _useState2[0],
      setInclusionNotice = _useState2[1];

  var _useState3 = (0,react.useState)(DefaultNotice),
      productNotice = _useState3[0],
      setProductNotice = _useState3[1];

  var _useState4 = (0,react.useState)(true),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var screenType = useScreenType();
  var isMobile = screenType === constants/* ScreenSizeTypes.Mobile */.yZ.Mobile;
  var isDesktop = screenType === constants/* ScreenSizeTypes.Desktop */.yZ.Desktop;
  var deviceImagePlaceHolder = (0,helperServices/* getProductImageUrl */.G)(dealData, "image", "No_image");
  var hasInclusions = Array.isArray(inclusions) && inclusions.length > 0;
  var hasSecondaryProduct = typeof secondaryProduct === "object" && Object.keys(secondaryProduct).length > 0;
  var isLinearDisplay = Array.isArray(inclusions) && inclusions.length <= MaxInclusionCount;
  var showAdditionalInfo = !!(dealData !== null && dealData !== void 0 && dealData.compatible_routers);
  var subsectionCol = isLinearDisplay && hasInclusions ? "col-lg-4" : "col-lg-6";
  var inclusionCol = isLinearDisplay ? "col-lg-12" : "col-lg-6";
  var additionalInfo = typeof (dealData === null || dealData === void 0 ? void 0 : dealData.compatible_routers) === "string" ? dealData === null || dealData === void 0 ? void 0 : dealData.compatible_routers.split("\r\n") : [];
  (0,react.useEffect)(function () {
    setIsLoading(false);
  }, []);

  var getHighlights = function getHighlights(item) {
    var highlights = DefaultHighLights.map(function (highlight) {
      return DealHighlights_objectSpread({}, highlight);
    });
    highlights.forEach(function (highlight) {
      highlight.value = item[highlight === null || highlight === void 0 ? void 0 : highlight.unit];
    });
    var newHighlight = highlights.filter(function (item) {
      if (item.value > 0 || item.value == "Unlimited") {
        return item;
      }
    });
    var dataIndex = newHighlight.findIndex(function (highLight) {
      return highLight.unit === "promo_data";
    });

    if (dataIndex >= 0) {
      newHighlight[dataIndex].value = (0,helperServices/* formatBytes */.td)(newHighlight[dataIndex].value);
    }

    var airtimeIndex = newHighlight.findIndex(function (highLight) {
      return highLight.unit === "airtime";
    });

    if (airtimeIndex >= 0) {
      newHighlight[airtimeIndex].value = "R".concat(newHighlight[airtimeIndex].value);
    }

    var nightData = newHighlight.findIndex(function (highLight) {
      return highLight.unit === "nightowl_units";
    });

    if (nightData >= 0) {
      var _newHighlight$nightDa;

      newHighlight[nightData].value = (planData === null || planData === void 0 ? void 0 : planData.nightowl_uom) != null ? "".concat((_newHighlight$nightDa = newHighlight[nightData]) === null || _newHighlight$nightDa === void 0 ? void 0 : _newHighlight$nightDa.value).concat(planData === null || planData === void 0 ? void 0 : planData.nightowl_uom) : "".concat(newHighlight[nightData].value);

      if (dataIndex >= 0) {
        newHighlight[dataIndex].owlValue = newHighlight[nightData].value;
        newHighlight[dataIndex].owlDisplayUnit = newHighlight[nightData].displayUnit;
        return newHighlight.filter(function (item) {
          return item.unit !== "nightowl_units";
        });
      }
    }

    return newHighlight;
  };

  var handleColorChange = function handleColorChange(primaryColor, secondaryColor) {
    typeof updateSelectedDeviceColor === "function" && updateSelectedDeviceColor({
      primaryDeviceColor: primaryColor,
      secondaryDeviceColor: secondaryColor
    });
  };

  var handleColorInclusionChange = function handleColorInclusionChange(inclusionSku, inclusionColor) {
    var _inclusionColor$notif, _inclusionColor$notif2, _inclusionColor$notif3, _inclusionColor$notif4;

    setInclusionNotice({
      text: (inclusionColor === null || inclusionColor === void 0 ? void 0 : (_inclusionColor$notif = inclusionColor.notification) === null || _inclusionColor$notif === void 0 ? void 0 : _inclusionColor$notif.text) || "",
      description: (inclusionColor === null || inclusionColor === void 0 ? void 0 : (_inclusionColor$notif2 = inclusionColor.notification) === null || _inclusionColor$notif2 === void 0 ? void 0 : _inclusionColor$notif2.description) || "",
      visible: !!(inclusionColor !== null && inclusionColor !== void 0 && (_inclusionColor$notif3 = inclusionColor.notification) !== null && _inclusionColor$notif3 !== void 0 && _inclusionColor$notif3.text && inclusionColor !== null && inclusionColor !== void 0 && (_inclusionColor$notif4 = inclusionColor.notification) !== null && _inclusionColor$notif4 !== void 0 && _inclusionColor$notif4.description)
    });
    typeof updateSelectedInclusionColor === "function" && updateSelectedInclusionColor(inclusionSku, inclusionColor);
  };

  var showInclusionColorSwatch = function showInclusionColorSwatch(inclusionColor) {
    return !!(inclusionColor && Array.isArray(inclusionColor.options));
  };

  var renderProduct = function renderProduct(product, deviceLabel, colorOptions) {
    var _primarySwatchColor$p, _primarySwatchColor$p2, _secondarySwatchColor, _secondarySwatchColor2;

    var isPrimaryDevice = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var onColorChange = function onColorChange(color) {
      var _color$notification, _color$notification2, _color$notification3, _color$notification4;

      setProductNotice({
        text: (color === null || color === void 0 ? void 0 : (_color$notification = color.notification) === null || _color$notification === void 0 ? void 0 : _color$notification.text) || "",
        description: (color === null || color === void 0 ? void 0 : (_color$notification2 = color.notification) === null || _color$notification2 === void 0 ? void 0 : _color$notification2.description) || "",
        visible: !!(color !== null && color !== void 0 && (_color$notification3 = color.notification) !== null && _color$notification3 !== void 0 && _color$notification3.text && color !== null && color !== void 0 && (_color$notification4 = color.notification) !== null && _color$notification4 !== void 0 && _color$notification4.description)
      });
      isPrimaryDevice ? handleColorChange(color, null) : handleColorChange(null, color);
    };

    var deviceImage = isPrimaryDevice ? primarySwatchColor === null || primarySwatchColor === void 0 ? void 0 : (_primarySwatchColor$p = primarySwatchColor.product) === null || _primarySwatchColor$p === void 0 ? void 0 : (_primarySwatchColor$p2 = _primarySwatchColor$p.image) === null || _primarySwatchColor$p2 === void 0 ? void 0 : _primarySwatchColor$p2.url : secondarySwatchColor === null || secondarySwatchColor === void 0 ? void 0 : (_secondarySwatchColor = secondarySwatchColor.product) === null || _secondarySwatchColor === void 0 ? void 0 : (_secondarySwatchColor2 = _secondarySwatchColor.image) === null || _secondarySwatchColor2 === void 0 ? void 0 : _secondarySwatchColor2.url;
    var showColorSwatch = !dealData.sim_only_flg && Array.isArray(colorOptions) && !!colorOptions.length;
    var colorSwatch = showColorSwatch ? /*#__PURE__*/(0,jsx_runtime.jsx)(colorSwatch_ColorSwatch, {
      alignNotification: NotificationPositions.Bottom,
      className: (DealHighLights_module_default())["color-swatch"],
      options: colorOptions,
      selectedOption: isPrimaryDevice ? primarySwatchColor : secondarySwatchColor,
      onColorSelect: onColorChange,
      swatchMode: ColorSwatchModes.Rounded,
      toggleNotice: function toggleNotice() {
        return setProductNotice(DealHighlights_objectSpread(DealHighlights_objectSpread({}, productNotice), {}, {
          visible: !productNotice.visible
        }));
      }
    }) : null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
        className: "d-block ".concat((DealHighLights_module_default())["device-title"]),
        children: [deviceLabel, ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: "d-flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((DealHighLights_module_default()).device, " ").concat((DealHighLights_module_default())["primary-device"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: (DealHighLights_module_default())["primary-device-img"],
            src: deviceImage || deviceImagePlaceHolder
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (DealHighLights_module_default())["device-details"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "pl-s ".concat((DealHighLights_module_default()).title),
            children: product === null || product === void 0 ? void 0 : product.name
          }), !isMobile && hasSecondaryProduct && colorSwatch]
        })]
      }), (isMobile || !hasSecondaryProduct) && colorSwatch]
    });
  };

  var renderPlanDetails = function renderPlanDetails() {
    if (!planData) {
      return null;
    }

    var planHighlights = getHighlights(planData);
    var highlighCol = planHighlights.length <= 2 && screenType === constants/* ScreenSizeTypes.Tablet */.yZ.Tablet ? "col-md-6" : "col-md-12";
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: "d-block ".concat((DealHighLights_module_default())["plan-title"]),
        children: "Plan:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: (DealHighLights_module_default()).title,
        children: planData === null || planData === void 0 ? void 0 : planData.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (DealHighLights_module_default())["plan-details"],
        children: planHighlights.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(svgWithText, {
            iconType: item.iconLabel,
            className: highlighCol,
            description: item.displayUnit,
            owlValue: item.owlValue,
            owlDescription: item.owlDisplayUnit,
            value: item.value
          }, "svg_".concat(index));
        })
      })]
    });
  };

  var renderInclusions = function renderInclusions() {
    if (!hasInclusions) return;

    var extractInclusionImg = function extractInclusionImg(colorOption, inclusion) {
      var _colorOption$product, _colorOption$product$, _colorOption$product2, _colorOption$product3;

      if (!(colorOption !== null && colorOption !== void 0 && (_colorOption$product = colorOption.product) !== null && _colorOption$product !== void 0 && (_colorOption$product$ = _colorOption$product.image) !== null && _colorOption$product$ !== void 0 && _colorOption$product$.url)) {
        var _inclusion$image;

        return (_inclusion$image = inclusion.image) === null || _inclusion$image === void 0 ? void 0 : _inclusion$image.url;
      }

      return (_colorOption$product2 = colorOption.product) === null || _colorOption$product2 === void 0 ? void 0 : (_colorOption$product3 = _colorOption$product2.image) === null || _colorOption$product3 === void 0 ? void 0 : _colorOption$product3.url;
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: "d-block ".concat((DealHighLights_module_default())["device-inclusion-title"]),
        children: "Also includes:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (DealHighLights_module_default())["device-inclusion-container"],
        children: inclusions.map(function (item, index) {
          var _dealInclusionColors$;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "col-xs-12 col-md-6 ".concat(inclusionCol, " d-flex \n                ").concat((DealHighLights_module_default())["device-inclusion"], "\n                ").concat(isLinearDisplay ? (DealHighLights_module_default())["linear-display"] : "", "\n              "),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: (DealHighLights_module_default()).device,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (DealHighLights_module_default())["device-img"],
                src: extractInclusionImg((_dealInclusionColors$ = dealInclusionColors[item.sku]) === null || _dealInclusionColors$ === void 0 ? void 0 : _dealInclusionColors$.selectedColor, item)
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "ml-s",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: (DealHighLights_module_default()).title,
                children: item === null || item === void 0 ? void 0 : item.name
              }), showInclusionColorSwatch(dealInclusionColors[item.sku + index]) && /*#__PURE__*/(0,jsx_runtime.jsx)(colorSwatch_ColorSwatch, {
                alignNotification: NotificationPositions.Right,
                options: dealInclusionColors[item.sku + index].options,
                selectedOption: dealInclusionColors[item.sku + index].selectedColor,
                onColorSelect: function onColorSelect(color) {
                  return handleColorInclusionChange(item.sku + index, color);
                },
                swatchMode: ColorSwatchModes.Rounded,
                toggleNotice: function toggleNotice() {
                  return setInclusionNotice(DealHighlights_objectSpread(DealHighlights_objectSpread({}, inclusionNotice), {}, {
                    visible: !inclusionNotice.visible
                  }));
                }
              })]
            }), isDesktop && isLinearDisplay && index < inclusions.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: (DealHighLights_module_default())["inclusion-separator"],
              children: " + "
            })]
          }, "itm_".concat(index));
        })
      })]
    });
  };

  return isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((DealDetailsBody_module_default()).loading_placeholder),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((DealDetailsBody_module_default())["animated-background"])
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "d-none d-lg-block ".concat((DealHighLights_module_default())["deal-highlights-divider"])
    }), primaryProduct && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (DealHighLights_module_default())["product-details"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (DealHighLights_module_default())["device-section"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: "col-sm-12 ".concat((DealHighLights_module_default())["device-header"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
            className: (DealHighLights_module_default())["device-header--name"],
            children: dealData === null || dealData === void 0 ? void 0 : dealData.name
          }), (dealData === null || dealData === void 0 ? void 0 : dealData.promotion_tag) != null && (dealData === null || dealData === void 0 ? void 0 : dealData.promotion_tag_label) !== types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER && /*#__PURE__*/(0,jsx_runtime.jsx)(dealDetailsPromotions, {
            variant: (0,helperServices/* getBadgeName */.n_)((0,helperServices/* getTagName */.MI)(dealData === null || dealData === void 0 ? void 0 : dealData.promotion_tag_label)),
            tagText: dealData === null || dealData === void 0 ? void 0 : dealData.promotion_tag_label,
            labelColor: dealData === null || dealData === void 0 ? void 0 : dealData.promotion_tag_swatch
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dealHighlights_DeviceSubsection, {
          className: subsectionCol,
          footerText: productNotice.visible ? productNotice.description : "",
          onDismissFooter: function onDismissFooter() {
            return setProductNotice(DealHighlights_objectSpread(DealHighlights_objectSpread({}, productNotice), {}, {
              visible: false
            }));
          },
          children: [renderProduct(primaryProduct, hasSecondaryProduct ? "Primary device" : "Device", primaryProductColors), hasSecondaryProduct && renderProduct(secondaryProduct, "Secondary device", secondaryProductColors, false)]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dealHighlights_DeviceSubsection, {
          className: subsectionCol,
          children: renderPlanDetails()
        }), hasInclusions && /*#__PURE__*/(0,jsx_runtime.jsx)(dealHighlights_DeviceSubsection, {
          className: isLinearDisplay ? subsectionCol : "col-md-12",
          footerText: inclusionNotice.visible ? inclusionNotice.description : "",
          onDismissFooter: function onDismissFooter() {
            return setInclusionNotice(DealHighlights_objectSpread(DealHighlights_objectSpread({}, inclusionNotice), {}, {
              visible: false
            }));
          },
          children: renderInclusions()
        }), showAdditionalInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)(dealHighlights_DeviceSubsection, {
          className: 'col-sm-12',
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (DealHighLights_module_default())["collapsible-header"],
            onClick: function onClick() {
              return setOpen(!open);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
              className: (DealHighLights_module_default())["collapsible-header--label"],
              children: "Only select routers are compatible for use with our Large Data Tariffs"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
              "aria-expanded": open,
              children: [!open ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "".concat((DealHighLights_module_default())["toggle-indicator--label"]),
                children: (dealData === null || dealData === void 0 ? void 0 : dealData.compatible_routers_lable) || "View more info"
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (DealHighLights_module_default())["toggle-indicator--hidden"],
                children: "Hide"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "".concat((DealHighLights_module_default())["toggle-indicator--icon"], " ").concat(open ? (DealHighLights_module_default()).open : ""),
                src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/caret-down.svg")
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
            "in": open,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "".concat((DealHighLights_module_default())["collapsible-content"]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                children: [(dealData === null || dealData === void 0 ? void 0 : dealData.compatible_routers_heading) || "", ":"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: (DealHighLights_module_default())["collapsible-content--list-items"],
                children: additionalInfo.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: item
                  }, "info-item-".concat(index));
                })
              })]
            })
          })]
        })]
      })
    })]
  });
};

DealHighlights.defaultProps = {
  primaryProduct: null,
  moreDeals: [],
  planData: null
};

var DealHighlights_mapStateToProps = function mapStateToProps(state) {
  return {
    dealData: state.dealDetails.selectedDealDetails,
    dealInclusionColors: state.dealDetails.dealInclusionColors,
    primaryProduct: state.dealDetails.primaryProduct,
    primaryProductColors: state.dealDetails.primaryProductColors,
    moreDeals: state.dealDetails.dealInclusions,
    planData: state.dealDetails.dataPlanDetails,
    secondaryProduct: state.dealDetails.secondaryProduct,
    secondaryProductColors: state.dealDetails.secondaryProductColors,
    selectedPrimaryDeviceColor: state.dealDetails.selectedPrimaryDeviceColor,
    selectedSecondaryDeviceColor: state.dealDetails.selectedSecondaryDeviceColor
  };
};

var DealHighlights_mapDispatchToProps = {
  updateSelectedDeviceColor: dealDetailsAction/* updateSelectedDeviceColor */.fP,
  updateSelectedInclusionColor: dealDetailsAction/* updateSelectedInclusionColor */.lC
};
/* harmony default export */ var dealHighlights_DealHighlights = ((0,DependencyHelper.connect)(DealHighlights_mapStateToProps, DealHighlights_mapDispatchToProps)(DealHighlights));
// EXTERNAL MODULE: ./utils/dealDetails.js
var utils_dealDetails = __webpack_require__(72490);
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./Redux/actions/upgradeAction.js
var upgradeAction = __webpack_require__(58486);
// EXTERNAL MODULE: ./services/upgradeService.js
var upgradeService = __webpack_require__(70098);
// EXTERNAL MODULE: ./services/vasDataService.js
var vasDataService = __webpack_require__(10686);
// EXTERNAL MODULE: ./components/organisms/dealDetailsBody/DealDetailSummary.module.scss
var DealDetailSummary_module = __webpack_require__(46271);
var DealDetailSummary_module_default = /*#__PURE__*/__webpack_require__.n(DealDetailSummary_module);
;// CONCATENATED MODULE: ./components/organisms/dealDetailsBody/DealDetailSummary.jsx







var DealDetailSummary = function DealDetailSummary(_ref) {
  var _dealData$deal_delive2;

  var dealData = _ref.dealData,
      selectedApplicationType = _ref.selectedApplicationType;
  var monthlyPriceDisplayLabel = (0,helperServices/* formatNumbersWithComma */.G0)(dealData === null || dealData === void 0 ? void 0 : dealData.monthly_recurring);
  var firstMonthPriceLable = '';

  if (dealData !== null && dealData !== void 0 && dealData.deal_delivery) {
    var _dealData$deal_delive;

    firstMonthPriceLable = (0,helperServices/* formatNumbersWithComma */.G0)(parseInt(dealData === null || dealData === void 0 ? void 0 : dealData.monthly_recurring) + parseInt(dealData === null || dealData === void 0 ? void 0 : (_dealData$deal_delive = dealData.deal_delivery) === null || _dealData$deal_delive === void 0 ? void 0 : _dealData$deal_delive.replace(/^\D+/g, "")));
  }

  var isSimonlyUpgrade = !(dealData.sim_only_flg && (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) === 'Upgrade');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (DealDetailSummary_module_default()).review_block,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DealDetailSummary_module_default()).review_row,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DealDetailSummary_module_default()).row_item,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (DealDetailSummary_module_default()).row_item_head,
          children: "Application type"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (DealDetailSummary_module_default()).row_item_info,
          children: (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) === "Get this deal on a new contract" ? "New contract" : selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DealDetailSummary_module_default()).row_item,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (DealDetailSummary_module_default()).row_item_head,
          children: "Contract duration"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (DealDetailSummary_module_default()).row_item_info,
          children: [dealData.payment_terms_label, " months"]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DealDetailSummary_module_default()).review_row,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (DealDetailSummary_module_default()).row_item,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (DealDetailSummary_module_default()).row_item_head,
          children: "Deal"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DealDetailSummary_module_default()).row_item,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (DealDetailSummary_module_default()).row_item_info,
          children: dealData.name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (DealDetailSummary_module_default()).row_item_price,
          children: ["R", monthlyPriceDisplayLabel, " PM"]
        })]
      })]
    }), (dealData === null || dealData === void 0 ? void 0 : dealData.deal_delivery) && isSimonlyUpgrade && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DealDetailSummary_module_default()).review_row,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (DealDetailSummary_module_default()).row_item,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (DealDetailSummary_module_default()).row_item_head,
          children: "Delivery"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DealDetailSummary_module_default()).row_item,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (DealDetailSummary_module_default()).row_item_info,
          children: "Standard once-off delivery fee. This will be added to your first month's bill "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (DealDetailSummary_module_default()).row_item_price,
          children: ["R", (0,helperServices/* formatNumbersWithComma */.G0)(dealData === null || dealData === void 0 ? void 0 : (_dealData$deal_delive2 = dealData.deal_delivery) === null || _dealData$deal_delive2 === void 0 ? void 0 : _dealData$deal_delive2.replace(/^\D+/g, ""))]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (DealDetailSummary_module_default()).review_row,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DealDetailSummary_module_default()).row_item,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (DealDetailSummary_module_default()).row_item_head,
          children: "Monthly total:"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (DealDetailSummary_module_default()).row_item_price,
          children: ["R", monthlyPriceDisplayLabel, " PM x ", dealData.payment_terms_label]
        })]
      })
    })]
  });
};

var DealDetailSummary_mapStateToProps = function mapStateToProps(state) {
  return {
    dealData: state.dealDetails.selectedDealDetails,
    selectedApplicationType: state.dealDetails.selectedApplicationType
  };
};

/* harmony default export */ var dealDetailsBody_DealDetailSummary = ((0,DependencyHelper.connect)(DealDetailSummary_mapStateToProps, {})(DealDetailSummary));
// EXTERNAL MODULE: ./components/molecules/VASMessage/VASMessage.module.scss
var VASMessage_module = __webpack_require__(44641);
var VASMessage_module_default = /*#__PURE__*/__webpack_require__.n(VASMessage_module);
;// CONCATENATED MODULE: ./components/molecules/VASMessage/VASMessage.jsx







var VASMessage = function VASMessage(_ref) {
  var messageTitle = _ref.messageTitle,
      messageDescription = _ref.messageDescription;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  if (isOpen) {
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": why get contract cover")
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (VASMessage_module_default())["message-container"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((VASMessage_module_default())["message-title"], " ").concat(isOpen ? (VASMessage_module_default()).open : ""),
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      },
      children: messageTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((VASMessage_module_default())["message-item"], " ").concat(!isOpen ? (VASMessage_module_default()).collapsed : ""),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (VASMessage_module_default())["message-description"],
        dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(messageDescription)
      })
    })]
  });
};

/* harmony default export */ var VASMessage_VASMessage = (/*#__PURE__*/(0,react.memo)(VASMessage));
// EXTERNAL MODULE: ./components/organisms/dealDetailsBody/AddOns.module.scss
var AddOns_module = __webpack_require__(73178);
var AddOns_module_default = /*#__PURE__*/__webpack_require__.n(AddOns_module);
;// CONCATENATED MODULE: ./components/organisms/dealDetailsBody/AddOns.jsx









var VasContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3799).then(__webpack_require__.bind(__webpack_require__, 93799));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(93799)];
    }
  }
});

var AddOns = function AddOns(props) {
  var selectedDealDetails = (0,es/* useSelector */.v9)(function (state) {
    return state.dealDetails.selectedDealDetails;
  });
  var isVAS = (0,es/* useSelector */.v9)(function (state) {
    var _state$common$feature;

    return (_state$common$feature = state.common.features) === null || _state$common$feature === void 0 ? void 0 : _state$common$feature.vas;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isVAS && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((AddOns_module_default()).vasContainer),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(VasContainer, {
        dealData: selectedDealDetails,
        isVasLoadedCallback: props.isVasAvailableWithCurrentDeal,
        vasRemoved: props.isVasRemoved
      })
    }), props.isShowVas && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: "".concat((AddOns_module_default()).banner),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (AddOns_module_default()).banner__icon,
          src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/Error.svg")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "We’ve added Contract Cover by default because we believe in its value for you. You can remove it, but before you do, please read why we think you should keep it..."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(VASMessage_VASMessage, {
          messageTitle: props.contractCoverTitle,
          messageDescription: props.contractCoverDescription
        })
      })]
    })]
  });
};

AddOns.defaultProps = {
  isShowHeader: true
};
/* harmony default export */ var dealDetailsBody_AddOns = (AddOns);
;// CONCATENATED MODULE: ./components/organisms/dealDetailsBody/DealDetailsBody.jsx




function DealDetailsBody_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DealDetailsBody_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DealDetailsBody_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DealDetailsBody_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










































var VASAddons = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7333), __webpack_require__.e(1408)]).then(__webpack_require__.bind(__webpack_require__, 71408));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(71408)];
    }
  }
});

var DealDetailsBody = function DealDetailsBody(_ref) {
  var _dealDetails$options$, _buyOptions$5, _buyOptions$6, _dealDetails$payment_;

  var addBundleProductToGuestCart = _ref.addBundleProductToGuestCart,
      addDeal = _ref.addDeal,
      addDealToCart = _ref.addDealToCart,
      backOderDealUnavailable = _ref.backOderDealUnavailable,
      canReciveOTP = _ref.canReciveOTP,
      checkIfdealQualifies = _ref.checkIfdealQualifies,
      checkIsDealAffordable = _ref.checkIsDealAffordable,
      clearUpgradeJourney = _ref.clearUpgradeJourney,
      creditFilters = _ref.creditFilters,
      dealCategoryId = _ref.dealCategoryId,
      dealDetails = _ref.dealDetails,
      displayHideUpgradeModal = _ref.displayHideUpgradeModal,
      eligibleUpgradeList = _ref.eligibleUpgradeList,
      features = _ref.features,
      fetchCreditFilters = _ref.fetchCreditFilters,
      getRecommendedDeals = _ref.getRecommendedDeals,
      handleContract = _ref.handleContract,
      isChildAllowed = _ref.isChildAllowed,
      isMiniApp = _ref.isMiniApp,
      isDealDetailPage = _ref.isDealDetailPage,
      isShowAffordDeal = _ref.isShowAffordDeal,
      isVasloaded = _ref.isVasloaded,
      selectedApplicationType = _ref.selectedApplicationType,
      setDevicePrice = _ref.setDevicePrice,
      setSelectedApplicationType = _ref.setSelectedApplicationType,
      updateJourneyStatus = _ref.updateJourneyStatus,
      showUpgradeModal = _ref.showUpgradeModal,
      unMaskedMsisdn = _ref.unMaskedMsisdn,
      updateSelectedData = _ref.updateSelectedData,
      updateUpgradeRedirect = _ref.updateUpgradeRedirect,
      upgradeCheckDone = _ref.upgradeCheckDone,
      upgradeResponse = _ref.upgradeResponse,
      urlQuery = _ref.urlQuery,
      userLoggedIn = _ref.userLoggedIn,
      lowCompLaod = _ref.lowCompLaod;
  var env = (config_default()).env;
  var legacyEnv = (config_default()).envConfigs[env].legacyEnv;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var isMobile = (0,helperServices/* componentResize */.Y4)();
  var cartBundleOptions = (0,hooks_dealDetails/* useCartBundleOptions */.Sv)();
  var dealSelectionSummary = (0,hooks_dealDetails/* useDealSelectionSummary */.xt)();
  var isDealInCart = (0,hooks_dealDetails/* useDealInCartStatus */.og)();
  var productTaggingInfo = (0,hooks_dealDetails/* useProductTaggingInfo */.MM)();

  var _useContext = (0,react.useContext)(VasContext/* default */.Z),
      vasList = _useContext.vasList;

  var _useState = (0,react.useState)(null),
      alertModalContent = _useState[0],
      setAlertModalContent = _useState[1];

  var _useState2 = (0,react.useState)(),
      contractCoverDescription = _useState2[0],
      setContractCoverDescription = _useState2[1];

  var _useState3 = (0,react.useState)(),
      contractCoverTitle = _useState3[0],
      setContractCoverTitle = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isBackOrderDealUnavailable = _useState4[0],
      setIsBackOrderDealUnavailableIsOutStock = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isShowVas = _useState5[0],
      setIsShowVas = _useState5[1];

  var _useState6 = (0,react.useState)(),
      isVasRemoved = _useState6[0],
      setIsVasRemoved = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      preOrderMessage = _useState7[0],
      setPreOrderMessage = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      renderModal = _useState8[0],
      setRenderModal = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      showAddons = _useState9[0],
      setShowAddons = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      showAffordModal = _useState10[0],
      setShowAffordModal = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      showAlertModal = _useState11[0],
      setShowAlertModal = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      showPreOrderInfo = _useState12[0],
      setShowPreOrderInfo = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      showSnackBar = _useState13[0],
      setShowSnackBar = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      showUpgradeConfirmModal = _useState14[0],
      setShowUpgradeConfirmModal = _useState14[1];

  var buyOptions = dealDetails !== null && dealDetails !== void 0 && dealDetails.options ? dealDetails === null || dealDetails === void 0 ? void 0 : (_dealDetails$options$ = dealDetails.options[0]) === null || _dealDetails$options$ === void 0 ? void 0 : _dealDetails$options$.value : null;
  var router = (0,DependencyHelper.useRouter)();
  var addDealToCartEnabled = features.addLineEnabled || features.newLineEnabled;
  var newRedirectURL = features !== null && features !== void 0 && features.shakaEnabled && (features === null || features === void 0 ? void 0 : features.shakaEnabled) !== undefined ? 'checkout' : 'shopping';
  var ctaText = getCTAText({
    features: features,
    dealDetails: dealDetails,
    userLoggedIn: userLoggedIn,
    upgradeCheckDone: upgradeCheckDone,
    eligibleUpgradeList: eligibleUpgradeList
  });
  var analyticsData = DealSpecificationsTaggingHelper/* generateAnalyticsData */.dL(dealDetails);
  var parentPageName;
  var dispatch = (0,es/* useDispatch */.I0)();

  var setLoadingState = function setLoadingState(isLoading) {
    return dispatch({
      type: actionTypes/* SET_IS_LOADING */.GA,
      payload: isLoading
    });
  };

  var addDealToCartHandler = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(buyOptionTypeId) {
      var _cartResult$data;

      var cartId, cartArr, cartResult;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoadingState(true);
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              cartArr = (0,utils_dealDetails/* createCartItems */.A_)({
                dealDetails: dealDetails,
                buyOptionTypeId: buyOptionTypeId,
                vasList: vasList,
                cartBundleOptions: cartBundleOptions
              });
              _context.next = 5;
              return addBundleProductToGuestCart(cartId, cartArr);

            case 5:
              cartResult = _context.sent;
              setLoadingState(false);

              if (cartResult && !cartResult.errors && (!(cartResult !== null && cartResult !== void 0 && cartResult.data) || cartResult !== null && cartResult !== void 0 && (_cartResult$data = cartResult.data) !== null && _cartResult$data !== void 0 && _cartResult$data.addBundleProductsToCart)) {
                setRenderModal(true);
                setShowSnackBar(true);
              } else if ((cartResult === null || cartResult === void 0 ? void 0 : cartResult.status) === constants/* BACK_ORDER_DEAL_AVAILABILITY_STATUS */.ur) {
                setIsBackOrderDealUnavailableIsOutStock(true);
                backOderDealUnavailable();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function addDealToCartHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var checkIfDealIsAffordable = function checkIfDealIsAffordable(creditValue) {
    if (creditValue !== null && creditValue !== void 0 && creditValue.financeIndicator && ((creditValue === null || creditValue === void 0 ? void 0 : creditValue.financeIndicator) === "Y" || (creditValue === null || creditValue === void 0 ? void 0 : creditValue.financeIndicator) === "N") && (Number(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.monthly_recurring) > Number(creditValue === null || creditValue === void 0 ? void 0 : creditValue.total_monthly_payment) || Number(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.installment) > Number(creditValue === null || creditValue === void 0 ? void 0 : creditValue.deviceInstallment))) {
      getAlertPopupContent();
      setShowAlertModal(true);
    } else {
      handleAddDealToCart();
    }
  };

  var clickHandlerPrimary = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var isUpgrade,
          fireAnalytics,
          creditFiltersData,
          _args2 = arguments;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isUpgrade = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              fireAnalytics = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;

              if (fireAnalytics) {
                DealSpecificationsTaggingHelper/* tagJourneyChangeUse */.lt(labels/* default.upgrade.lbl_continue_upgrade */.Z.upgrade.lbl_continue_upgrade);
              }

              if (showUpgradeConfirmModal) {
                setShowUpgradeConfirmModal(false);
              }

              if (!(creditFilters !== null && creditFilters !== void 0 && creditFilters.total_monthly_payment)) {
                _context2.next = 8;
                break;
              }

              fetchRecommendedDeals(creditFilters, isUpgrade);
              _context2.next = 12;
              break;

            case 8:
              _context2.next = 10;
              return fetchCreditFilters(upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.msisdn);

            case 10:
              creditFiltersData = _context2.sent;

              if (!creditFiltersData.fail) {
                fetchRecommendedDeals(creditFiltersData, isUpgrade);
              } else {
                displayHideUpgradeModal(true);
                updateJourneyStatus(upgradeService/* errorCodes.service_down */.Zk.service_down, upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR);
              }

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function clickHandlerPrimary() {
      return _ref3.apply(this, arguments);
    };
  }();

  var clickHandlerSecondary = function clickHandlerSecondary() {
    DealSpecificationsTaggingHelper/* tagJourneyChangeUse */.lt(labels/* default.upgrade.lbl_apply_new_contract */.Z.upgrade.lbl_apply_new_contract);
    setShowUpgradeConfirmModal(false);
    clearUpgradeJourney();
    handleAddDealToCart();
  };

  var closeOptions = function closeOptions() {
    setRenderModal(false);
  };

  var closeUnaffordableAlertModal = function closeUnaffordableAlertModal() {
    setAlertModalContent(null);
  };

  var fetchPreOrderContent = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var _result$sections$, result;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "preOrderDealDetail");

            case 3:
              result = _context3.sent;

              if (result !== null && result !== void 0 && (_result$sections$ = result.sections[0]) !== null && _result$sections$ !== void 0 && _result$sections$.items) {
                setPreOrderMessage(result.sections[0].items[0].description.replace(/<[^>]+>/g, ""));
                setShowPreOrderInfo(true);
              }

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));

    return function fetchPreOrderContent() {
      return _ref4.apply(this, arguments);
    };
  }();

  var fetchRecommendedDeals = function fetchRecommendedDeals(creditValue) {
    var isUpgrade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    getRecommendedDeals(upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.msisdn, "", "", "", creditValue === null || creditValue === void 0 ? void 0 : creditValue.total_monthly_payment, Number(creditValue === null || creditValue === void 0 ? void 0 : creditValue.deviceInstallment), creditValue === null || creditValue === void 0 ? void 0 : creditValue.financeIndicator, dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku, isUpgrade ? upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.simOnlyUpgradeFlg : "").then(function (result) {
      var _result$response, _result$response$data;

      // 200 or 204 check isUpgradeAffordable("Y" | "N")
      if (result.fail) {
        displayHideUpgradeModal(true);
        updateJourneyStatus(upgradeService/* errorCodes.service_down */.Zk.service_down, upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR);
        return;
      }

      if ((result === null || result === void 0 ? void 0 : (_result$response = result.response) === null || _result$response === void 0 ? void 0 : (_result$response$data = _result$response.data) === null || _result$response$data === void 0 ? void 0 : _result$response$data.isUpgradeAffordable) === "N") {
        setShowAffordModal(true);
      } else {
        handleAddDealToCart(isUpgrade);
      }
    });
  };

  var isVasAvailableWithCurrentDeal = function isVasAvailableWithCurrentDeal(isAvailable) {
    setIsShowVas(isAvailable);
    isVasloaded(isAvailable);

    if (isAvailable) {
      // fetch drupal content
      (0,vasDataService/* getVASContractCoverContent */.Sb)().then(function (result) {
        if (result !== null && result !== void 0 && result.sections[0]) {
          var item = result === null || result === void 0 ? void 0 : result.sections[0];
          setContractCoverTitle(item === null || item === void 0 ? void 0 : item.title);
          setContractCoverDescription(item === null || item === void 0 ? void 0 : item.description);
        }
      });
    }
  };

  var itemRemovedFromAddOns = function itemRemovedFromAddOns(val) {
    setIsVasRemoved(val);
  };

  var getAlertPopupContent = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var result;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              setLoadingState(true);
              _context4.next = 4;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "dealDetailsUnaffordabilityError");

            case 4:
              result = _context4.sent;
              setAlertModalContent(result[0]);
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              setLoadingState(false);

            case 11:
              _context4.prev = 11;
              setLoadingState(false);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 8, 11, 14]]);
    }));

    return function getAlertPopupContent() {
      return _ref5.apply(this, arguments);
    };
  }();

  var generateURLParameterString = function generateURLParameterString(dealSelectionSummary) {
    if (dealSelectionSummary) {
      var urlParamsString = '';
      var deviceCount = 0;
      var accessoryCount = 0;
      dealSelectionSummary.forEach(function (item) {
        var prefix = "";

        if (item.deviceType === "primary" || item.deviceType === "secondary") {
          deviceCount++;
          prefix = "dev".concat(deviceCount);
        } else if (item.deviceType === "inclusion") {
          accessoryCount++;
          prefix = "acc".concat(accessoryCount);
        }

        Object.entries(item).forEach(function (_ref6) {
          var _ref7 = (0,slicedToArray/* default */.Z)(_ref6, 2),
              key = _ref7[0],
              value = _ref7[1];

          urlParamsString += "&".concat(prefix).concat(key, "=").concat(encodeURIComponent(value));
        });
      });
      return urlParamsString;
    }
  };

  var handleAddToCart = function handleAddToCart(label) {
    updateSession(label);
    (0,helperServices/* deleteSessionStorage */.pC)(labels/* default.Session_Keys.lbl_cart_summary */.Z.Session_Keys.lbl_cart_summary);
    (0,helperServices/* updateSessionStorage */.F$)(labels/* default.Session_Keys.lbl_cart_summary */.Z.Session_Keys.lbl_cart_summary, dealSelectionSummary);

    if (ctaText !== labels/* default.deal_details.lbl_add_deal_cart */.Z.deal_details.lbl_add_deal_cart) {
      handleAddDealToCart();
      return;
    }

    if (upgradeCheckDone && upgradeResponse && (upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.eligibilityStatus || upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.upgradeEligible)) {
      parentPageName = (0,analyticsUtag/* getPageName */.j0)();
      DealSpecificationsTaggingHelper/* tagJourneyChange */.jc();
      setShowUpgradeConfirmModal(true);
      return;
    }

    if (!upgradeCheckDone && isShowAffordDeal && creditFilters !== null && creditFilters !== void 0 && creditFilters.total_monthly_payment) {
      checkIfDealIsAffordable(creditFilters);
      return;
    }

    handleAddDealToCart();
    return;
  };

  var handleAddDealToCart = function handleAddDealToCart() {
    var _buyOptions$, _buyOptions$3, _buyOptions$4;

    var isUpgrade = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if ((selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) === ((_buyOptions$ = buyOptions[0]) === null || _buyOptions$ === void 0 ? void 0 : _buyOptions$.title)) {
      if (isUpgrade && features !== null && features !== void 0 && features.upgradeEnabled) {
        var _buyOptions$2;

        addDealToCartHandler((_buyOptions$2 = buyOptions[1]) === null || _buyOptions$2 === void 0 ? void 0 : _buyOptions$2.option_type_id);
      } else if (isUpgrade) {
        navigateTo("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/shopping/order-summary?salesChannel=Upgrade&dealId=").concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.id, "&dealSheetNumber=").concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku).concat(isMiniApp ? "&miniApp=true" : ""), true);
      } else if (addDealToCartEnabled) {
        addDealToCartHandler(selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.option_type_id);
      } else {
        navigateTo("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/").concat(newRedirectURL, "/order-summary?salesChannel=Contract&dealSheetNumber=").concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku).concat(isMiniApp ? "&miniApp=true" : "").concat(generateURLParameterString(dealSelectionSummary)));
      }

      return;
    }

    if ((selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) === ((_buyOptions$3 = buyOptions[1]) === null || _buyOptions$3 === void 0 ? void 0 : _buyOptions$3.title) && features !== null && features !== void 0 && features.upgradeEnabled) {
      addDealToCartHandler(selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.option_type_id);
      return;
    } else if ((selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) === ((_buyOptions$4 = buyOptions[1]) === null || _buyOptions$4 === void 0 ? void 0 : _buyOptions$4.title)) {
      navigateTo("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/shopping/order-summary?salesChannel=Upgrade&dealId=").concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.id, "&dealSheetNumber=").concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku).concat(isMiniApp ? "&miniApp=true" : ""), true);
      return;
    }
  };

  var handleContinueShopping = function handleContinueShopping() {
    closeOptions();
    setLoadingState(true);
    DealSpecificationsTaggingHelper/* tagContinueShopping */.sD();
    router.push("".concat(urlPrefix, "/products")).then(function () {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  var handleFindOut = function handleFindOut() {
    displayHideUpgradeModal(!showUpgradeModal);
  };

  var handleModalDismiss = function handleModalDismiss() {
    DealSpecificationsTaggingHelper/* tagJourneyChangeDismiss */.Ov();
    setShowUpgradeConfirmModal(false);
    (0,analyticsUtag/* setPageName */.t0)(parentPageName);
  };

  var handleSelectedBuyOption = function handleSelectedBuyOption(selectedOption) {
    setSelectedApplicationType(selectedOption);
    (0,analyticsUtag/* link */.p4)(DealDetailsBody_objectSpread(DealDetailsBody_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)()), {}, {
      page_tool_event: "use",
      page_tool_name: "shopping: deal details: plan type filter",
      filter_query: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.title) || ''
    }));
  };

  var handleSnackBarClose = function handleSnackBarClose() {
    setShowSnackBar(false);
  };

  var handleUpgrade = function handleUpgrade(val) {
    updateSession(labels/* default.lbl_do_an_upgrade_check */.Z.lbl_do_an_upgrade_check);
    (0,helperServices/* deleteSessionStorage */.pC)(labels/* default.Session_Keys.lbl_cart_summary */.Z.Session_Keys.lbl_cart_summary);
    (0,helperServices/* updateSessionStorage */.F$)(labels/* default.Session_Keys.lbl_cart_summary */.Z.Session_Keys.lbl_cart_summary, dealSelectionSummary);

    if (val == labels/* default.lbl_do_an_upgrade_check */.Z.lbl_do_an_upgrade_check && !(features !== null && features !== void 0 && features.upgradeChecksEnabled)) {
      navigateTo("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/shopping/upgrades-check?dealsheet=").concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku));
    } else if (val == labels/* default.lbl_do_an_upgrade_check */.Z.lbl_do_an_upgrade_check) {
      var _dealDetails$categori, _dealDetails$categori2;

      setDevicePrice({
        devicePrice: dealDetails.monthly_recurring,
        installment: dealDetails.installment || 0,
        sku: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku,
        analyticsOptions: {
          sales_product_id: [dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku],
          sales_product_quantity: [1],
          sales_product_category: [dealDetails === null || dealDetails === void 0 ? void 0 : (_dealDetails$categori = dealDetails.categories) === null || _dealDetails$categori === void 0 ? void 0 : (_dealDetails$categori2 = _dealDetails$categori[0]) === null || _dealDetails$categori2 === void 0 ? void 0 : _dealDetails$categori2.name],
          sales_product_price: ["".concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.monthly_recurring)],
          sales_order_discount: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.save_monthly_recurring
        }
      });
      var redirectLink = "https://www".concat(legacyEnv, ".vodacom.co.za/cloud/shopping/order-summary?salesChannel=Upgrade&dealId=").concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.id, "&dealSheetNumber=").concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku).concat(isMiniApp ? "&miniApp=true" : "");
      displayHideUpgradeModal(!showUpgradeModal);
      updateUpgradeRedirect(redirectLink, !(features !== null && features !== void 0 && features.upgradeEnabled) ? labels/* default.deal_details.lbl_upgrade_this_deal */.Z.deal_details.lbl_upgrade_this_deal : labels/* default.deal_details.lbl_deal_to_cart */.Z.deal_details.lbl_deal_to_cart);

      if (userLoggedIn && eligibleUpgradeList.length > 1) {
        updateJourneyStatus(null, upgradeService/* upgradeStages.ELIGIBLE_NUMBER_SELECT */.wv.ELIGIBLE_NUMBER_SELECT);
      } else if (userLoggedIn && eligibleUpgradeList.length == 1) {
        updateJourneyStatus(eligibleUpgradeList[0].resultCode, upgradeService/* upgradeStages.UPGRADE_RESULT */.wv.UPGRADE_RESULT);
        updateSelectedData(eligibleUpgradeList[0]);
      }
    } else {
      clickHandlerPrimary(false);
    }
  };

  var itemRemoved = function itemRemoved(val) {
    itemRemovedFromAddOns(val);
  };

  var navigateTo = function navigateTo(url) {
    var handoverSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (handoverSession) {
      (0,upgradeService/* handoverUpgradeeSession */.I0)(canReciveOTP, isChildAllowed, upgradeResponse);
    }

    DependencyHelper.Router.push(url);
  };

  var updateSession = function updateSession(label) {
    DealSpecificationsTaggingHelper/* tagSessionUpdate */.l7(dealDetails, label, productTaggingInfo);
    (0,helperServices/* updateSessionStorage */.F$)(labels/* default.deal_details.lbl_session_storage */.Z.deal_details.lbl_session_storage, {
      value: selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title,
      id: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku
    });
  };

  var viewAffordableDeals = function viewAffordableDeals(url) {
    if (url) {
      setLoadingState(true);
      router.push("".concat(urlPrefix).concat(url, "?category=").concat(dealCategoryId, "&monthly_recurring=minValue:0,maxValue:").concat(creditFilters === null || creditFilters === void 0 ? void 0 : creditFilters.total_monthly_payment, "&isShowQualifying=true")).then(function () {
        setLoadingState(false);
      });
    }
  };

  var viewCart = function viewCart() {
    setLoadingState(true);
    DealSpecificationsTaggingHelper/* tagViewCart */.Rx(analyticsData);
    router.push("".concat(urlPrefix, "/cart")).then(function () {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  (0,react.useEffect)(function () {
    var _dealDetails$categori3, _dealDetails$categori4;

    var buyOptionValue = (0,helperServices/* getSessionStorage */.wJ)(labels/* default.deal_details.lbl_session_storage */.Z.deal_details.lbl_session_storage);

    if (buyOptionValue && buyOptionValue.id === (dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku)) {
      (0,helperServices/* deleteSessionStorage */.pC)(labels/* default.deal_details.lbl_session_storage */.Z.deal_details.lbl_session_storage);
    }

    setDevicePrice({
      devicePrice: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.monthly_recurring,
      installment: (dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.installment) || 0,
      sku: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku,
      analyticsOptions: {
        sales_product_id: [dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku],
        sales_product_quantity: [1],
        sales_product_category: [dealDetails === null || dealDetails === void 0 ? void 0 : (_dealDetails$categori3 = dealDetails.categories) === null || _dealDetails$categori3 === void 0 ? void 0 : (_dealDetails$categori4 = _dealDetails$categori3[0]) === null || _dealDetails$categori4 === void 0 ? void 0 : _dealDetails$categori4.name],
        sales_product_price: ["".concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.monthly_recurring)],
        sales_order_discount: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.save_monthly_recurring
      }
    });

    if ((dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.promotion_tag_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER) {
      fetchPreOrderContent();
    }
  }, []);
  (0,react.useEffect)(function () {
    var selectedBuyOption = urlQuery !== null && urlQuery !== void 0 && urlQuery.buyOption && buyOptions ? buyOptions.find(function (option) {
      return (option === null || option === void 0 ? void 0 : option.sku) == (urlQuery === null || urlQuery === void 0 ? void 0 : urlQuery.buyOption);
    }) : null;
    var buyOption = urlQuery && selectedBuyOption ? selectedBuyOption : Array.isArray(buyOptions) && buyOptions.length > 0 ? buyOptions[0] : {};
    setSelectedApplicationType(buyOption);
  }, [urlQuery, buyOptions]);
  (0,react.useEffect)(function () {
    if (addDeal) {
      handleAddDealToCart();
      addDealToCart(false);
    }
  }, [addDeal]);
  (0,react.useEffect)(function () {
    if (checkIsDealAffordable && creditFilters !== null && creditFilters !== void 0 && creditFilters.total_monthly_payment) {
      checkIfdealQualifies(false);
      getRecommendedDeals(unMaskedMsisdn, "", "", "", creditFilters === null || creditFilters === void 0 ? void 0 : creditFilters.total_monthly_payment, creditFilters === null || creditFilters === void 0 ? void 0 : creditFilters.deviceInstallment, creditFilters === null || creditFilters === void 0 ? void 0 : creditFilters.financeIndicator, dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku).then(function (result) {
        var _result$response2, _result$response2$dat;

        // 200 or 204 check isUpgradeAffordable("Y" | "N")
        if (result.fail) {
          displayHideUpgradeModal(true);
          updateJourneyStatus(upgradeService/* errorCodes.service_down */.Zk.service_down, upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR);
          return;
        }

        if ((result === null || result === void 0 ? void 0 : (_result$response2 = result.response) === null || _result$response2 === void 0 ? void 0 : (_result$response2$dat = _result$response2.data) === null || _result$response2$dat === void 0 ? void 0 : _result$response2$dat.isUpgradeAffordable) === "N") {
          setShowAffordModal(true);
        } else {
          handleAddDealToCart();
        }
      });
    }
  }, [checkIsDealAffordable, creditFilters]);
  (0,react.useEffect)(function () {
    setShowAddons(!!vasList.length);
  }, [vasList]);
  (0,react.useEffect)(function () {
    if (showSnackBar) {
      var SnackbarShowDuration = 3000;
      var timer = setTimeout(function () {
        return handleSnackBarClose();
      }, SnackbarShowDuration);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [showSnackBar]);
  (0,react.useEffect)(function () {
    if (isMobile) {
      setTimeout(function () {
        setRenderModal(true);
      }, 1000);
    }
  }, [isDealInCart]);
  var modalDisplayData = {
    iconUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-info.svg"),
    title: labels/* default.upgrade.lbl_still_upgrading */.Z.upgrade.lbl_still_upgrading,
    description: labels/* default.upgrade.lbl_processing_desc */.Z.upgrade.lbl_processing_desc,
    primaryButtonText: labels/* default.upgrade.lbl_continue_upgrade */.Z.upgrade.lbl_continue_upgrade,
    onClickHandlerPrimary: function onClickHandlerPrimary() {
      return clickHandlerPrimary(true);
    },
    secondaryButtonText: labels/* default.upgrade.lbl_apply_new_contract */.Z.upgrade.lbl_apply_new_contract,
    secondaryButtonStyle: "flat black",
    onClickHandlerSecondary: clickHandlerSecondary
  };
  var isUpgrade = (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) && (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) === ((_buyOptions$5 = buyOptions[1]) === null || _buyOptions$5 === void 0 ? void 0 : _buyOptions$5.title);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showSnackBar && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(SnackBar["default"], {
      message: labels/* default.deal_details.lbl_deal_added */.Z.deal_details.lbl_deal_added,
      className: (DealDetailsBody_module_default()).snackBarSpacing,
      labelStyling: "".concat((DealDetailsBody_module_default())["msg-label"]),
      closeSnackBar: handleSnackBarClose,
      isVisible: showSnackBar,
      id: "".concat(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku, "-popup")
    }), showAffordModal && /*#__PURE__*/(0,jsx_runtime.jsx)(AffordabilityContainer/* default */.Z, {
      showModal: showAffordModal,
      resultCode: labels/* default.upgrade.errorCodes.code_deal_not_affordable */.Z.upgrade.errorCodes.code_deal_not_affordable,
      toggleModal: function toggleModal() {
        return setShowAffordModal(false);
      }
    }), showAlertModal && isShowAffordDeal && alertModalContent && /*#__PURE__*/(0,jsx_runtime.jsx)(unaffordableAlertModal_UnaffordableAlertModal, {
      showModal: showAlertModal,
      displayData: alertModalContent,
      onClickHandlerPrimary: viewAffordableDeals,
      toggleModal: closeUnaffordableAlertModal
    }), showUpgradeConfirmModal && /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeModal/* default */.Z, {
      showModal: showUpgradeConfirmModal,
      displayData: modalDisplayData,
      toggleModal: handleModalDismiss
    }), isDealInCart && isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(AddedToCartPopup/* default */.Z, {
      dealSKU: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku,
      onContinueShopping: handleContinueShopping,
      imageUrl: '/assets/images/success-circle-o-copy.svg',
      onCloseModal: closeOptions,
      showModal: renderModal,
      viewCart: viewCart
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(summeryWizard_SummeryWizard, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(summeryWizard_WizardSection, {
          sectionTitle: "Confirm your application type",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dealSpecifications_ApplicationTypeSelector, {
            buyOptions: buyOptions,
            buyOptionSelected: selectedApplicationType,
            handleSelectedBuyOption: handleSelectedBuyOption
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(summeryWizard_WizardSection, {
          sectionTitle: "Review your selected deal",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dealHighlights_DealHighlights, {
            isDealDetailPage: isDealDetailPage
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(summeryWizard_WizardSection, {
          sectionTitle: "Choose the duration & price:",
          showAsSubsection: true,
          children: lowCompLaod ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((DealDetailsBody_module_default()).loading_placeholder),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((DealDetailsBody_module_default())["animated-background"])
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dealSpecifications_DealDurationAndPrice, {
              handleContract: handleContract
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(dealDetailsIndicators, {
              deliveryAndReturn: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.delivery_and_return,
              isUpgradeSelection: (features === null || features === void 0 ? void 0 : features.upgradeChecksEnabled) && (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) === (buyOptions === null || buyOptions === void 0 ? void 0 : (_buyOptions$6 = buyOptions[1]) === null || _buyOptions$6 === void 0 ? void 0 : _buyOptions$6.title),
              isUpgradeEnabled: features === null || features === void 0 ? void 0 : features.upgradeEnabled,
              onUpgradeAction: handleFindOut,
              stockMessages: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.stock_message
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(summeryWizard_WizardSection, {
          sectionTitle: "Choose your add-ons",
          isOptional: true,
          isSectionHidden: !isShowVas,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dealDetailsBody_AddOns, {
            isShowVas: isShowVas,
            isVasAvailableWithCurrentDeal: isVasAvailableWithCurrentDeal,
            isVasRemoved: isVasRemoved,
            contractCoverTitle: contractCoverTitle,
            contractCoverDescription: contractCoverDescription
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(summeryWizard_WizardSection, {
          sectionTitle: !isUpgrade ? "Review contract & add to your cart" : "Review your contract",
          children: [showAddons && /*#__PURE__*/(0,jsx_runtime.jsx)(VASAddons, {
            currentDealSku: dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.sku,
            totalPrice: Math.round(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.monthly_recurring),
            paymentTerms: " PM x " + Math.round(dealDetails === null || dealDetails === void 0 ? void 0 : (_dealDetails$payment_ = dealDetails.payment_terms_label) === null || _dealDetails$payment_ === void 0 ? void 0 : _dealDetails$payment_.split(" ")[0]),
            itemRemoved: itemRemoved
          }), lowCompLaod ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((DealDetailsBody_module_default()).loading_placeholder),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((DealDetailsBody_module_default())["animated-background"])
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(dealDetailsBody_DealDetailSummary, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(dealSpecifications_DealSpecificationControl, {
            addDealToCartEnabled: addDealToCartEnabled,
            buyOptions: buyOptions,
            ctaText: ctaText,
            handleAddToCart: handleAddToCart,
            handleUpgrade: handleUpgrade,
            isBackOrderDealUnavailable: isBackOrderDealUnavailable,
            viewCart: viewCart
          }), showPreOrderInfo && (dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.promotion_tag_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER && (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) && buyOptions && (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.title) === buyOptions[0].title && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((DealDetailsBody_module_default())["pre-order-deal-message"]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              className: "mr-2",
              img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/toolTip-icon.svg"),
              img_width: "1.125rem",
              img_height: "1.125rem"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              children: preOrderMessage
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((DealDetailsBody_module_default())["product-indicator-container"])
    })]
  });
};

var DealDetailsBody_mapStateToProps = function mapStateToProps(state) {
  return {
    addDeal: state.upgrade.addDeal,
    canReciveOTP: state.upgrade.canReciveOTP,
    checkIsDealAffordable: state.upgrade.checkIsDealAffordable,
    creditFilters: state.upgrade.creditFilters,
    dealDetails: state.dealDetails.selectedDealDetails,
    eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
    features: state.common.features,
    isChildAllowed: state.upgrade.isChildAllowed,
    isMiniApp: state.navDetails.isMiniApp,
    isShowAffordDeal: state.creditCheckDetails.isShowAffordDeal,
    selectedApplicationType: state.dealDetails.selectedApplicationType,
    showUpgradeModal: state.upgrade.showModal,
    unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
    upgradeCheckDone: state.upgrade.upgradeCheckDone,
    upgradeResponse: state.upgrade.upgradeResponse,
    userLoggedIn: state.navDetails.isUserLoggedIn
  };
};

var DealDetailsBody_mapDispatchToProps = {
  addBundleProductToGuestCart: cartAction/* addBundleProductToGuestCart */.HJ,
  addDealToCart: upgradeAction/* addDealToCart */.ff,
  checkIfdealQualifies: upgradeAction/* checkIfdealQualifies */.RZ,
  clearUpgradeJourney: upgradeAction/* clearUpgradeJourney */.rX,
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex,
  fetchCreditFilters: upgradeAction/* fetchCreditFilters */.QV,
  getRecommendedDeals: upgradeAction/* getRecommendedDeals */.VZ,
  setDevicePrice: upgradeAction/* setDevicePrice */.kb,
  updateJourneyStatus: upgradeAction/* updateJourneyStatus */.aI,
  updateSelectedData: upgradeAction/* updateSelectedData */.x$,
  updateUpgradeRedirect: upgradeAction/* updateUpgradeRedirect */.z9,
  setSelectedApplicationType: dealDetailsAction/* setSelectedApplicationType */.NZ
};
/* harmony default export */ var dealDetailsBody_DealDetailsBody = ((0,DependencyHelper.connect)(DealDetailsBody_mapStateToProps, DealDetailsBody_mapDispatchToProps)(DealDetailsBody));
// EXTERNAL MODULE: ./components/atoms/toolTip/Tooltip.jsx
var toolTip_Tooltip = __webpack_require__(7971);
// EXTERNAL MODULE: ./components/organisms/dealDetailFooterTop/DealDetailFooterTop.module.scss
var DealDetailFooterTop_module = __webpack_require__(55074);
var DealDetailFooterTop_module_default = /*#__PURE__*/__webpack_require__.n(DealDetailFooterTop_module);
;// CONCATENATED MODULE: ./components/organisms/dealDetailFooterTop/DealDetailFooterTop.jsx



function DealDetailFooterTop_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DealDetailFooterTop_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DealDetailFooterTop_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DealDetailFooterTop_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var env = (config_default()).env;
var shoppingUrlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;

var DealDetailsFooterTop = function DealDetailsFooterTop(_ref) {
  var activeContract = _ref.activeContract,
      anyTimeProduct = _ref.anyTimeProduct,
      contractsList = _ref.contractsList,
      extraProductsUnderContract = _ref.extraProductsUnderContract,
      isSim = _ref.isSim,
      primaryProduct = _ref.primaryProduct;
  var planData = [];
  var tabNames = [{
    key: "DESC",
    title: labels/* default.deal_details.lbl_deal_details */.Z.deal_details.lbl_deal_details,
    hidden: true
  }, {
    key: "SPEC",
    title: isSim ? labels/* default.deal_details.lbl_plan_details */.Z.deal_details.lbl_plan_details : labels/* default.deal_details.lbl_device_plan_details */.Z.deal_details.lbl_device_plan_details,
    hidden: true
  }, {
    key: "ACC",
    title: labels/* default.deal_details.lbl_acc_voucher_details */.Z.deal_details.lbl_acc_voucher_details,
    hidden: true
  }];
  var firstTabActive = tabNames.find(function (tab) {
    return !tab.hidden;
  });

  var _useState = (0,react.useState)((firstTabActive === null || firstTabActive === void 0 ? void 0 : firstTabActive.key) || "DESC"),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  extraProductsUnderContract = extraProductsUnderContract.filter(function (obj) {
    return obj.badges != "" || obj.badges !== null;
  });

  var renderDescription = function renderDescription(index) {
    var dealDeviceData = [{
      label: labels/* default.deal_details.device_data.lbl_deal_price */.Z.deal_details.device_data.lbl_deal_price,
      value: "R" + (0,helperServices/* numberFormat */.i8)(activeContract === null || activeContract === void 0 ? void 0 : activeContract.monthly_recurring) + " PM"
    }, {
      label: labels/* default.deal_details.device_data.lbl_contract_duration */.Z.deal_details.device_data.lbl_contract_duration,
      value: (activeContract === null || activeContract === void 0 ? void 0 : activeContract.payment_terms_label) + " " + labels/* default.lbl_months.toLowerCase */.Z.lbl_months.toLowerCase()
    }, {
      label: labels/* default.deal_details.device_data.lbl_available_online */.Z.deal_details.device_data.lbl_available_online,
      value: (activeContract === null || activeContract === void 0 ? void 0 : activeContract.stock_status) == "OUT_OF_STOCK" ? "No" : "Yes"
    }];
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (DealDetailFooterTop_module_default())["details-deal-sub-section"],
      children: renderData(dealDeviceData)
    }, index);
  };

  var renderData = function renderData(dealData) {
    return dealData.map(function (deal, index) {
      var _deal$toolData;

      return deal.value ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
        className: "mx-0 ".concat((DealDetailFooterTop_module_default())["details-section-row"]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
          md: 4,
          xs: activeTab == "DESC" ? 6 : 12,
          className: "".concat((DealDetailFooterTop_module_default())["details-label"], " pl-m"),
          children: [(deal === null || deal === void 0 ? void 0 : deal.displayLabel) || deal.label, ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
          md: 8,
          xs: activeTab == "DESC" ? 6 : 12,
          className: (DealDetailFooterTop_module_default())["details-value"],
          children: [deal.value, (deal === null || deal === void 0 ? void 0 : deal.icon) && (deal === null || deal === void 0 ? void 0 : deal.toolData) && (deal === null || deal === void 0 ? void 0 : deal.toolData.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (DealDetailFooterTop_module_default())["tool-tip"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(toolTip_Tooltip/* default */.Z, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: deal === null || deal === void 0 ? void 0 : (_deal$toolData = deal.toolData) === null || _deal$toolData === void 0 ? void 0 : _deal$toolData.map(function (data) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (DealDetailFooterTop_module_default()).description,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "d-flex ".concat((DealDetailFooterTop_module_default()).title),
                      children: data === null || data === void 0 ? void 0 : data.contract_type_option_label
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "d-flex",
                      children: data === null || data === void 0 ? void 0 : data.contract_type_desc
                    })]
                  }, data === null || data === void 0 ? void 0 : data.contract_type_option_label);
                })
              })
            })
          }), (deal === null || deal === void 0 ? void 0 : deal.linkName) && (deal === null || deal === void 0 ? void 0 : deal.visibility) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            role: "link",
            className: (DealDetailFooterTop_module_default())["deal-details-link"],
            onClick: function onClick() {
              return handleClick(deal.linkKey);
            },
            children: [" ", deal.linkName, " "]
          })]
        })]
      }, "row-".concat(index)) : "";
    });
  };

  var handleClick = function handleClick(key) {
    var _accessory;

    var path;
    var accessory;

    switch (key) {
      case "details":
        path = "".concat(shoppingUrlPrefix, "/product-details/").concat(primaryProduct === null || primaryProduct === void 0 ? void 0 : primaryProduct.sku);
        break;

      case "accessory":
        accessory = extraProductsUnderContract.find(function (product) {
          return product.badges_label === "Accessory";
        });
        path = "".concat(shoppingUrlPrefix, "/product-details/").concat((_accessory = accessory) === null || _accessory === void 0 ? void 0 : _accessory.sku);
        break;

      case "voucher-details":
        path = activeContract === null || activeContract === void 0 ? void 0 : activeContract.promotion_link;
    }

    window.open(path, "_blank");
  };

  var renderSpecifications = function renderSpecifications(productDetalis, planDetails) {
    var deviceData = productDetalis && [{
      label: "Device name",
      value: productDetalis === null || productDetalis === void 0 ? void 0 : productDetalis.name
    }].concat((0,toConsumableArray/* default */.Z)((0,helperServices/* getSpecs */.Fh)(productDetalis)));
    var PlanData = planDetails && [{
      label: "Plan name",
      value: planDetails === null || planDetails === void 0 ? void 0 : planDetails.name
    }, {
      label: "Anytime data allocation",
      value: planDetails !== null && planDetails !== void 0 && planDetails.promo_data ? (0,helperServices/* formatBytes */.td)(planDetails === null || planDetails === void 0 ? void 0 : planDetails.promo_data) : null
    }, {
      label: "Night owl data allocation",
      value: "".concat(planDetails === null || planDetails === void 0 ? void 0 : planDetails.nightowl_units).concat(planDetails !== null && planDetails !== void 0 && planDetails.nightowl_uom ? planDetails === null || planDetails === void 0 ? void 0 : planDetails.nightowl_uom : "")
    }, {
      label: "Voice minutes",
      value: planDetails === null || planDetails === void 0 ? void 0 : planDetails.minutes_label
    }, {
      label: "Air time",
      value: planDetails.airtime ? "R" + planDetails.airtime : 0
    }, {
      label: "SMS",
      value: planDetails === null || planDetails === void 0 ? void 0 : planDetails.sms
    }, {
      label: "Contract type",
      value: activeContract === null || activeContract === void 0 ? void 0 : activeContract.contract_type_label,
      icon: true,
      toolData: contractsList === null || contractsList === void 0 ? void 0 : contractsList.filter(function (item) {
        if (item.contract_type_option_label === (activeContract === null || activeContract === void 0 ? void 0 : activeContract.contract_type_label)) {
          return item;
        }
      })
    }];

    if (PlanData != undefined || PlanData != null) {
      planData = PlanData.filter(function (item) {
        return item.value != "null";
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      children: [productDetalis && !isSim && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (DealDetailFooterTop_module_default())["details-sub-header-one"],
          children: "Device details"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((DealDetailFooterTop_module_default())["details-deal-sub-section"], " ").concat((DealDetailFooterTop_module_default())["sub-section-mobile-styling"]),
          children: renderData(deviceData)
        })]
      }), planDetails && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (DealDetailFooterTop_module_default())["details-sub-header-two"],
          children: "Plan details"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((DealDetailFooterTop_module_default())["details-deal-sub-section"], " ").concat((DealDetailFooterTop_module_default())["sub-section-mobile-styling"]),
          children: renderData(planData)
        })]
      })]
    });
  };

  var renderVocherDetails = function renderVocherDetails(index) {
    var accessory = extraProductsUnderContract.find(function (product) {
      return product.badges_label === "Accessory";
    });
    var voucher = extraProductsUnderContract.find(function (product) {
      return product.badges_label === "Voucher";
    });
    var doubleDevice = extraProductsUnderContract.find(function (product) {
      return product.badges_label === "Device";
    });
    var doublePlan = extraProductsUnderContract.find(function (product) {
      return product.badges_label === "Plan";
    });
    var AccessoryData = accessory && [{
      label: "Accessory name ",
      value: accessory === null || accessory === void 0 ? void 0 : accessory.name
    }].concat((0,toConsumableArray/* default */.Z)((0,helperServices/* getSpecs */.Fh)(accessory)));
    var VoucherData = voucher && [{
      label: "Voucher name",
      value: voucher === null || voucher === void 0 ? void 0 : voucher.name,
      linkName: "View voucher redemption details",
      linkKey: "voucher-details",
      visibility: voucher === null || voucher === void 0 ? void 0 : voucher.promotion_link
    }];
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      children: [accessory && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (DealDetailFooterTop_module_default())["details-sub-header-one"],
          children: "Accessory details"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((DealDetailFooterTop_module_default())["details-deal-sub-section"], " ").concat((DealDetailFooterTop_module_default())["sub-section-mobile-styling"]),
          children: renderData(AccessoryData)
        })]
      }), renderSpecifications(doubleDevice, doublePlan), voucher && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (DealDetailFooterTop_module_default())["details-sub-header-two"],
          children: "Voucher details"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((DealDetailFooterTop_module_default())["details-deal-sub-section"], " ").concat((DealDetailFooterTop_module_default())["sub-section-mobile-styling"]),
          children: renderData(VoucherData)
        })]
      })]
    }, index);
  };

  var renderTabs = function renderTabs() {
    var footerTabs = tabNames.reduce(function (acc, tab, index) {
      if (tab.hidden) return acc;

      var _tab = DealDetailFooterTop_objectSpread({}, tab);

      switch (tab.key) {
        case "DESC":
          _tab.component = renderDescription("desc-".concat(index));
          break;

        case "SPEC":
          _tab.component = renderSpecifications(primaryProduct, anyTimeProduct, "spec-".concat(index));
          break;

        case "ACC":
          _tab.component = renderVocherDetails("acc-".concat(index));
          break;

        default:
          _tab.component = null;
          break;
      }

      return [].concat((0,toConsumableArray/* default */.Z)(acc), [_tab]);
    }, []);
    return footerTabs;
  };

  var getTabName = function getTabName(key, tabs) {
    var total = tabs.length;

    for (var i = 0; i < total; i++) {
      if (key === tabs[i].key) {
        return tabs[i].title;
      }
    }
  };

  var handleTabChange = function handleTabChange(eventKey) {
    setActiveTab(eventKey);
    (0,analyticsUtag/* link */.p4)({
      page_tool_event: "use",
      page_tool_name: "shopping: deal details: ".concat(getTabName(eventKey, tabNames))
    });
  };

  if (!firstTabActive) return null;
  var tabList = renderTabs();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((DealDetailFooterTop_module_default())["line-seperator"])
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((DealDetailFooterTop_module_default())["product-indicator-container"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((DealDetailFooterTop_module_default())["deal-detail-wrapper"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Tab.Container, {
          id: "product-fbt",
          className: (DealDetailFooterTop_module_default())["deal-detail-nav-container"],
          defaultActiveKey: activeTab,
          onSelect: handleTabChange,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Nav, {
              variant: "tabs",
              className: (DealDetailFooterTop_module_default())["nav-tabs"],
              children: tabList.map(function (tab, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Nav.Item, {
                  bsPrefix: "mt-0",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Nav.Link, {
                    eventKey: tab.key,
                    bsPrefix: "".concat((DealDetailFooterTop_module_default())["tab-link"], " ").concat(activeTab === tab.key ? (DealDetailFooterTop_module_default())["tab-link--active"] : ""),
                    children: tab.title
                  })
                }, index);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "".concat((DealDetailFooterTop_module_default())["nav-line-seperator"])
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Tab.Content, {
              className: "".concat((DealDetailFooterTop_module_default())["tab-content"]),
              children: tabList.map(function (tab, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Tab.Pane, {
                  eventKey: tab.key,
                  children: tab.component
                }, index);
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (DealDetailFooterTop_module_default())["line-seperator"]
    })]
  });
};

var DealDetailFooterTop_mapStateToProps = function mapStateToProps(state) {
  return {
    activeContract: state.dealDetails.selectedDealDetails,
    anyTimeProduct: state.dealDetails.dataPlanDetails,
    contractsList: state.dealDetails.contractsList,
    extraProductsUnderContract: state.dealDetails.dealInclusions,
    primaryProduct: state.dealDetails.primaryProduct
  };
};

/* harmony default export */ var DealDetailFooterTop = ((0,DependencyHelper.connect)(DealDetailFooterTop_mapStateToProps, {})(DealDetailsFooterTop));
// EXTERNAL MODULE: ./components/molecules/dealCard/DealCard.jsx
var DealCard = __webpack_require__(8005);
// EXTERNAL MODULE: ./components/organisms/dealDetailFooterBottom/DealListCarousel.module.scss
var DealListCarousel_module = __webpack_require__(2060);
var DealListCarousel_module_default = /*#__PURE__*/__webpack_require__.n(DealListCarousel_module);
;// CONCATENATED MODULE: ./components/organisms/dealDetailFooterBottom/DealListCarousel.jsx











var ScrollByVal = 300;
var ScrollOffset = 10;

var DealListCarousel = function DealListCarousel(props) {
  var dealContainerRef = (0,react.useRef)(null);
  var isTablet = useScreenType() === constants/* ScreenSizeTypes.Tablet */.yZ.Tablet;

  var _useState = (0,react.useState)(0),
      hScroll = _useState[0],
      setHScroll = _useState[1];

  var _useState2 = (0,react.useState)(ScrollByVal),
      maxScrollWidth = _useState2[0],
      setMaxScrollWidth = _useState2[1];

  var handleLeftScroll = function handleLeftScroll() {
    var _dealContainerRef$cur;

    dealContainerRef === null || dealContainerRef === void 0 ? void 0 : (_dealContainerRef$cur = dealContainerRef.current) === null || _dealContainerRef$cur === void 0 ? void 0 : _dealContainerRef$cur.scrollBy(ScrollByVal * -1, 0);
  };

  var handleRightScroll = function handleRightScroll() {
    var _dealContainerRef$cur2;

    dealContainerRef === null || dealContainerRef === void 0 ? void 0 : (_dealContainerRef$cur2 = dealContainerRef.current) === null || _dealContainerRef$cur2 === void 0 ? void 0 : _dealContainerRef$cur2.scrollBy(ScrollByVal, 0);
  };

  (0,react.useEffect)(function () {
    if (!(dealContainerRef !== null && dealContainerRef !== void 0 && dealContainerRef.current)) {
      return;
    }

    var handleScroll = function handleScroll() {
      var el = dealContainerRef.current;
      setHScroll(el.scrollLeft);
    };

    var element = dealContainerRef.current;
    var maxScroll = element.scrollWidth - element.clientWidth;

    if (maxScroll !== maxScrollWidth) {
      setMaxScrollWidth(element.scrollWidth - element.clientWidth);
    }

    element.addEventListener("scroll", (0,helperServices/* debounce */.Ds)(handleScroll, 100));
    return function () {
      element.removeEventListener("scroll", (0,helperServices/* debounce */.Ds)(handleScroll, 100));
    };
  }, []);
  (0,react.useEffect)(function () {
    if (!(dealContainerRef !== null && dealContainerRef !== void 0 && dealContainerRef.current)) {
      return;
    }

    var element = dealContainerRef.current;
    var maxScroll = element.scrollWidth - element.clientWidth;

    if (maxScroll !== maxScrollWidth) {
      setMaxScrollWidth(element.scrollWidth - element.clientWidth);
    }
  }, [dealContainerRef === null || dealContainerRef === void 0 ? void 0 : dealContainerRef.current]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (DealListCarousel_module_default())["tab-content"],
    children: [hScroll > ScrollOffset && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (DealListCarousel_module_default())["carousel-arrow--left"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        onClick: handleLeftScroll,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (DealListCarousel_module_default())["carousel-arrow-icon"],
          src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/chevron-left-black.svg"),
          alt: "carousel arrow left"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (DealListCarousel_module_default())["deals-wrapper"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        ref: dealContainerRef,
        className: "d-flex mb-5 pl-lg-0 ".concat((DealListCarousel_module_default())["deals-container"]),
        children: [props.dealList.map(function (item, i) {
          return item && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "d-flex mr-s ".concat(i == props.dealList.length - 1 ? "pr-xs" : "", " ").concat((DealListCarousel_module_default()).deal),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DealCard/* default */.Z, {
              width: isTablet ? "17.5rem" : "19rem",
              width_mobile: "17.5rem",
              height: "32.938rem",
              img_width: "10rem",
              maxHeight: "33.5rem",
              img_height: "10rem",
              height_mobile: "29.313rem",
              img_width_mobile: "7.5rem",
              img_height_mobile: "7.5rem",
              isOutOfStock: (0,helperServices/* checkIsOutOfStock */.zy)(item),
              productName: item.name,
              imgUrl: (0,helperServices/* getProductImageUrl */.G)(item, "image", "No_image"),
              imgUrl_mobile: (0,helperServices/* getProductImageUrl */.G)(item, "small_image", "No_image_1"),
              saveLabel: item.save_monthly_recurring,
              promotionLabel: (item === null || item === void 0 ? void 0 : item.promotion_tag) != null && item !== null && item !== void 0 && item.promotion_tag_label ? item === null || item === void 0 ? void 0 : item.promotion_tag_label : '',
              promotionVariant: (0,helperServices/* getPromotionVariant */.HM)(item),
              promotionLabelColor: item.promotion_tag_swatch,
              planName: item.package_description ? item.package_description : '',
              highlights: (0,helperServices/* getHighlights */._Y)(item),
              originalPrice: !item.old_monthly_recurring ? item.monthly_recurring : null,
              offerPrice: item.old_monthly_recurring ? item.monthly_recurring : null,
              prevPrice: item.old_monthly_recurring,
              numberOfMonths: item.payment_terms_label,
              buttonText: labels/* default.deal_details.lbl_get_this_deal */.Z.deal_details.lbl_get_this_deal,
              deal_end_date: item.deal_end_date,
              deal_go_live_date: item.deal_go_live_date,
              deal_label: item.deal_label,
              is_deal_locked: item.is_deal_locked,
              buttonHandler: function buttonHandler() {
                return props.onSeeDetailsClick(item);
              },
              noLazyload: true
            })
          }, i);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {}, "scroll-end-padding")]
      })
    }), hScroll < maxScrollWidth - ScrollOffset && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (DealListCarousel_module_default())["carousel-arrow--right"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        onClick: handleRightScroll,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (DealListCarousel_module_default())["carousel-arrow-icon"],
          src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/chevron-right-black.svg"),
          alt: "carousel arrow right"
        })
      })
    })]
  });
};

/* harmony default export */ var dealDetailFooterBottom_DealListCarousel = (DealListCarousel);
// EXTERNAL MODULE: ./components/organisms/dealDetailFooterBottom/DealDetailFooterBottom.module.scss
var DealDetailFooterBottom_module = __webpack_require__(9161);
var DealDetailFooterBottom_module_default = /*#__PURE__*/__webpack_require__.n(DealDetailFooterBottom_module);
;// CONCATENATED MODULE: ./components/organisms/dealDetailFooterBottom/DealDetailFooterBottom.jsx


function DealDetailFooterBottom_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DealDetailFooterBottom_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DealDetailFooterBottom_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DealDetailFooterBottom_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var DealDetailsFooterBottom = function DealDetailsFooterBottom() {
  var relatedDeals = (0,es/* useSelector */.v9)(function (state) {
    return state.dealDetails.relatedDeals;
  });
  var similarDeals = (0,es/* useSelector */.v9)(function (state) {
    return state.dealDetails.similarDeals;
  });

  var _useState = (0,react.useState)("SMP"),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var _useState2 = (0,react.useState)(false),
      analytics = _useState2[0],
      setAnalytics = _useState2[1];

  var _useState3 = (0,react.useState)(Array.isArray(similarDeals) ? similarDeals : []),
      tabData = _useState3[0],
      setTabData = _useState3[1];

  var env = (config_default()).env;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var router = (0,DependencyHelper.useRouter)();
  var tabNames = [{
    key: "SMP",
    title: "Similar deals"
  }, {
    key: "RLP",
    title: "You might also like"
  }];
  var dispatch = (0,es/* useDispatch */.I0)();

  var setLoadingState = function setLoadingState(isLoading) {
    return dispatch({
      type: actionTypes/* SET_IS_LOADING */.GA,
      payload: isLoading
    });
  };

  var getTabTitle = function getTabTitle(eventKey, tabNames) {
    var total = tabNames.length;

    for (var i = 0; i < total; i++) {
      if (eventKey === tabNames[i].key) {
        return tabNames[i].title;
      }
    }
  };

  function getCrossSellData(key) {
    setActiveTab(key);

    switch (key) {
      case "SMP":
        Array.isArray(similarDeals) ? setTabData(similarDeals.slice(0, labels/* default.productBottomFooterTabs.max_products */.Z.productBottomFooterTabs.max_products)) : setTabData([]);
        break;

      case "RLP":
        Array.isArray(relatedDeals) ? setTabData(relatedDeals.slice(0, labels/* default.productBottomFooterTabs.max_products */.Z.productBottomFooterTabs.max_products)) : setTabData([]);
        break;

      default:
        setTabData([]);
        break;
    }

    (0,analyticsUtag/* link */.p4)(DealDetailFooterBottom_objectSpread(DealDetailFooterBottom_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)(["page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
      page_tool_event: "use",
      page_tool_name: "shopping: devices: deal details: ".concat(getTabTitle(key, tabNames)),
      link_name: "shopping: devices: deal details: ".concat(getTabTitle(key, tabNames)),
      link_type: "use",
      page_name: "shopping: devices: deal details"
    }));
  }

  var onSeeDetailsClick = function onSeeDetailsClick(item) {
    var _router$query, _router$query2;

    var contracts = item.contract_sku;

    if (!Array.isArray(contracts)) {
      contracts = ["".concat(contracts)];
    }

    setLoadingState(true);
    var buyOption = router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.buyOption ? router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.buyOption : false;
    router.push({
      pathname: "".concat(urlPrefix, "/deal-details-page/").concat(item.sku),
      query: buyOption ? {
        contractSkus: contracts,
        buyOption: buyOption
      } : {
        contractSkus: contracts
      }
    }).then(function () {
      window.scrollTo(0, 0); // setLoadingState(false);
    });

    if (!analytics) {
      (0,analyticsUtag/* link */.p4)(DealDetailFooterBottom_objectSpread(DealDetailFooterBottom_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
        link_type: "use",
        link_name: "shopping: deal details: view recommended deal",
        page_name: "shopping: deal selection: build your contract"
      }));
      setAnalytics(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((tabData === null || tabData === void 0 ? void 0 : tabData.length) > 0 ? (DealDetailFooterBottom_module_default())["footer-product-divder"] : "")
    }), ((similarDeals === null || similarDeals === void 0 ? void 0 : similarDeals.length) > 0 || (relatedDeals === null || relatedDeals === void 0 ? void 0 : relatedDeals.length) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "mt-xl ".concat((DealDetailFooterBottom_module_default())["footer-product-container"], " p-0"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          xs: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Tab.Container, {
            id: "left-tabs-example",
            defaultActiveKey: tabNames[0].key,
            onSelect: function onSelect(eventKey) {
              return getCrossSellData(eventKey);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
                xs: 12,
                className: "".concat((DealDetailFooterBottom_module_default())["tabs-design"]),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Nav, {
                  variant: "tabs",
                  className: "".concat((DealDetailFooterBottom_module_default())["tabs-design__nav"]),
                  children: tabNames.map(function (tab, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Nav.Item, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Nav.Link, {
                        eventKey: tab.key,
                        bsPrefix: "".concat((DealDetailFooterBottom_module_default())["tab-link"], " ").concat(activeTab === tab.key ? (DealDetailFooterBottom_module_default())["tab-link--active"] : ""),
                        children: tab.title
                      })
                    }, index);
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: "".concat((DealDetailFooterBottom_module_default())["nav-line-seperator"])
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                xs: 12,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Tab.Content, {
                  className: "".concat((DealDetailFooterBottom_module_default())["tab-content"], " pt-m "),
                  children: tabNames.map(function (tab, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Tab.Pane, {
                      eventKey: tab.key,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dealDetailFooterBottom_DealListCarousel, {
                        dealList: tabData,
                        onSeeDetailsClick: onSeeDetailsClick
                      })
                    }, index);
                  })
                })
              })
            })]
          })
        })
      })
    })]
  });
};

/* harmony default export */ var DealDetailFooterBottom = (DealDetailsFooterBottom);
// EXTERNAL MODULE: ./components/molecules/modals/clickAndCollectModal/ClickAndCollectModal.jsx + 1 modules
var ClickAndCollectModal = __webpack_require__(89429);
// EXTERNAL MODULE: ./components/molecules/pageError/pageError.jsx
var pageError = __webpack_require__(66115);
// EXTERNAL MODULE: ./components/molecules/errorToolTip/ErrorTooltip.jsx
var ErrorTooltip = __webpack_require__(94029);
// EXTERNAL MODULE: ./components/atoms/Seo/Seo.js
var Seo = __webpack_require__(22505);
// EXTERNAL MODULE: ./utils/handleGeoLocation.js
var handleGeoLocation = __webpack_require__(17028);
;// CONCATENATED MODULE: ./pages/shopping/deal-details-page/[id].js





function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _id_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _id_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _id_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _id_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














 // import ajaxServices from "../../../utils/ajaxServices";
// import { urlResolver } from "../../../config/queries";














var DealDetailsPage = function DealDetailsPage(props) {
  var _props$activeContract6, _props$geoLocation, _props$geoLocation2, _props$similarDeals, _props$relatedDeals;

  var _useState = (0,react.useState)(false),
      analytics = _useState[0],
      setAnalytics = _useState[1];

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var shoppingUrlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var router = (0,DependencyHelper.useRouter)();

  var _useState2 = (0,react.useState)(false),
      showError = _useState2[0],
      setShowError = _useState2[1];

  var _useState3 = (0,react.useState)(),
      status = _useState3[0],
      setStatus = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isModalOpen = _useState4[0],
      setShowModal = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      storeAddress = _useState5[0],
      populateStoreList = _useState5[1];

  var _useState6 = (0,react.useState)(""),
      nearestStore = _useState6[0],
      setNearestStore = _useState6[1];

  var _useState7 = (0,react.useState)(true),
      serviceDown = _useState7[0],
      setServiceDown = _useState7[1];

  var _useState8 = (0,react.useState)(true),
      isClickAndCollectEligible = _useState8[0],
      setIsClickAndCollectEligible = _useState8[1];

  var _useReducer = (0,react.useReducer)(reducer, []),
      vasList = _useReducer[0],
      setVasList = _useReducer[1];

  var _useState9 = (0,react.useState)(false),
      vasAvailable = _useState9[0],
      setVasAvailable = _useState9[1];

  var _useState10 = (0,react.useState)(),
      dealSKU = _useState10[0],
      setDealSKU = _useState10[1];

  var _useState11 = (0,react.useState)(true),
      lowCompLaod = _useState11[0],
      setLowCompLaod = _useState11[1];

  var _useState12 = (0,react.useState)(null),
      contractSKUS = _useState12[0],
      setContractSKUS = _useState12[1];

  var _useState13 = (0,react.useState)(null),
      seoDetails = _useState13[0],
      setSeoDetails = _useState13[1];

  var vasProviderValue = {
    vasAvailable: vasAvailable,
    setVasAvailable: setVasAvailable,
    dealSKU: dealSKU,
    setDealSKU: setDealSKU,
    vasList: vasList,
    setVasList: setVasList
  };

  var _useState14 = (0,react.useState)({
    visible: false,
    message: ""
  }),
      showSnackBar = _useState14[0],
      setShowSnackBar = _useState14[1];

  (0,react.useEffect)(function () {
    props === null || props === void 0 ? void 0 : props.setHelpLeadBucket(constants/* LEAD_BUCKETS.general */.xO.general);
    props.checkFeatures();

    if (showError) {
      (0,analyticsUtag/* link */.p4)({
        page_name: "shopping: deal details",
        page_form_event: "error",
        page_errors: "".concat(labels/* default.lbl_menu_top.lbl_deal_404_heading */.Z.lbl_menu_top.lbl_deal_404_heading, ". ").concat(labels/* default.lbl_menu_top.lbl_deal_404_description */.Z.lbl_menu_top.lbl_deal_404_description),
        page_errors_code: "ddp-m-p-dd-".concat(status)
      });
    }
  }, []);

  var getUserLocation = function getUserLocation(productSKU) {
    (0,handleGeoLocation/* default */.Z)(props, productSKU, populateStoreList, setServiceDown);
  };

  (0,react.useEffect)(function () {
    if (storeAddress && storeAddress.length) {
      var storeDetails = (0,handleGeoLocation/* getNearestStore */.I)(storeAddress);
      setNearestStore(storeDetails);
    }
  }, [storeAddress]);

  var selectedStoreDetails = function selectedStoreDetails(selectedStore) {
    if (selectedStore) {
      setNearestStore(selectedStore);
    }

    hideCndCModal();
  };

  (0,react.useEffect)(function () {
    var _props$features;

    if ((_props$features = props.features) !== null && _props$features !== void 0 && _props$features.clickAndCollectEnabled) {
      var _props$activeContract, _props$activeContract2;

      if (props.activeContract && (_props$activeContract = props.activeContract) !== null && _props$activeContract !== void 0 && _props$activeContract.enable_click_and_collect && (props === null || props === void 0 ? void 0 : (_props$activeContract2 = props.activeContractValue) === null || _props$activeContract2 === void 0 ? void 0 : _props$activeContract2.promotion_tag_label) != types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER) {
        var _props$activeContract3;

        getUserLocation((_props$activeContract3 = props.activeContract) === null || _props$activeContract3 === void 0 ? void 0 : _props$activeContract3.primary_product_sku);
        setIsClickAndCollectEligible(true);
      } else {
        setIsClickAndCollectEligible(false);
      }
    }
  }, [props.activeContract]);
  var dispatch = (0,es/* useDispatch */.I0)();

  var setLoadingState = function setLoadingState(isLoading) {
    return dispatch({
      type: actionTypes/* SET_IS_LOADING */.GA,
      payload: isLoading
    });
  };

  var handleSeoData = function handleSeoData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var tempSeo = {};
    if (data !== null && data !== void 0 && data.meta_title) tempSeo.metaTitle = data.meta_title;
    if (data !== null && data !== void 0 && data.meta_description) tempSeo.metaDescription = data.meta_description;
    if (Object.keys(tempSeo).length) setSeoDetails(tempSeo);
  };

  function fetchData() {
    return _fetchData.apply(this, arguments);
  }

  function _fetchData() {
    _fetchData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _props$query, _props$query$id, _props$query$id$toLow;

      var sku, result, _result$errors, _result$errors2, _result$errors2$;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoadingState(true);
              setLowCompLaod(true);
              sku = (_props$query = props.query) === null || _props$query === void 0 ? void 0 : (_props$query$id = _props$query.id) === null || _props$query$id === void 0 ? void 0 : (_props$query$id$toLow = _props$query$id.toLowerCase) === null || _props$query$id$toLow === void 0 ? void 0 : _props$query$id$toLow.call(_props$query$id);
              setContractSKUS(props.query.id); // const urlResolverData = await ajaxServices.fetchGraphQLPOSTRequest(
              //   urlResolver,
              //   { url: props.query.id }
              // );
              // const { route } = urlResolverData || {};
              // const { redirect_code, relative_url } = route || {};
              // if (relative_url && redirect_code > 0) {
              //   return router.push(addObjectKeysToUrl(relative_url, props.query));
              // }

              _context.next = 6;
              return props.getAndSetDealDetails(sku);

            case 6:
              result = _context.sent;
              handleSeoData(result === null || result === void 0 ? void 0 : result.productItem);
              setStatus(result === null || result === void 0 ? void 0 : result.status);
              setShowError(result.isError);

              if (!result.ok) {
                (0,analyticsUtag/* link */.p4)({
                  page_name: "shopping: deal details",
                  page_form_event: "error",
                  page_errors: "".concat(labels/* default.lbl_menu_top.lbl_deal_404_heading */.Z.lbl_menu_top.lbl_deal_404_heading, ". ").concat(labels/* default.lbl_menu_top.lbl_deal_404_description */.Z.lbl_menu_top.lbl_deal_404_description),
                  page_errors_code: "ddp-m-p-dd-".concat(result === null || result === void 0 ? void 0 : result.status)
                });
              }

              if (result && result.errors) {
                (0,analyticsUtag/* link */.p4)({
                  page_name: "shopping: deal details",
                  page_form_event: "error",
                  page_errors: "".concat((_result$errors = result.errors) !== null && _result$errors !== void 0 && _result$errors[0] ? (_result$errors2 = result.errors) === null || _result$errors2 === void 0 ? void 0 : (_result$errors2$ = _result$errors2[0]) === null || _result$errors2$ === void 0 ? void 0 : _result$errors2$.message : ""),
                  page_errors_code: "ddp-m-p-dd-".concat(result === null || result === void 0 ? void 0 : result.status)
                });
              }

              setLoadingState(false);
              setLowCompLaod(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetchData.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    if (props !== null && props !== void 0 && props.query) {
      fetchData();
      return;
    }
  }, [props === null || props === void 0 ? void 0 : props.query]);

  var handleActiveContract = function handleActiveContract(id) {
    props.updateSelectedDealDetail(id);
    var contracts = contractSKUS;

    if (!Array.isArray(contractSKUS)) {
      contracts = ["".concat(contractSKUS)];
    } else {
      var total = contractSKUS.length;
      var contractPosition = contractSKUS.indexOf(id);

      if (contractPosition !== -1 && contractPosition !== total - 1) {
        var filteredContracts = contractSKUS.filter(function (contract) {
          return contract !== id;
        });
        filteredContracts.push(id);
        contracts = filteredContracts;
      }
    }

    if (contracts) {
      contracts.map(function (contract) {
        if (contract.id === id) {
          var _props$activeContract4, _props$activeContract5;

          (0,analyticsUtag/* link */.p4)(_id_objectSpread(_id_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "sales_order_discount", "sales_promo_name", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3"])), {}, {
            page_tool_event: "use",
            page_tool_name: "shopping: deal details: contract duration filter",
            filter_query: "".concat(contract.duration, " months"),
            sales_product_price: [(_props$activeContract4 = props.activeContract) === null || _props$activeContract4 === void 0 ? void 0 : _props$activeContract4.payment_terms],
            sales_order_discount: [(_props$activeContract5 = props.activeContract) === null || _props$activeContract5 === void 0 ? void 0 : _props$activeContract5.save_monthly_recurring]
          }));
        }
      });
    }
  };

  var isSim = !((_props$activeContract6 = props.activeContract) !== null && _props$activeContract6 !== void 0 && _props$activeContract6.installment);
  var dynamicRoute = (0,helperServices/* dynamicBreadCrumb */.sz)();
  (0,react.useEffect)(function () {
    (0,analyticsUtag/* setAutoTagging */.fv)(false);

    if (Object.keys(dynamicRoute).length && props.activeContract) {
      var userMetaData = (0,analyticsUtag/* getProfileData */.$y)(props.userLoggedIn, props.profileData);
      var breadcrumbs = Object.keys(dynamicRoute).reverse();
      var section_lvls = {};
      var index = 0;

      var _iterator = _createForOfIteratorHelper(breadcrumbs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          index = index + 1;
          if (index > 4) break;
          section_lvls["page_site_section_lvl_".concat(index)] = item;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!analytics) {
        var _props$activeContract7, _props$activeContract8, _props$activeContract9, _props$activeContract10, _props$activeContract11, _props$activeContract13, _props$activeContract14, _props$activeContract15, _props$activeContract16, _props$activeContract17;

        var analyticsData = _id_objectSpread(_id_objectSpread({
          page_event: "view",
          page_name: "shopping: deal details",
          page_channel: "shopping",
          page_master_tab: "personal",
          sales_event: "view",
          sales_product_id: [(_props$activeContract7 = props.activeContract) === null || _props$activeContract7 === void 0 ? void 0 : _props$activeContract7.sku],
          sales_product_price: [(_props$activeContract8 = props.activeContract) === null || _props$activeContract8 === void 0 ? void 0 : _props$activeContract8.payment_terms],
          sales_product_quantity: [1],
          sales_order_discount: [(_props$activeContract9 = props.activeContract) === null || _props$activeContract9 === void 0 ? void 0 : _props$activeContract9.save_monthly_recurring],
          sales_promo_name: [(_props$activeContract10 = props.activeContract) === null || _props$activeContract10 === void 0 ? void 0 : _props$activeContract10.promotion_tag_label]
        }, userMetaData), section_lvls);

        if ((_props$activeContract11 = props.activeContract) !== null && _props$activeContract11 !== void 0 && _props$activeContract11.promotion_tag_label) {
          var _props$activeContract12;

          analyticsData.sales_promo_name = [(_props$activeContract12 = props.activeContract) === null || _props$activeContract12 === void 0 ? void 0 : _props$activeContract12.promotion_tag_label];
        }

        if ((props === null || props === void 0 ? void 0 : (_props$activeContract13 = props.activeContractValue) === null || _props$activeContract13 === void 0 ? void 0 : _props$activeContract13.promotion_tag_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER) {
          analyticsData.preorder_flag = "true";
        }

        if (((_props$activeContract14 = props.activeContract) === null || _props$activeContract14 === void 0 ? void 0 : (_props$activeContract15 = _props$activeContract14.stock_status) === null || _props$activeContract15 === void 0 ? void 0 : _props$activeContract15.toLowerCase()) === "out_of_stock") {
          analyticsData.page_tool_event = "use";
          analyticsData.page_tool_name = "shopping: devices: Deal details: out of stock";
        }

        analyticsData.out_of_stock = (_props$activeContract16 = props.activeContract) === null || _props$activeContract16 === void 0 ? void 0 : (_props$activeContract17 = _props$activeContract16.stock_status) === null || _props$activeContract17 === void 0 ? void 0 : _props$activeContract17.toLowerCase();
        (0,analyticsUtag/* view */.ei)(analyticsData);
        setAnalytics(true);
      }
    }
  }, [dynamicRoute, props.activeContract]);

  var goToDeals = function goToDeals() {
    (0,analyticsUtag/* link */.p4)({
      page_name: "shopping: deal details",
      link_type: "o",
      link_name: "shopping: deal details: error Browse all deals"
    });
    setLoadingState(true);
    router.push("".concat(shoppingUrlPrefix, "/deals")).then(function () {
      setLoadingState(false);
    });
  };

  function reducer(state, item) {
    if (item.length !== 0) {
      if (item.action === "add") {
        return [].concat((0,toConsumableArray/* default */.Z)(state), [item]);
      }

      var updatedVasList = state.filter(function (vasItem) {
        return vasItem.id !== (item === null || item === void 0 ? void 0 : item.id);
      });
      return updatedVasList;
    }

    return [];
  }

  var showModal = function showModal() {
    setShowModal(true);
  };

  var hideCndCModal = function hideCndCModal() {
    setShowModal(false);
  };

  var isVasloaded = function isVasloaded(isLoaded) {
    setVasAvailable(isLoaded);
  };

  var displaySnakbar = function displaySnakbar() {
    setShowSnackBar({
      visible: true,
      message: labels/* default.errorMessages.lbl_back_order_deal_unavailable */.Z.errorMessages.lbl_back_order_deal_unavailable
    });
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar({
      visible: false,
      message: ""
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [seoDetails && /*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* default */.Z, {
      metaTitle: seoDetails.metaTitle,
      title: seoDetails.metaTitle,
      content: seoDetails.metaDescription
    }), showError ? /*#__PURE__*/(0,jsx_runtime.jsx)(pageError/* default */.Z, {
      className: "not-found",
      heading: labels/* default.lbl_menu_top.lbl_deal_404_heading */.Z.lbl_menu_top.lbl_deal_404_heading,
      description: labels/* default.lbl_menu_top.lbl_deal_404_description */.Z.lbl_menu_top.lbl_deal_404_description,
      primaryLabel: "Browse all deals",
      handlePrimaryClick: goToDeals,
      imgUrl: "".concat(imagePrefix, "/assets/images/search-not-found.svg")
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(VasContext/* default.Provider */.Z.Provider, {
      value: vasProviderValue,
      children: [(showSnackBar === null || showSnackBar === void 0 ? void 0 : showSnackBar.visible) && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTooltip/* default */.Z, {
        errorMsg: showSnackBar === null || showSnackBar === void 0 ? void 0 : showSnackBar.message,
        buttonHandler: closeSnackBar,
        setFixedTop: props.isMiniApp
      }), props.activeContract && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
        className: "deal-detail-page",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ClickAndCollectModal/* default */.Z, {
          sku: props.activeContract.primary_product_sku,
          isModalOpen: isModalOpen,
          hideModal: hideCndCModal,
          storeAddress: storeAddress,
          geoLocationIsAllowed: (_props$geoLocation = props.geoLocation) === null || _props$geoLocation === void 0 ? void 0 : _props$geoLocation.allowed,
          selectedStore: selectedStoreDetails
        }), vasList.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(dealDetailsHeader_DealDetailsHeader, {
          productName: "Deal details & add-ons"
        }), vasList.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(dealDetailsHeader_DealDetailsHeader, {
          productName: "Deal details"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dealDetailsBody_DealDetailsBody, {
          handleContract: function handleContract(id) {
            return handleActiveContract(id);
          },
          urlQuery: props === null || props === void 0 ? void 0 : props.query,
          isDealDetailPage: true,
          dealCategoryId: props === null || props === void 0 ? void 0 : props.dealCategoryId,
          onShowModalStores: showModal,
          lowCompLaod: lowCompLaod,
          geoLocationIsAllowed: (_props$geoLocation2 = props.geoLocation) === null || _props$geoLocation2 === void 0 ? void 0 : _props$geoLocation2.allowed,
          nearestStore: nearestStore,
          isStoreStockServiceDown: serviceDown,
          isVasloaded: isVasloaded,
          isCandCEligible: isClickAndCollectEligible,
          backOderDealUnavailable: displaySnakbar
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DealDetailFooterTop, {
          isSim: isSim
        }), (((_props$similarDeals = props.similarDeals) === null || _props$similarDeals === void 0 ? void 0 : _props$similarDeals.length) > 0 || ((_props$relatedDeals = props.relatedDeals) === null || _props$relatedDeals === void 0 ? void 0 : _props$relatedDeals.length) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)(DealDetailFooterBottom, {})]
      })]
    })]
  });
}; // function addObjectKeysToUrl(baseString, obj) {
//   const searchParams = new URLSearchParams();
//   for (const [key, value] of Object.entries(obj)) {
//     if(['id', 'contractSkus'].includes(key)) {
//       continue
//     }
//     searchParams.append(key, value);
//   }
//   const queryString = searchParams.toString();
//   const connector = baseString.includes('?') ? '&' : '?';
//   return queryString ? `${baseString}${connector}${queryString}` : baseString;
// }


var _id_mapStateToProps = function mapStateToProps(state) {
  return {
    activeContract: state.dealDetails.selectedDealDetails,
    features: state.common.features,
    dealList: state.dealDetails.dealList,
    similarDeals: state.dealDetails.similarDeals,
    relatedDeals: state.dealDetails.relatedDeals,
    geoLocation: state.geoLocation,
    isMiniApp: state.navDetails.isMiniApp,
    primaryProduct: state.dealDetails.primaryProduct,
    profileData: state.navDetails.profileData,
    userLoggedIn: state.navDetails.isUserLoggedIn
  };
};

var _id_mapDispatchToProps = {
  setHelpLeadBucket: getHelpAction/* setHelpLeadBucket */.A,
  getAndSetDealDetails: dealDetailsAction/* getAndSetDealDetails */.NB,
  updateSelectedDealDetail: dealDetailsAction/* updateSelectedDealDetail */.rv,
  checkFeatures: commonAction/* checkFeatures */.k
};
var __N_SSP = true;
/* harmony default export */ var _id_ = ((0,es/* connect */.$j)(_id_mapStateToProps, _id_mapDispatchToProps)(DealDetailsPage));

/***/ }),

/***/ 74425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ breadcrumbGenerator; }
/* harmony export */ });
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);



var breadcrumbGenerator = function breadcrumbGenerator(customBreadcrumb) {
  var _labels$Session_Keys, _getSessionStorage$, _labels$Session_Keys2;

  var productlistfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys === void 0 ? void 0 : _labels$Session_Keys.lbl_list_page_router_with_filters) ? (_getSessionStorage$ = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys2 = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys2 === void 0 ? void 0 : _labels$Session_Keys2.lbl_list_page_router_with_filters)[0]) === null || _getSessionStorage$ === void 0 ? void 0 : _getSessionStorage$.products : "/shopping/products";
  var dealfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") ? (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") : "/shopping/deals";
  var router = (0,_components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var breadcrumbconfig = {
    productlist: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/products",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }],
    cmsPage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.link,
      label: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.label
    }],
    productdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }],
    productcompare: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-compare",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_compare_products */ .Z.BreadCrumbLabels.lbl_compare_products
    }],
    deals: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }],
    dealdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }, {
      link: "/shopping/deal-details-page/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_deal_details */ .Z.BreadCrumbLabels.lbl_deal_details
    }],
    dealselection: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/".concat(router.query.id),
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }, {
      link: "/shopping/deal-selection",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lbl_select_deal */ .Z.lbl_select_deal
    }],
    orderhistory: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }],
    orderdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/view-order-details",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_details */ .Z.BreadCrumbLabels.lbl_order_details
    }],
    trackorder: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/track-my-order",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_track_order */ .Z.BreadCrumbLabels.lbl_track_order
    }],
    upgradePage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/upgrade",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_upgrade_page */ .Z.BreadCrumbLabels.lbl_upgrade_page
    }]
  };
  return breadcrumbconfig;
};

/***/ }),

/***/ 48036:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/deal-details-page/[id]",
      function () {
        return __webpack_require__(73742);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"BreadCrumb_p-xxs__heuAZ","pl-xxs":"BreadCrumb_pl-xxs__Pq2yx","pr-xxs":"BreadCrumb_pr-xxs__LOdz9","pb-xxs":"BreadCrumb_pb-xxs__dYHA5","pt-xxs":"BreadCrumb_pt-xxs__I5eh2","m-xxs":"BreadCrumb_m-xxs__BV_wk","ml-xxs":"BreadCrumb_ml-xxs__AFLMm","mr-xxs":"BreadCrumb_mr-xxs__PCCSC","mb-xxs":"BreadCrumb_mb-xxs__afj_v","mt-xxs":"BreadCrumb_mt-xxs__hsFq1","px-xxs":"BreadCrumb_px-xxs__JeufQ","mx-xxs":"BreadCrumb_mx-xxs__6nDs8","my-xxs":"BreadCrumb_my-xxs__ExH3B","py-xxs":"BreadCrumb_py-xxs___yoiL","font-size-xxs":"BreadCrumb_font-size-xxs__G3b3k","p-xs":"BreadCrumb_p-xs__Ydf2v","pl-xs":"BreadCrumb_pl-xs__4KFtt","pr-xs":"BreadCrumb_pr-xs__j5LDB","pb-xs":"BreadCrumb_pb-xs__r7wlS","pt-xs":"BreadCrumb_pt-xs__lYyC_","m-xs":"BreadCrumb_m-xs__kqGup","ml-xs":"BreadCrumb_ml-xs__9fxNn","mr-xs":"BreadCrumb_mr-xs__MnHIX","mb-xs":"BreadCrumb_mb-xs__2kV_4","mt-xs":"BreadCrumb_mt-xs__TWQWC","px-xs":"BreadCrumb_px-xs__POnB8","mx-xs":"BreadCrumb_mx-xs__NWC0P","my-xs":"BreadCrumb_my-xs__Ov9pH","py-xs":"BreadCrumb_py-xs__6k99w","font-size-xs":"BreadCrumb_font-size-xs__TDTVR","p-ss":"BreadCrumb_p-ss__8nenT","pl-ss":"BreadCrumb_pl-ss__E6s6_","pr-ss":"BreadCrumb_pr-ss__bDcG5","pb-ss":"BreadCrumb_pb-ss__J6_Jj","pt-ss":"BreadCrumb_pt-ss__V9sXm","m-ss":"BreadCrumb_m-ss__MksLc","ml-ss":"BreadCrumb_ml-ss__IgrfK","mr-ss":"BreadCrumb_mr-ss__NBuN5","mb-ss":"BreadCrumb_mb-ss__eXzqE","mt-ss":"BreadCrumb_mt-ss__RtZGW","px-ss":"BreadCrumb_px-ss__iSdiI","mx-ss":"BreadCrumb_mx-ss__gmV4s","my-ss":"BreadCrumb_my-ss__vBgaK","py-ss":"BreadCrumb_py-ss__6S3aJ","font-size-ss":"BreadCrumb_font-size-ss__8a9R5","p-ms":"BreadCrumb_p-ms__ekoV9","pl-ms":"BreadCrumb_pl-ms__D7tmj","pr-ms":"BreadCrumb_pr-ms__e2sRD","pb-ms":"BreadCrumb_pb-ms__rnAj_","pt-ms":"BreadCrumb_pt-ms__ag7m4","m-ms":"BreadCrumb_m-ms__T9KF0","ml-ms":"BreadCrumb_ml-ms__5RRFE","mr-ms":"BreadCrumb_mr-ms__wfkjE","mb-ms":"BreadCrumb_mb-ms__NUSVf","mt-ms":"BreadCrumb_mt-ms__O7sWI","px-ms":"BreadCrumb_px-ms__4XByK","mx-ms":"BreadCrumb_mx-ms__Tnh9Z","my-ms":"BreadCrumb_my-ms__2jObH","py-ms":"BreadCrumb_py-ms__QLzHK","font-size-ms":"BreadCrumb_font-size-ms__Ii_oH","p-s":"BreadCrumb_p-s__Ao5TN","pl-s":"BreadCrumb_pl-s__kmzwv","pr-s":"BreadCrumb_pr-s__0GvID","pb-s":"BreadCrumb_pb-s__LMNvJ","pt-s":"BreadCrumb_pt-s__DN70M","m-s":"BreadCrumb_m-s__Gfub1","ml-s":"BreadCrumb_ml-s__T1n7a","mr-s":"BreadCrumb_mr-s__JM_qb","mb-s":"BreadCrumb_mb-s__Y9fra","mt-s":"BreadCrumb_mt-s__TgqdQ","px-s":"BreadCrumb_px-s__B4BJD","mx-s":"BreadCrumb_mx-s__ggx55","my-s":"BreadCrumb_my-s__VOnn0","py-s":"BreadCrumb_py-s__RJTVn","font-size-s":"BreadCrumb_font-size-s__OJxvW","p-m":"BreadCrumb_p-m__4jcNq","pl-m":"BreadCrumb_pl-m__qoFdT","pr-m":"BreadCrumb_pr-m__fCW0F","pb-m":"BreadCrumb_pb-m__4_21j","pt-m":"BreadCrumb_pt-m__1bU9M","m-m":"BreadCrumb_m-m__piMyJ","ml-m":"BreadCrumb_ml-m__oBCf_","mr-m":"BreadCrumb_mr-m__p9RbI","mb-m":"BreadCrumb_mb-m__W6HyL","mt-m":"BreadCrumb_mt-m__gibKu","px-m":"BreadCrumb_px-m__NFUVV","mx-m":"BreadCrumb_mx-m__ACbJ1","my-m":"BreadCrumb_my-m__IDE7l","py-m":"BreadCrumb_py-m__I1kXn","font-size-m":"BreadCrumb_font-size-m__5EbDy","p-l":"BreadCrumb_p-l___LdZT","pl-l":"BreadCrumb_pl-l__1c4Iu","pr-l":"BreadCrumb_pr-l__euf69","pb-l":"BreadCrumb_pb-l__naQqI","pt-l":"BreadCrumb_pt-l__2H63b","m-l":"BreadCrumb_m-l__LFNUk","ml-l":"BreadCrumb_ml-l__AUqRa","mr-l":"BreadCrumb_mr-l__d60lJ","mb-l":"BreadCrumb_mb-l__xoQ9d","mt-l":"BreadCrumb_mt-l__FpoKd","px-l":"BreadCrumb_px-l__R8GEA","mx-l":"BreadCrumb_mx-l__0zBpp","my-l":"BreadCrumb_my-l__tYR_K","py-l":"BreadCrumb_py-l__fWTn6","font-size-l":"BreadCrumb_font-size-l__kHO4q","p-xl":"BreadCrumb_p-xl__sVryE","pl-xl":"BreadCrumb_pl-xl__OKP64","pr-xl":"BreadCrumb_pr-xl__6IFNa","pb-xl":"BreadCrumb_pb-xl__WaJwF","pt-xl":"BreadCrumb_pt-xl__apbAF","m-xl":"BreadCrumb_m-xl__gKVFJ","ml-xl":"BreadCrumb_ml-xl__RboKO","mr-xl":"BreadCrumb_mr-xl__dpz2h","mb-xl":"BreadCrumb_mb-xl__uOh3J","mt-xl":"BreadCrumb_mt-xl__FFF7p","px-xl":"BreadCrumb_px-xl__ITzPQ","mx-xl":"BreadCrumb_mx-xl__x7GK3","my-xl":"BreadCrumb_my-xl__2QEJ2","py-xl":"BreadCrumb_py-xl__bNH7S","font-size-xl":"BreadCrumb_font-size-xl__QyImp","p-xxl":"BreadCrumb_p-xxl__5ZYd6","pl-xxl":"BreadCrumb_pl-xxl__TlpF5","pr-xxl":"BreadCrumb_pr-xxl__Jw5VV","pb-xxl":"BreadCrumb_pb-xxl__6i7kj","pt-xxl":"BreadCrumb_pt-xxl__s5KBw","m-xxl":"BreadCrumb_m-xxl__whIb2","ml-xxl":"BreadCrumb_ml-xxl__kkiO1","mr-xxl":"BreadCrumb_mr-xxl__Rqk9w","mb-xxl":"BreadCrumb_mb-xxl__UvCHx","mt-xxl":"BreadCrumb_mt-xxl__3CXiR","px-xxl":"BreadCrumb_px-xxl__t2uey","mx-xxl":"BreadCrumb_mx-xxl__72iew","my-xxl":"BreadCrumb_my-xxl__xu_qX","py-xxl":"BreadCrumb_py-xxl__KknxS","font-size-xxl":"BreadCrumb_font-size-xxl__l_W0q","overflow-hidden":"BreadCrumb_overflow-hidden__6Pek3","topMargin":"BreadCrumb_topMargin__h_vBW","breadcrumb-wrapper":"BreadCrumb_breadcrumb-wrapper__PXx8y","breadcrumb-list":"BreadCrumb_breadcrumb-list__bwQ2f","breadcrumb-item":"BreadCrumb_breadcrumb-item__8lNEe"};

/***/ }),

/***/ 44641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message-container":"VASMessage_message-container__cZpwX","message-title":"VASMessage_message-title__ZkGFu","open":"VASMessage_open__yKWcp","message-item":"VASMessage_message-item__eVfwg","message-description":"VASMessage_message-description__Zidpx","collapsed":"VASMessage_collapsed__wTcIv"};

/***/ }),

/***/ 11410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"color-swatch-container":"ColorSwatch_color-swatch-container__Z55XS","color-swatch-content":"ColorSwatch_color-swatch-content__z3Bt9","color-swatch-content--bottom":"ColorSwatch_color-swatch-content--bottom__r2mXm","color-swatch-content--right":"ColorSwatch_color-swatch-content--right__ChQhQ","swatch-color-title":"ColorSwatch_swatch-color-title__PEi34","swatch-color-label":"ColorSwatch_swatch-color-label__1irxc","color-swatch-group":"ColorSwatch_color-swatch-group__tS9pT","swatch-color-indicator":"ColorSwatch_swatch-color-indicator__SSoKZ","swatch-color-indicator--selected":"ColorSwatch_swatch-color-indicator--selected__Ve3Wh","swatch-color-indicator--notice":"ColorSwatch_swatch-color-indicator--notice__qCXUO","swatch-color-indicator--notice--error":"ColorSwatch_swatch-color-indicator--notice--error__XN9Nb","swatch-color-indicator--notice--success":"ColorSwatch_swatch-color-indicator--notice--success___GrH5","swatch-color-indicator--notice--warning":"ColorSwatch_swatch-color-indicator--notice--warning___mzIZ","swatch-color-indicator-pill":"ColorSwatch_swatch-color-indicator-pill__WGKzB","swatch-color-indicator-rounded":"ColorSwatch_swatch-color-indicator-rounded___I_Jj","swatch-color-icon":"ColorSwatch_swatch-color-icon__gO6eK","swatch-notification":"ColorSwatch_swatch-notification__GdYyx","swatch-notification-label":"ColorSwatch_swatch-notification-label__ZFO54","swatch-notification-error":"ColorSwatch_swatch-notification-error___7M_Z","swatch-notification-success":"ColorSwatch_swatch-notification-success__mXiNh","swatch-notification-warning":"ColorSwatch_swatch-notification-warning__NbuGj","swatch-notification-icon":"ColorSwatch_swatch-notification-icon__uR0Ny"};

/***/ }),

/***/ 83984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"brand-label":"DealDetailsHeader_brand-label__3Ptu6","brand-label-divider":"DealDetailsHeader_brand-label-divider__vp_6q","product-details-heading":"DealDetailsHeader_product-details-heading__evRaW"};

/***/ }),

/***/ 35347:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promotion":"dealDetailsPromotions_promotion__VnzbR","promotion__tag":"dealDetailsPromotions_promotion__tag___H_Zi","promotion__description":"dealDetailsPromotions_promotion__description__Runz_","description_font":"dealDetailsPromotions_description_font___fC43","promotion__description__link":"dealDetailsPromotions_promotion__description__link___X8XY","product-details-bottom-hr":"dealDetailsPromotions_product-details-bottom-hr__ebRLo"};

/***/ }),

/***/ 10932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"svgWithText_p-xxs__IX84o","pl-xxs":"svgWithText_pl-xxs__N3c3y","pr-xxs":"svgWithText_pr-xxs__5nAaV","pb-xxs":"svgWithText_pb-xxs__zxgzh","pt-xxs":"svgWithText_pt-xxs__U5Hkl","m-xxs":"svgWithText_m-xxs__yR8kx","ml-xxs":"svgWithText_ml-xxs__j5KSn","mr-xxs":"svgWithText_mr-xxs__rdaiI","mb-xxs":"svgWithText_mb-xxs___Qzvp","mt-xxs":"svgWithText_mt-xxs__RCktk","px-xxs":"svgWithText_px-xxs__tEkHU","mx-xxs":"svgWithText_mx-xxs__aYzm5","my-xxs":"svgWithText_my-xxs__A6obE","py-xxs":"svgWithText_py-xxs__RrmsO","font-size-xxs":"svgWithText_font-size-xxs__p9KNi","p-xs":"svgWithText_p-xs__ULGEy","pl-xs":"svgWithText_pl-xs__vgLH2","pr-xs":"svgWithText_pr-xs__EI2Gy","pb-xs":"svgWithText_pb-xs__kfS6c","pt-xs":"svgWithText_pt-xs__VeocM","m-xs":"svgWithText_m-xs__YWQGz","ml-xs":"svgWithText_ml-xs__mjmWH","mr-xs":"svgWithText_mr-xs__pQm4B","mb-xs":"svgWithText_mb-xs__QGZTb","mt-xs":"svgWithText_mt-xs__mjbRA","px-xs":"svgWithText_px-xs__SIryo","mx-xs":"svgWithText_mx-xs__bEmhs","my-xs":"svgWithText_my-xs__BSn2t","py-xs":"svgWithText_py-xs___0WoX","font-size-xs":"svgWithText_font-size-xs__tIJ0G","p-ss":"svgWithText_p-ss__qhKA4","pl-ss":"svgWithText_pl-ss__xLorc","pr-ss":"svgWithText_pr-ss__z_KjQ","pb-ss":"svgWithText_pb-ss__8pHWJ","pt-ss":"svgWithText_pt-ss__XGe3i","m-ss":"svgWithText_m-ss__qGQnP","ml-ss":"svgWithText_ml-ss___Suwg","mr-ss":"svgWithText_mr-ss__mZvor","mb-ss":"svgWithText_mb-ss__hC5ar","mt-ss":"svgWithText_mt-ss__uE6F6","px-ss":"svgWithText_px-ss__HONkG","mx-ss":"svgWithText_mx-ss__koIrv","my-ss":"svgWithText_my-ss__sx7Co","py-ss":"svgWithText_py-ss__Q5_ZE","font-size-ss":"svgWithText_font-size-ss__wQuHt","p-ms":"svgWithText_p-ms__MNPjk","pl-ms":"svgWithText_pl-ms__DgQ8L","pr-ms":"svgWithText_pr-ms__ygF4L","pb-ms":"svgWithText_pb-ms__iunIn","pt-ms":"svgWithText_pt-ms__7iApa","m-ms":"svgWithText_m-ms__RF4yK","ml-ms":"svgWithText_ml-ms__TaTzv","mr-ms":"svgWithText_mr-ms__uFxA9","mb-ms":"svgWithText_mb-ms__qN5fm","mt-ms":"svgWithText_mt-ms__DojIH","px-ms":"svgWithText_px-ms__6rSMd","mx-ms":"svgWithText_mx-ms__unQDZ","my-ms":"svgWithText_my-ms__WeH4e","py-ms":"svgWithText_py-ms__rBvAS","font-size-ms":"svgWithText_font-size-ms__AIUm5","p-s":"svgWithText_p-s__LZNOZ","pl-s":"svgWithText_pl-s___d_Yj","pr-s":"svgWithText_pr-s__dqgdX","pb-s":"svgWithText_pb-s__4UJgK","pt-s":"svgWithText_pt-s__uTx9e","m-s":"svgWithText_m-s__e02gG","ml-s":"svgWithText_ml-s__HQ_U5","mr-s":"svgWithText_mr-s__t1OM_","mb-s":"svgWithText_mb-s__8HfTp","mt-s":"svgWithText_mt-s__YzoCa","px-s":"svgWithText_px-s__CX118","mx-s":"svgWithText_mx-s__46nFf","my-s":"svgWithText_my-s__icl5x","py-s":"svgWithText_py-s__24zCg","font-size-s":"svgWithText_font-size-s__VUkvp","p-m":"svgWithText_p-m__g09e_","pl-m":"svgWithText_pl-m__fWcON","pr-m":"svgWithText_pr-m__rF9uq","pb-m":"svgWithText_pb-m__1pxOb","pt-m":"svgWithText_pt-m___WifG","m-m":"svgWithText_m-m__5Kcp6","ml-m":"svgWithText_ml-m__3XoQL","mr-m":"svgWithText_mr-m__kh5Zy","mb-m":"svgWithText_mb-m__cHzTJ","mt-m":"svgWithText_mt-m__mDogo","px-m":"svgWithText_px-m__h2x2m","mx-m":"svgWithText_mx-m__fLZKZ","my-m":"svgWithText_my-m__a_1Yz","py-m":"svgWithText_py-m__m8yO8","font-size-m":"svgWithText_font-size-m__lVl6O","p-l":"svgWithText_p-l__kuECh","pl-l":"svgWithText_pl-l__78r7o","pr-l":"svgWithText_pr-l__8xfRC","pb-l":"svgWithText_pb-l__wfQ94","pt-l":"svgWithText_pt-l__YDt6n","m-l":"svgWithText_m-l__0sq_r","ml-l":"svgWithText_ml-l__o9sT1","mr-l":"svgWithText_mr-l__y3Bxn","mb-l":"svgWithText_mb-l__cWKym","mt-l":"svgWithText_mt-l__tnd3t","px-l":"svgWithText_px-l__RGrJ6","mx-l":"svgWithText_mx-l__O7l7V","my-l":"svgWithText_my-l___AEjw","py-l":"svgWithText_py-l___UCBC","font-size-l":"svgWithText_font-size-l__Q2lKx","p-xl":"svgWithText_p-xl__V2mY5","pl-xl":"svgWithText_pl-xl__FFg8O","pr-xl":"svgWithText_pr-xl__IdVyR","pb-xl":"svgWithText_pb-xl__5U6BL","pt-xl":"svgWithText_pt-xl__nG3AU","m-xl":"svgWithText_m-xl__6UgC8","ml-xl":"svgWithText_ml-xl__rwiR6","mr-xl":"svgWithText_mr-xl__d8OMF","mb-xl":"svgWithText_mb-xl__2Pdwm","mt-xl":"svgWithText_mt-xl__FwsU0","px-xl":"svgWithText_px-xl__aCi2O","mx-xl":"svgWithText_mx-xl__pZ5d0","my-xl":"svgWithText_my-xl__IObiP","py-xl":"svgWithText_py-xl__fLYvg","font-size-xl":"svgWithText_font-size-xl__932_Z","p-xxl":"svgWithText_p-xxl__6qsO1","pl-xxl":"svgWithText_pl-xxl__hYN4c","pr-xxl":"svgWithText_pr-xxl__OtXT4","pb-xxl":"svgWithText_pb-xxl__qAxwO","pt-xxl":"svgWithText_pt-xxl__OwrG4","m-xxl":"svgWithText_m-xxl__nSn7b","ml-xxl":"svgWithText_ml-xxl__y4m_5","mr-xxl":"svgWithText_mr-xxl__k2NiM","mb-xxl":"svgWithText_mb-xxl__XmRET","mt-xxl":"svgWithText_mt-xxl__wPxNp","px-xxl":"svgWithText_px-xxl__RfL9d","mx-xxl":"svgWithText_mx-xxl__1UaD9","my-xxl":"svgWithText_my-xxl__BsKW5","py-xxl":"svgWithText_py-xxl__bWYFF","font-size-xxl":"svgWithText_font-size-xxl__BVFWp","overflow-hidden":"svgWithText_overflow-hidden__hkKI3","topMargin":"svgWithText_topMargin__U8Spg","detail-container":"svgWithText_detail-container__rd8i4","svg-icon":"svgWithText_svg-icon__cXXrz","value":"svgWithText_value__pHw39","type":"svgWithText_type__NZo8m","description":"svgWithText_description__6C3Tt"};

/***/ }),

/***/ 8247:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-modal1":"UnaffordableAlertModal_upgrade-modal1__XsJOV","upgrade-modal1-continue":"UnaffordableAlertModal_upgrade-modal1-continue__MYOyt","close-button":"UnaffordableAlertModal_close-button__w8QPO","upgrade-modal1-submit-otp":"UnaffordableAlertModal_upgrade-modal1-submit-otp__ZVXwh","modal-header":"UnaffordableAlertModal_modal-header__h2NKU","modal-body":"UnaffordableAlertModal_modal-body__bbSF5","select-number-form":"UnaffordableAlertModal_select-number-form__nXeto","num-3":"UnaffordableAlertModal_num-3__KzkMI","num-4":"UnaffordableAlertModal_num-4__qFCb7","singleNumber":"UnaffordableAlertModal_singleNumber__6GCSV","selctedNumber":"UnaffordableAlertModal_selctedNumber__RT5hJ","re-send-otp-btn":"UnaffordableAlertModal_re-send-otp-btn__et66L","upgrade-btn-submit-otp":"UnaffordableAlertModal_upgrade-btn-submit-otp__E4B6y","upgradeComponent":"UnaffordableAlertModal_upgradeComponent__27Uzq","icon":"UnaffordableAlertModal_icon__xo1Ue","title":"UnaffordableAlertModal_title__bj38g","description":"UnaffordableAlertModal_description__c4Lx4","infoText":"UnaffordableAlertModal_infoText__ZJSne","inputTitle":"UnaffordableAlertModal_inputTitle__VQCAW","input-box":"UnaffordableAlertModal_input-box__PTsNK","invalid":"UnaffordableAlertModal_invalid__Ikenb","checkboxContainer":"UnaffordableAlertModal_checkboxContainer__Nu4go","checkboxText":"UnaffordableAlertModal_checkboxText__lEg7I","otpInput":"UnaffordableAlertModal_otpInput__rAmov","buttonContainer":"UnaffordableAlertModal_buttonContainer__Zjevg","otp-tick-img":"UnaffordableAlertModal_otp-tick-img__SyY3h","invalid-feedback":"UnaffordableAlertModal_invalid-feedback__mvTLO","addnlInfo":"UnaffordableAlertModal_addnlInfo__VjEBZ","upgrade-continue":"UnaffordableAlertModal_upgrade-continue__hF7Zp","upgrade-btn-continue":"UnaffordableAlertModal_upgrade-btn-continue__fPuTo","big-margin-bottom":"UnaffordableAlertModal_big-margin-bottom__7ICUO","medium-margin-bottom":"UnaffordableAlertModal_medium-margin-bottom__SQtOZ","buttonContainerOTP":"UnaffordableAlertModal_buttonContainerOTP__aQMpN","otpContainer":"UnaffordableAlertModal_otpContainer__FMu8F","wrap-numbers":"UnaffordableAlertModal_wrap-numbers__lTE35","inputContainer":"UnaffordableAlertModal_inputContainer__IAyGd","mobileNumbers":"UnaffordableAlertModal_mobileNumbers__md79w"};

/***/ }),

/***/ 9161:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"no-products":"DealDetailFooterBottom_no-products__nDVh2","tab-link":"DealDetailFooterBottom_tab-link__EpRMX","nav-tabs":"DealDetailFooterBottom_nav-tabs__GZ607","nav-line-seperator":"DealDetailFooterBottom_nav-line-seperator__HPwIl","tab-content":"DealDetailFooterBottom_tab-content__SRuCn","tabs-design":"DealDetailFooterBottom_tabs-design___sLil","tabs-design__nav":"DealDetailFooterBottom_tabs-design__nav__7CkH6","tab-link--active":"DealDetailFooterBottom_tab-link--active__m_FCK","heading":"DealDetailFooterBottom_heading__BgGy_","paragraph":"DealDetailFooterBottom_paragraph__i7_y2","footer-product-container":"DealDetailFooterBottom_footer-product-container__HVs6Z","footer-product-divder":"DealDetailFooterBottom_footer-product-divder__n3ik5"};

/***/ }),

/***/ 2060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab-content":"DealListCarousel_tab-content__vnVKU","deals-wrapper":"DealListCarousel_deals-wrapper__1FyLd","deals-container":"DealListCarousel_deals-container__uK24v","deal":"DealListCarousel_deal__h20mv","carousel-arrow--left":"DealListCarousel_carousel-arrow--left__4dKgK","carousel-arrow--right":"DealListCarousel_carousel-arrow--right__ChVQo"};

/***/ }),

/***/ 55074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab-link":"DealDetailFooterTop_tab-link__OlECH","tab-link--active":"DealDetailFooterTop_tab-link--active__L2dEX","tab-content":"DealDetailFooterTop_tab-content__NukqE","deal-detail-wrapper":"DealDetailFooterTop_deal-detail-wrapper__Yst2o","product-indicator-container":"DealDetailFooterTop_product-indicator-container__ujirB","deal-detail-nav-container":"DealDetailFooterTop_deal-detail-nav-container__cS1Tn","details-sub-header-one":"DealDetailFooterTop_details-sub-header-one__gnWiq","details-sub-header-two":"DealDetailFooterTop_details-sub-header-two___YXMk","deal-details-link":"DealDetailFooterTop_deal-details-link__s3y8j","details-deal-sub-section":"DealDetailFooterTop_details-deal-sub-section__ZzCGn","details-section-row":"DealDetailFooterTop_details-section-row__tgqI4","details-value":"DealDetailFooterTop_details-value__G4y0t","details-label":"DealDetailFooterTop_details-label__Ymvp3","nav-tabs":"DealDetailFooterTop_nav-tabs__J3b_Y","delivery-text":"DealDetailFooterTop_delivery-text__x9iGN","nav-line-seperator":"DealDetailFooterTop_nav-line-seperator__RIDHb","description":"DealDetailFooterTop_description__huiEK","title":"DealDetailFooterTop_title__Z37hg","tool-tip":"DealDetailFooterTop_tool-tip__88sjG","sub-section-mobile-styling":"DealDetailFooterTop_sub-section-mobile-styling__WbsJk","line-seperator":"DealDetailFooterTop_line-seperator__TWpwc","deal-list-container":"DealDetailFooterTop_deal-list-container__t0Fmp","deal-list-item":"DealDetailFooterTop_deal-list-item__Vurbl"};

/***/ }),

/***/ 73178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addOns":"AddOns_addOns__KIk7K","addOns-grey":"AddOns_addOns-grey__1wYaw","divider":"AddOns_divider__ahAJZ","vasContainer":"AddOns_vasContainer__0lEQQ"};

/***/ }),

/***/ 46271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"DealDetailSummary_p-xxs__9H2_o","pl-xxs":"DealDetailSummary_pl-xxs__iEjlO","pr-xxs":"DealDetailSummary_pr-xxs__QMc6V","pb-xxs":"DealDetailSummary_pb-xxs__hukBB","pt-xxs":"DealDetailSummary_pt-xxs__QcYCo","m-xxs":"DealDetailSummary_m-xxs__wsMSC","ml-xxs":"DealDetailSummary_ml-xxs__W0tE_","mr-xxs":"DealDetailSummary_mr-xxs__T6H2m","mb-xxs":"DealDetailSummary_mb-xxs__Gxzyo","mt-xxs":"DealDetailSummary_mt-xxs__NvJy1","px-xxs":"DealDetailSummary_px-xxs__t8CQK","mx-xxs":"DealDetailSummary_mx-xxs__EMjiC","my-xxs":"DealDetailSummary_my-xxs__GBi_A","py-xxs":"DealDetailSummary_py-xxs__yCzBj","font-size-xxs":"DealDetailSummary_font-size-xxs__dRQbl","p-xs":"DealDetailSummary_p-xs__vCaMq","pl-xs":"DealDetailSummary_pl-xs__taKIX","pr-xs":"DealDetailSummary_pr-xs__AYLMX","pb-xs":"DealDetailSummary_pb-xs__HRnaE","pt-xs":"DealDetailSummary_pt-xs__gH9w5","m-xs":"DealDetailSummary_m-xs__4gxfs","ml-xs":"DealDetailSummary_ml-xs__d_tHq","mr-xs":"DealDetailSummary_mr-xs__Bqlau","mb-xs":"DealDetailSummary_mb-xs__hlr7y","mt-xs":"DealDetailSummary_mt-xs___E2rz","px-xs":"DealDetailSummary_px-xs__ne5HY","mx-xs":"DealDetailSummary_mx-xs__Ugur9","my-xs":"DealDetailSummary_my-xs__W4dCe","py-xs":"DealDetailSummary_py-xs__d2hxH","font-size-xs":"DealDetailSummary_font-size-xs__PY2LA","p-ss":"DealDetailSummary_p-ss__McvSx","pl-ss":"DealDetailSummary_pl-ss__OaHum","pr-ss":"DealDetailSummary_pr-ss__HVcBE","pb-ss":"DealDetailSummary_pb-ss__4Z5HB","pt-ss":"DealDetailSummary_pt-ss__QwFK4","m-ss":"DealDetailSummary_m-ss__cE3z7","ml-ss":"DealDetailSummary_ml-ss__c9NTQ","mr-ss":"DealDetailSummary_mr-ss__lvE8q","mb-ss":"DealDetailSummary_mb-ss__5NK5y","mt-ss":"DealDetailSummary_mt-ss__LkZ0X","px-ss":"DealDetailSummary_px-ss__SdNLd","mx-ss":"DealDetailSummary_mx-ss__Knm3_","my-ss":"DealDetailSummary_my-ss__qUrkJ","py-ss":"DealDetailSummary_py-ss__8mbNU","font-size-ss":"DealDetailSummary_font-size-ss__uaJgR","p-ms":"DealDetailSummary_p-ms__CFeEV","pl-ms":"DealDetailSummary_pl-ms__vRS9M","pr-ms":"DealDetailSummary_pr-ms__lAGxq","pb-ms":"DealDetailSummary_pb-ms__WnkS4","pt-ms":"DealDetailSummary_pt-ms__lgy2c","m-ms":"DealDetailSummary_m-ms__9oYSC","ml-ms":"DealDetailSummary_ml-ms__rm2PH","mr-ms":"DealDetailSummary_mr-ms__G2quk","mb-ms":"DealDetailSummary_mb-ms__BQ6My","mt-ms":"DealDetailSummary_mt-ms__Uo9Br","px-ms":"DealDetailSummary_px-ms__oALMh","mx-ms":"DealDetailSummary_mx-ms__wg3CX","my-ms":"DealDetailSummary_my-ms__0Xw_b","py-ms":"DealDetailSummary_py-ms__oCTrd","font-size-ms":"DealDetailSummary_font-size-ms__n2kkx","p-s":"DealDetailSummary_p-s__eq7tA","pl-s":"DealDetailSummary_pl-s__BzqS3","pr-s":"DealDetailSummary_pr-s__2Ilyw","pb-s":"DealDetailSummary_pb-s__V_8k1","pt-s":"DealDetailSummary_pt-s__lYJ_Q","m-s":"DealDetailSummary_m-s__Irg3h","ml-s":"DealDetailSummary_ml-s__5Mqok","mr-s":"DealDetailSummary_mr-s__7I3en","mb-s":"DealDetailSummary_mb-s__Moi4J","mt-s":"DealDetailSummary_mt-s__sKDvE","px-s":"DealDetailSummary_px-s__7oltO","mx-s":"DealDetailSummary_mx-s__AQOI2","my-s":"DealDetailSummary_my-s__PPThU","py-s":"DealDetailSummary_py-s__or_YY","font-size-s":"DealDetailSummary_font-size-s__WKT_H","p-m":"DealDetailSummary_p-m__MkWW3","pl-m":"DealDetailSummary_pl-m__HYJYd","pr-m":"DealDetailSummary_pr-m__OL6yP","pb-m":"DealDetailSummary_pb-m__POJ_Z","pt-m":"DealDetailSummary_pt-m__yECVT","m-m":"DealDetailSummary_m-m__Lrij_","ml-m":"DealDetailSummary_ml-m__eNLSa","mr-m":"DealDetailSummary_mr-m__OUsGk","mb-m":"DealDetailSummary_mb-m__YuY7F","mt-m":"DealDetailSummary_mt-m__ibo61","px-m":"DealDetailSummary_px-m__seID3","mx-m":"DealDetailSummary_mx-m__B5Cvr","my-m":"DealDetailSummary_my-m__wiL6c","py-m":"DealDetailSummary_py-m__DSvmm","font-size-m":"DealDetailSummary_font-size-m__8a9KN","p-l":"DealDetailSummary_p-l__ZMDUk","pl-l":"DealDetailSummary_pl-l__p18Fh","pr-l":"DealDetailSummary_pr-l__xZWCT","pb-l":"DealDetailSummary_pb-l__6HW0v","pt-l":"DealDetailSummary_pt-l__xvqLY","m-l":"DealDetailSummary_m-l___sgEh","ml-l":"DealDetailSummary_ml-l__QGuil","mr-l":"DealDetailSummary_mr-l__hGYIJ","mb-l":"DealDetailSummary_mb-l__nSfus","mt-l":"DealDetailSummary_mt-l__04EM1","px-l":"DealDetailSummary_px-l__uz4TO","mx-l":"DealDetailSummary_mx-l__ka1vw","my-l":"DealDetailSummary_my-l__BPR53","py-l":"DealDetailSummary_py-l__w2te3","font-size-l":"DealDetailSummary_font-size-l__5N_1r","p-xl":"DealDetailSummary_p-xl__gQi4N","pl-xl":"DealDetailSummary_pl-xl__uaGpB","pr-xl":"DealDetailSummary_pr-xl__4Nsvw","pb-xl":"DealDetailSummary_pb-xl__Wb8_5","pt-xl":"DealDetailSummary_pt-xl__QsYvb","m-xl":"DealDetailSummary_m-xl__sqHEf","ml-xl":"DealDetailSummary_ml-xl__CNA_O","mr-xl":"DealDetailSummary_mr-xl__gdXbC","mb-xl":"DealDetailSummary_mb-xl__5m8bI","mt-xl":"DealDetailSummary_mt-xl__13GN4","px-xl":"DealDetailSummary_px-xl__pcDja","mx-xl":"DealDetailSummary_mx-xl__fJ13b","my-xl":"DealDetailSummary_my-xl__1aC3_","py-xl":"DealDetailSummary_py-xl__rvOuj","font-size-xl":"DealDetailSummary_font-size-xl__fR_ae","p-xxl":"DealDetailSummary_p-xxl__7_cG_","pl-xxl":"DealDetailSummary_pl-xxl__gGKxQ","pr-xxl":"DealDetailSummary_pr-xxl__Z0yvD","pb-xxl":"DealDetailSummary_pb-xxl__4Z5og","pt-xxl":"DealDetailSummary_pt-xxl__OFkFe","m-xxl":"DealDetailSummary_m-xxl__8vJwS","ml-xxl":"DealDetailSummary_ml-xxl__fWHQY","mr-xxl":"DealDetailSummary_mr-xxl__EYbG6","mb-xxl":"DealDetailSummary_mb-xxl__foOE0","mt-xxl":"DealDetailSummary_mt-xxl__Jq_gT","px-xxl":"DealDetailSummary_px-xxl__4B2nx","mx-xxl":"DealDetailSummary_mx-xxl__vyM58","my-xxl":"DealDetailSummary_my-xxl__P24bj","py-xxl":"DealDetailSummary_py-xxl__AoX_Q","font-size-xxl":"DealDetailSummary_font-size-xxl__1ICtW","overflow-hidden":"DealDetailSummary_overflow-hidden__I4K1e","topMargin":"DealDetailSummary_topMargin__GUv40","review_block":"DealDetailSummary_review_block__NcvnA","review_block_title":"DealDetailSummary_review_block_title__69OSo","review_row":"DealDetailSummary_review_row__jE5CP","small_space_row":"DealDetailSummary_small_space_row__DCnXA","row_item":"DealDetailSummary_row_item__FPJTl","row_item_head":"DealDetailSummary_row_item_head__8vY45","row_item_price":"DealDetailSummary_row_item_price__MD3mT","add_on_delete":"DealDetailSummary_add_on_delete__ClOTa","action_row":"DealDetailSummary_action_row__wILxk"};

/***/ }),

/***/ 52857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"DealDetailsBody_p-xxs__ywDaY","pl-xxs":"DealDetailsBody_pl-xxs__LYsUj","pr-xxs":"DealDetailsBody_pr-xxs__UrKSB","pb-xxs":"DealDetailsBody_pb-xxs__4yj0C","pt-xxs":"DealDetailsBody_pt-xxs__HmYEc","m-xxs":"DealDetailsBody_m-xxs__2tClJ","ml-xxs":"DealDetailsBody_ml-xxs__T2ELZ","mr-xxs":"DealDetailsBody_mr-xxs__yFIXf","mb-xxs":"DealDetailsBody_mb-xxs__xu7SR","mt-xxs":"DealDetailsBody_mt-xxs__1F_qP","px-xxs":"DealDetailsBody_px-xxs__HvTa6","mx-xxs":"DealDetailsBody_mx-xxs__1lhLG","my-xxs":"DealDetailsBody_my-xxs__hnPe9","py-xxs":"DealDetailsBody_py-xxs__2U3fp","font-size-xxs":"DealDetailsBody_font-size-xxs__7vbvB","p-xs":"DealDetailsBody_p-xs__21dv6","pl-xs":"DealDetailsBody_pl-xs__mBA6d","pr-xs":"DealDetailsBody_pr-xs__6N5iL","pb-xs":"DealDetailsBody_pb-xs__RC7s5","pt-xs":"DealDetailsBody_pt-xs__SVwds","m-xs":"DealDetailsBody_m-xs__g6Lva","ml-xs":"DealDetailsBody_ml-xs__Mpt6k","mr-xs":"DealDetailsBody_mr-xs__rPQzC","mb-xs":"DealDetailsBody_mb-xs__3mfw3","mt-xs":"DealDetailsBody_mt-xs__ZpyZx","px-xs":"DealDetailsBody_px-xs__MFxO2","mx-xs":"DealDetailsBody_mx-xs__TsGYE","my-xs":"DealDetailsBody_my-xs__0Inpe","py-xs":"DealDetailsBody_py-xs__UA4tT","font-size-xs":"DealDetailsBody_font-size-xs__Gm4oj","p-ss":"DealDetailsBody_p-ss__7rj2d","pl-ss":"DealDetailsBody_pl-ss__fGxcC","pr-ss":"DealDetailsBody_pr-ss__bWsqC","pb-ss":"DealDetailsBody_pb-ss__qjl46","pt-ss":"DealDetailsBody_pt-ss__8osMJ","m-ss":"DealDetailsBody_m-ss__IV21z","ml-ss":"DealDetailsBody_ml-ss__v1iRa","mr-ss":"DealDetailsBody_mr-ss__BzN5X","mb-ss":"DealDetailsBody_mb-ss__eVlZN","mt-ss":"DealDetailsBody_mt-ss__KNqsa","px-ss":"DealDetailsBody_px-ss__Z9aMn","mx-ss":"DealDetailsBody_mx-ss__UKFF8","my-ss":"DealDetailsBody_my-ss__1jrl_","py-ss":"DealDetailsBody_py-ss__SFS0z","font-size-ss":"DealDetailsBody_font-size-ss__69Qqz","p-ms":"DealDetailsBody_p-ms__q7Rbd","pl-ms":"DealDetailsBody_pl-ms__P3Gg7","pr-ms":"DealDetailsBody_pr-ms__7uM_W","pb-ms":"DealDetailsBody_pb-ms__8hDfa","pt-ms":"DealDetailsBody_pt-ms__kX7lA","m-ms":"DealDetailsBody_m-ms__nkI96","ml-ms":"DealDetailsBody_ml-ms___Sy4g","mr-ms":"DealDetailsBody_mr-ms__v_kKm","mb-ms":"DealDetailsBody_mb-ms__EPLzd","mt-ms":"DealDetailsBody_mt-ms__aIOKl","px-ms":"DealDetailsBody_px-ms___f6KY","mx-ms":"DealDetailsBody_mx-ms__nKkP2","my-ms":"DealDetailsBody_my-ms__z6X_1","py-ms":"DealDetailsBody_py-ms__EgOr8","font-size-ms":"DealDetailsBody_font-size-ms__3ngRT","p-s":"DealDetailsBody_p-s__4ML7_","pl-s":"DealDetailsBody_pl-s__R7T3B","pr-s":"DealDetailsBody_pr-s__4UhTS","pb-s":"DealDetailsBody_pb-s__4G8cc","pt-s":"DealDetailsBody_pt-s__dHW02","m-s":"DealDetailsBody_m-s__U6qda","ml-s":"DealDetailsBody_ml-s__MDE6A","mr-s":"DealDetailsBody_mr-s__MRbIx","mb-s":"DealDetailsBody_mb-s__Bd9rj","mt-s":"DealDetailsBody_mt-s__lPN4J","px-s":"DealDetailsBody_px-s__PB5U_","mx-s":"DealDetailsBody_mx-s__iAV_A","my-s":"DealDetailsBody_my-s__YCo_c","py-s":"DealDetailsBody_py-s__iJsY8","font-size-s":"DealDetailsBody_font-size-s__T8c_g","p-m":"DealDetailsBody_p-m__jsJv1","pl-m":"DealDetailsBody_pl-m__3HfOe","pr-m":"DealDetailsBody_pr-m__L3vgy","pb-m":"DealDetailsBody_pb-m__6BOba","pt-m":"DealDetailsBody_pt-m__BLnLR","m-m":"DealDetailsBody_m-m__RvDNh","ml-m":"DealDetailsBody_ml-m__5W19t","mr-m":"DealDetailsBody_mr-m__xizO5","mb-m":"DealDetailsBody_mb-m__tL5o3","mt-m":"DealDetailsBody_mt-m__aQ_yE","px-m":"DealDetailsBody_px-m__FrrXC","mx-m":"DealDetailsBody_mx-m__JC1Eb","my-m":"DealDetailsBody_my-m__LJaaY","py-m":"DealDetailsBody_py-m__IDEfL","font-size-m":"DealDetailsBody_font-size-m__8Qk8_","p-l":"DealDetailsBody_p-l__GYTxk","pl-l":"DealDetailsBody_pl-l__1UYDc","pr-l":"DealDetailsBody_pr-l__x_Uqg","pb-l":"DealDetailsBody_pb-l__8Fl5n","pt-l":"DealDetailsBody_pt-l__6cuLa","m-l":"DealDetailsBody_m-l__bqHFI","ml-l":"DealDetailsBody_ml-l__v_1Xu","mr-l":"DealDetailsBody_mr-l__XZzeN","mb-l":"DealDetailsBody_mb-l__Suq2g","mt-l":"DealDetailsBody_mt-l__wljR9","px-l":"DealDetailsBody_px-l__OXA94","mx-l":"DealDetailsBody_mx-l__DrrYR","my-l":"DealDetailsBody_my-l__gud7e","py-l":"DealDetailsBody_py-l__87Grt","font-size-l":"DealDetailsBody_font-size-l__nY339","p-xl":"DealDetailsBody_p-xl__fn5BD","pl-xl":"DealDetailsBody_pl-xl__JBIFb","pr-xl":"DealDetailsBody_pr-xl__iffNk","pb-xl":"DealDetailsBody_pb-xl__ILBiV","pt-xl":"DealDetailsBody_pt-xl__86EwV","m-xl":"DealDetailsBody_m-xl__kCuHT","ml-xl":"DealDetailsBody_ml-xl__fvU_O","mr-xl":"DealDetailsBody_mr-xl__BFloN","mb-xl":"DealDetailsBody_mb-xl__X9rii","mt-xl":"DealDetailsBody_mt-xl__s__kX","px-xl":"DealDetailsBody_px-xl__mXd_7","mx-xl":"DealDetailsBody_mx-xl__UdOSj","my-xl":"DealDetailsBody_my-xl__GcqAl","py-xl":"DealDetailsBody_py-xl__HazJp","font-size-xl":"DealDetailsBody_font-size-xl__6vzUY","p-xxl":"DealDetailsBody_p-xxl__5uE78","pl-xxl":"DealDetailsBody_pl-xxl__WxhVk","pr-xxl":"DealDetailsBody_pr-xxl__YO3n4","pb-xxl":"DealDetailsBody_pb-xxl__Mwe9n","pt-xxl":"DealDetailsBody_pt-xxl__oPuEb","m-xxl":"DealDetailsBody_m-xxl__QDw9s","ml-xxl":"DealDetailsBody_ml-xxl__e3p4m","mr-xxl":"DealDetailsBody_mr-xxl__ezdTQ","mb-xxl":"DealDetailsBody_mb-xxl__5OOLQ","mt-xxl":"DealDetailsBody_mt-xxl__9q9E8","px-xxl":"DealDetailsBody_px-xxl__a2UIk","mx-xxl":"DealDetailsBody_mx-xxl__DbY1j","my-xxl":"DealDetailsBody_my-xxl__78EX8","py-xxl":"DealDetailsBody_py-xxl__0iOd1","font-size-xxl":"DealDetailsBody_font-size-xxl__FKDiM","overflow-hidden":"DealDetailsBody_overflow-hidden__MYXGC","topMargin":"DealDetailsBody_topMargin__rnPgA","loading_placeholder":"DealDetailsBody_loading_placeholder__2nZwR","animated-background":"DealDetailsBody_animated-background__MUypj","loadingplaceHolderShimmer":"DealDetailsBody_loadingplaceHolderShimmer__NBiZZ","banner":"DealDetailsBody_banner__cdN4U","banner__icon":"DealDetailsBody_banner__icon__oVcgS","indicators-section":"DealDetailsBody_indicators-section__FShCK","indicators-items":"DealDetailsBody_indicators-items__bL_Nu","msg-label":"DealDetailsBody_msg-label__VtspQ","section-divider":"DealDetailsBody_section-divider__KYw8P","product-details":"DealDetailsBody_product-details__PHNa6","snackBarSpacing":"DealDetailsBody_snackBarSpacing__9fDhK","wrapper-device":"DealDetailsBody_wrapper-device__CqlS8","wrapper":"DealDetailsBody_wrapper__8ekii","product-indicator-container":"DealDetailsBody_product-indicator-container__upcrR"};

/***/ }),

/***/ 79462:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"indicators-container":"dealDetailsIndicators_indicators-container__HCSQm","indicator-item":"dealDetailsIndicators_indicator-item__I_spF","deliveryReturn_section":"dealDetailsIndicators_deliveryReturn_section__8bTrQ","deliveryReturn_section--enhanced":"dealDetailsIndicators_deliveryReturn_section--enhanced__VDj2C","deliveryReturn_section--terms":"dealDetailsIndicators_deliveryReturn_section--terms__oFcp5","upgrade-indicator":"dealDetailsIndicators_upgrade-indicator___D85O"};

/***/ }),

/***/ 33240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"DealHighLights_p-xxs__skUmd","pl-xxs":"DealHighLights_pl-xxs__FrOlN","pr-xxs":"DealHighLights_pr-xxs__nB9ZS","pb-xxs":"DealHighLights_pb-xxs__1tTgk","pt-xxs":"DealHighLights_pt-xxs__hk9YT","m-xxs":"DealHighLights_m-xxs__y_W_V","ml-xxs":"DealHighLights_ml-xxs__bh7Kc","mr-xxs":"DealHighLights_mr-xxs__mZJ8y","mb-xxs":"DealHighLights_mb-xxs__lX_Xj","mt-xxs":"DealHighLights_mt-xxs__02_59","px-xxs":"DealHighLights_px-xxs__dVhVB","mx-xxs":"DealHighLights_mx-xxs__8sL34","my-xxs":"DealHighLights_my-xxs__BtTZq","py-xxs":"DealHighLights_py-xxs__68RwN","font-size-xxs":"DealHighLights_font-size-xxs__pee95","p-xs":"DealHighLights_p-xs__XWbQC","pl-xs":"DealHighLights_pl-xs__uDIK9","pr-xs":"DealHighLights_pr-xs__Tsdt_","pb-xs":"DealHighLights_pb-xs__Hlgvk","pt-xs":"DealHighLights_pt-xs__JB4jz","m-xs":"DealHighLights_m-xs__rUjBy","ml-xs":"DealHighLights_ml-xs__BGaR6","mr-xs":"DealHighLights_mr-xs__q_01_","mb-xs":"DealHighLights_mb-xs__lBSha","mt-xs":"DealHighLights_mt-xs__URDi5","px-xs":"DealHighLights_px-xs__3B8Pj","mx-xs":"DealHighLights_mx-xs__ZAR6E","my-xs":"DealHighLights_my-xs__fkVSR","py-xs":"DealHighLights_py-xs__HAFx3","font-size-xs":"DealHighLights_font-size-xs__yBslc","p-ss":"DealHighLights_p-ss__72MHC","pl-ss":"DealHighLights_pl-ss__KQMrU","pr-ss":"DealHighLights_pr-ss__Aij7X","pb-ss":"DealHighLights_pb-ss__ATxUd","pt-ss":"DealHighLights_pt-ss__TdhKa","m-ss":"DealHighLights_m-ss__YKRQx","ml-ss":"DealHighLights_ml-ss__nb1ec","mr-ss":"DealHighLights_mr-ss__cNHio","mb-ss":"DealHighLights_mb-ss__8QekE","mt-ss":"DealHighLights_mt-ss__u88eF","px-ss":"DealHighLights_px-ss__QfMIA","mx-ss":"DealHighLights_mx-ss__cdU_e","my-ss":"DealHighLights_my-ss__wzcTP","py-ss":"DealHighLights_py-ss__z8gVM","font-size-ss":"DealHighLights_font-size-ss__1V3rf","p-ms":"DealHighLights_p-ms__uYF0W","pl-ms":"DealHighLights_pl-ms__5IS8d","pr-ms":"DealHighLights_pr-ms__AVJ6h","pb-ms":"DealHighLights_pb-ms__eDEqH","pt-ms":"DealHighLights_pt-ms__MKZPj","m-ms":"DealHighLights_m-ms__BAmkx","ml-ms":"DealHighLights_ml-ms__DoLXM","mr-ms":"DealHighLights_mr-ms__4us_m","mb-ms":"DealHighLights_mb-ms__fQpBe","mt-ms":"DealHighLights_mt-ms__eA7eU","px-ms":"DealHighLights_px-ms__rZPGy","mx-ms":"DealHighLights_mx-ms__TgFWp","my-ms":"DealHighLights_my-ms__IKt2Z","py-ms":"DealHighLights_py-ms__p1_Zb","font-size-ms":"DealHighLights_font-size-ms__Efzsq","p-s":"DealHighLights_p-s__tliCr","pl-s":"DealHighLights_pl-s__ZlKjH","pr-s":"DealHighLights_pr-s__lBANF","pb-s":"DealHighLights_pb-s__pxo4F","pt-s":"DealHighLights_pt-s__P0N7d","m-s":"DealHighLights_m-s__daAcg","ml-s":"DealHighLights_ml-s__yyGe3","mr-s":"DealHighLights_mr-s__Xz_mc","mb-s":"DealHighLights_mb-s__rVNVu","mt-s":"DealHighLights_mt-s__78xz_","px-s":"DealHighLights_px-s__4e2_q","mx-s":"DealHighLights_mx-s__PW59T","my-s":"DealHighLights_my-s__bG_K8","py-s":"DealHighLights_py-s__JyH18","font-size-s":"DealHighLights_font-size-s__5_wnX","p-m":"DealHighLights_p-m__Fl1si","pl-m":"DealHighLights_pl-m__qPyJH","pr-m":"DealHighLights_pr-m__vATom","pb-m":"DealHighLights_pb-m__MmuMI","pt-m":"DealHighLights_pt-m__N732x","m-m":"DealHighLights_m-m__t3GbE","ml-m":"DealHighLights_ml-m__4N1oF","mr-m":"DealHighLights_mr-m__LiGyn","mb-m":"DealHighLights_mb-m__fzifp","mt-m":"DealHighLights_mt-m__pqoPm","px-m":"DealHighLights_px-m__Ij7jb","mx-m":"DealHighLights_mx-m__QMvo4","my-m":"DealHighLights_my-m__TNKac","py-m":"DealHighLights_py-m__uWoXy","font-size-m":"DealHighLights_font-size-m__pGg12","p-l":"DealHighLights_p-l__9sKJq","pl-l":"DealHighLights_pl-l__az_0_","pr-l":"DealHighLights_pr-l__totFN","pb-l":"DealHighLights_pb-l___gal3","pt-l":"DealHighLights_pt-l__SKL_4","m-l":"DealHighLights_m-l__LAfRN","ml-l":"DealHighLights_ml-l__9TitN","mr-l":"DealHighLights_mr-l__BspQX","mb-l":"DealHighLights_mb-l__g5Ka8","mt-l":"DealHighLights_mt-l__ADP0_","px-l":"DealHighLights_px-l__PXLvs","mx-l":"DealHighLights_mx-l__cKRfN","my-l":"DealHighLights_my-l__gajkc","py-l":"DealHighLights_py-l__zv83q","font-size-l":"DealHighLights_font-size-l__xk_pm","p-xl":"DealHighLights_p-xl__Cz6_f","pl-xl":"DealHighLights_pl-xl__BkFNI","pr-xl":"DealHighLights_pr-xl__mkxat","pb-xl":"DealHighLights_pb-xl__9lWzF","pt-xl":"DealHighLights_pt-xl__Rc5OQ","m-xl":"DealHighLights_m-xl__hZ_vj","ml-xl":"DealHighLights_ml-xl__Xz4Go","mr-xl":"DealHighLights_mr-xl__ItwkQ","mb-xl":"DealHighLights_mb-xl__kq6c8","mt-xl":"DealHighLights_mt-xl__IBRrT","px-xl":"DealHighLights_px-xl__A8_p_","mx-xl":"DealHighLights_mx-xl__LpfEE","my-xl":"DealHighLights_my-xl__NfH0u","py-xl":"DealHighLights_py-xl__H1tpE","font-size-xl":"DealHighLights_font-size-xl__dCRz9","p-xxl":"DealHighLights_p-xxl__ZO1qU","pl-xxl":"DealHighLights_pl-xxl__p0q_c","pr-xxl":"DealHighLights_pr-xxl__zr5gs","pb-xxl":"DealHighLights_pb-xxl__AlbjS","pt-xxl":"DealHighLights_pt-xxl__couym","m-xxl":"DealHighLights_m-xxl__1n_Z8","ml-xxl":"DealHighLights_ml-xxl__5wkGi","mr-xxl":"DealHighLights_mr-xxl__Wybxv","mb-xxl":"DealHighLights_mb-xxl__qa6Wl","mt-xxl":"DealHighLights_mt-xxl__CdCwo","px-xxl":"DealHighLights_px-xxl__64Q6N","mx-xxl":"DealHighLights_mx-xxl__ruSb7","my-xxl":"DealHighLights_my-xxl__ZqMZN","py-xxl":"DealHighLights_py-xxl__YurWw","font-size-xxl":"DealHighLights_font-size-xxl__3h7PU","overflow-hidden":"DealHighLights_overflow-hidden__vaIzm","topMargin":"DealHighLights_topMargin__pLhoO","cursor-pointer":"DealHighLights_cursor-pointer__8Dqon","collapsible-content":"DealHighLights_collapsible-content__E4cIo","collapsible-content--list-items":"DealHighLights_collapsible-content--list-items__n1ksO","collapsible-header":"DealHighLights_collapsible-header__TDJQr","collapsible-header--label":"DealHighLights_collapsible-header--label__gvEV1","color-swatch":"DealHighLights_color-swatch__CEh_x","device":"DealHighLights_device__kJ5U5","device-img":"DealHighLights_device-img__3o3MW","device-details":"DealHighLights_device-details__skr_3","device-header":"DealHighLights_device-header__dGt98","device-header--name":"DealHighLights_device-header--name__l3_DD","badge":"DealHighLights_badge__25vm8","device-image":"DealHighLights_device-image___zvY0","device-inclusion-title":"DealHighLights_device-inclusion-title__GjJy7","device-inclusion-container":"DealHighLights_device-inclusion-container__ThCyC","device-inclusion":"DealHighLights_device-inclusion__eE2ek","linear-display":"DealHighLights_linear-display__Q49RO","inclusion-separator":"DealHighLights_inclusion-separator__AUWmR","device-section":"DealHighLights_device-section__unwCU","device-title":"DealHighLights_device-title___VskM","plan-title":"DealHighLights_plan-title__ryKhu","plan-details":"DealHighLights_plan-details__IY7dv","primary-device":"DealHighLights_primary-device__2Brxk","primary-device-img":"DealHighLights_primary-device-img__lziXx","product-details":"DealHighLights_product-details__MpPa_","title":"DealHighLights_title__rKimD","toggle-indicator":"DealHighLights_toggle-indicator__khuiO","toggle-indicator--icon":"DealHighLights_toggle-indicator--icon__IK0lT","open":"DealHighLights_open__5Sa5K","deal-highlights-divider":"DealHighLights_deal-highlights-divider__A4a7p"};

/***/ }),

/***/ 81993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"device-subsection":"DeviceSubsection_device-subsection__yIfw8","device-content":"DeviceSubsection_device-content__eW_hy","device-subsection-footer":"DeviceSubsection_device-subsection-footer__Vh_vc","footer":"DeviceSubsection_footer___MLFr","footer--icon":"DeviceSubsection_footer--icon__p_95F"};

/***/ }),

/***/ 37293:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn-gradient":"ApplicationTypeSelector_btn-gradient__oB00F","pill-btn":"ApplicationTypeSelector_pill-btn___FjXP","default-gradient":"ApplicationTypeSelector_default-gradient__hL4p6","contracts-container":"ApplicationTypeSelector_contracts-container__Qx0VS","contract-box":"ApplicationTypeSelector_contract-box__5460w","contract-box--active":"ApplicationTypeSelector_contract-box--active__TrzYf","contract-box--duration":"ApplicationTypeSelector_contract-box--duration__b3yMm","contract-box--price":"ApplicationTypeSelector_contract-box--price__VT1lz","pill-btn-all":"ApplicationTypeSelector_pill-btn-all__BXHAe","PillVectorPrice_icon":"ApplicationTypeSelector_PillVectorPrice_icon__MjeLK"};

/***/ }),

/***/ 86175:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cta-txt":"CTADescription_cta-txt__XIrlZ","cta-txt-icon":"CTADescription_cta-txt-icon__oNrd4","cta-txt-info":"CTADescription_cta-txt-info__Wv_IP","cta-txt-warning":"CTADescription_cta-txt-warning___yGMT","upgrade":"CTADescription_upgrade__jv1EY","info-link":"CTADescription_info-link__fbESf"};

/***/ }),

/***/ 52506:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contract-box":"DealDurationAndPrice_contract-box__DvaQx","radio-selector":"DealDurationAndPrice_radio-selector__zrbhS","selection-placeholder":"DealDurationAndPrice_selection-placeholder__jBf9r","contract-box--active":"DealDurationAndPrice_contract-box--active__cgxz_","contract-box--duration":"DealDurationAndPrice_contract-box--duration__VQDs9","contract-box--price":"DealDurationAndPrice_contract-box--price__JFZXV","contract-box--discount":"DealDurationAndPrice_contract-box--discount__UtkEQ","contract-box--old-price":"DealDurationAndPrice_contract-box--old-price__jiaWv","contract-box--savings":"DealDurationAndPrice_contract-box--savings__OHhe0","container-group":"DealDurationAndPrice_container-group__vC3Mb","contracts-container":"DealDurationAndPrice_contracts-container__MS0ft","offer-style":"DealDurationAndPrice_offer-style__cVzJE"};

/***/ }),

/***/ 46589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addToCartBtn":"DealSpecificationControl_addToCartBtn__60XOK","disabled":"DealSpecificationControl_disabled__WNDgk","button-container":"DealSpecificationControl_button-container__8DvIN","sticky_on_mobile":"DealSpecificationControl_sticky_on_mobile__BkQdf","viewcart-btn":"DealSpecificationControl_viewcart-btn__WZIWn"};

/***/ }),

/***/ 932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"summary-wizard-container":"SummeryWizard_summary-wizard-container__Zdgov"};

/***/ }),

/***/ 5289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wizard-section-container":"WizardSection_wizard-section-container__eTCfh","section-indicators":"WizardSection_section-indicators__i_Z1S","section-step":"WizardSection_section-step__RelpW","section-sub-step":"WizardSection_section-sub-step__Xb7aC","indicator-line":"WizardSection_indicator-line__Q3Ve1","section-content":"WizardSection_section-content__6Jgg0","section-header":"WizardSection_section-header__wBYy4","subsection-header":"WizardSection_subsection-header__cwHi7","addOns":"WizardSection_addOns__UxD7Q","addOns-grey":"WizardSection_addOns-grey__AeIeJ","section-body":"WizardSection_section-body__dxQJi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1216,8005,9494,4767,284,3729,9774,2888,179], function() { return __webpack_exec__(48036); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);